const __custfyConsole = (() => {
  const C = globalThis.console;
  if (globalThis.__custfyConsole) return globalThis.__custfyConsole;
  const B =
      "background:#0f172a;color:#fff;padding:1px 6px;border-radius:4px;font-weight:600;letter-spacing:.02em",
    W =
      "background:#b45309;color:#fff;padding:1px 6px;border-radius:4px;font-weight:600;letter-spacing:.02em",
    E =
      "background:#b91c1c;color:#fff;padding:1px 6px;border-radius:4px;font-weight:600;letter-spacing:.02em",
    S = "color:#64748b;font-weight:500",
    R = "color:inherit;font-weight:400";
  const strip = (s) =>
    s
      .replace(
        /[\u2705\u26A0\uFE0F\u274C\u2192\u2714\u2716\u{1F300}-\u{1FAFF}]/gu,
        "",
      )
      .replace(/\s{2,}/g, " ")
      .trim();
  const norm = (a) => {
    a = [...a];
    let scope = "";
    if (typeof a[0] === "string") {
      let m = a[0];
      if (m.startsWith("%c") && typeof a[1] === "string") {
        m = m.replace(/%c/g, "");
        a.splice(1, 1);
      }
      const b = m.match(/^\[([^\]]+)\]\s*/);
      if (b) {
        scope = b[1];
        m = m.slice(b[0].length);
      }
      m = strip(m);
      if (m === "error") m = "failed";
      if (m === "uploadFileLarge") {
        scope = "upload";
        m = "upload attempt failed";
      }
      a[0] = m;
    }
    return {
      scope: scope.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase(),
      a,
    };
  };
  const out =
    (l) =>
    (...args) => {
      const { scope, a } = norm(args);
      C[l](
        "%cCustfy%c" + (scope ? " " + scope : "") + "%c",
        l === "error" ? E : l === "warn" ? W : B,
        S,
        R,
        ...a,
      );
    };
  const w = Object.create(C);
  for (const l of ["log", "info", "warn", "error", "debug"]) w[l] = out(l);
  w.banner = (v) =>
    C.info(
      "%cCustfy%c Personalizer %c" + v + "%c \u00b7 ready",
      "background:#0f172a;color:#fff;padding:2px 8px;border-radius:4px;font-weight:700;letter-spacing:.04em",
      R,
      "font-family:ui-monospace,SFMono-Regular,Menlo,monospace;color:#0f172a;font-weight:600",
      S,
    );
  globalThis.__custfyConsole = w;
  return w;
})();
const console = __custfyConsole;
const __vite__mapDeps = (
  i,
  m = __vite__mapDeps,
  d = m.f ||
    (m.f = [
      "./ImageUploadAIForm.js?v=1-0-2-28d679f1",
      "./modals.js?v=1-0-2-28d679f1",
      "./vendor.min.js?v=1-0-2-28d679f1",
      "./blob-polyfill.js?v=1-0-2-28d679f1",
      "./wavesurfer.js?v=1-0-2-28d679f1",
      "./ImageUploadAIGenForm.js?v=1-0-2-28d679f1",
      "./StarmapField.js?v=1-0-2-28d679f1",
      "./MapField.js?v=1-0-2-28d679f1",
      "./CalendarField.js?v=1-0-2-28d679f1",
      "./specialtyLayerUtils.js?v=1-0-2-28d679f1",
      "./ClockField.js?v=1-0-2-28d679f1",
      "./PuzzleField.js?v=1-0-2-28d679f1",
      "./TagInput.js?v=1-0-2-28d679f1",
      "./AudioField.js?v=1-0-2-28d679f1",
      "./AudioUploadForm.js?v=1-0-2-28d679f1",
      "./ClipartFrameField.js?v=1-0-2-28d679f1",
      "./WordSearchField.js?v=1-0-2-28d679f1",
      "./WaveformField.js?v=1-0-2-28d679f1",
      "./WordCloudField.js?v=1-0-2-28d679f1",
      "./BirthFlowerField.js?v=1-0-2-28d679f1",
      "./date-picker-v2.js?v=1-0-2-28d679f1",
      "./AIPromptField.js?v=1-0-2-28d679f1",
      "./CoordinateField.js?v=1-0-2-28d679f1",
      "./AlbumField.js?v=1-0-2-28d679f1",
      "./RingTextField.js?v=1-0-2-28d679f1",
      "./SpiralTextField.js?v=1-0-2-28d679f1",
      "./PackItemTabs.js?v=1-0-2-28d679f1",
      "./Preview.js?v=1-0-2-28d679f1",
      "./AppButton.js?v=1-0-2-28d679f1",
      "./ModalUpsell.js?v=1-0-2-28d679f1",
      "./PopupATC.js?v=1-0-2-28d679f1",
    ]),
) => i.map((i) => d[i]);
import {
  a7 as It,
  aS as Kr,
  d as ne,
  o as l,
  B as p,
  a5 as Xt,
  K as I,
  g as ae,
  E as le,
  L as V,
  G as v,
  i as Bt,
  a8 as Wr,
  a2 as B,
  e as w,
  h as ue,
  D as f,
  F as st,
  aT as Qt,
  aU as Hr,
  W as J,
  X as Ie,
  C as $,
  aV as Te,
  a6 as Ot,
  aW as co,
  a9 as ee,
  aX as Yr,
  aJ as Xr,
  aK as Qr,
  aY as Gr,
  aZ as Zr,
  c as Fe,
  aC as ut,
  a_ as Oe,
  a$ as vt,
  $ as Jr,
  R as io,
  b0 as Gt,
  b1 as Xe,
  U as Ue,
  a4 as xe,
  a3 as ot,
  aI as ye,
  M as _t,
  S as po,
  J as Go,
  T as xr,
  b2 as Zo,
  a1 as Jo,
  H as tt,
  z as mo,
  k as Le,
  b3 as ei,
  b4 as ti,
  w as ft,
  b5 as St,
  y as xo,
  A as wo,
  u as b,
  s as oi,
  aR as ri,
  aO as ii,
  b6 as er,
  b7 as ai,
  b8 as ni,
  b9 as si,
  ba as li,
  bb as ui,
} from "./vendor.min.js?v=1-0-2-28d679f1";
import {
  u as oe,
  a as K,
  b as Se,
  i as di,
  c as he,
  p as Zt,
  C as tr,
  d as dt,
  g as Me,
  e as or,
  f as rr,
  h as ci,
  j as pi,
  k as mi,
  l as fi,
  m as qt,
  n as ao,
  o as Lt,
  q as Tt,
  r as ko,
  s as hi,
  t as yi,
  v as bo,
  w as gi,
  x as vi,
  y as wi,
  E as rt,
  z as Jt,
  A as ki,
  B as bi,
  D as So,
  R as Co,
  _ as ge,
  F as ir,
  G as ar,
  H as Si,
  I as Pt,
  J as no,
  K as Ci,
  L as Io,
  M as _o,
  N as Po,
  O as $o,
  P as so,
  Q as Ii,
  S as _i,
  T as Pi,
  U as $i,
  V as Di,
  W as Ai,
  X as Dt,
  Y as xt,
  Z as Fi,
  $ as Ei,
  a0 as jt,
  a1 as Kt,
  a2 as Li,
  a3 as Ti,
  a4 as Do,
  a5 as Ce,
  a6 as Vi,
  a7 as Ke,
  a8 as We,
  a9 as Mi,
  aa as Ui,
  ab as Ao,
  ac as zi,
  ad as Oi,
  ae as Ni,
  af as nr,
  ag as Ri,
  ah as Bi,
  ai as qi,
  aj as Fo,
  ak as ji,
} from "./modals.js?v=1-0-2-28d679f1";
import "./blob-polyfill.js?v=1-0-2-28d679f1";
import "./wavesurfer.js?v=1-0-2-28d679f1";
(function () {
  const t = document.createElement("link").relList;
  if (t && t.supports && t.supports("modulepreload")) return;
  for (const r of document.querySelectorAll('link[rel="modulepreload"]')) i(r);
  new MutationObserver((r) => {
    for (const n of r)
      if (n.type === "childList")
        for (const a of n.addedNodes)
          a.tagName === "LINK" && a.rel === "modulepreload" && i(a);
  }).observe(document, { childList: !0, subtree: !0 });
  function o(r) {
    const n = {};
    return (
      r.integrity && (n.integrity = r.integrity),
      r.referrerPolicy && (n.referrerPolicy = r.referrerPolicy),
      r.crossOrigin === "use-credentials"
        ? (n.credentials = "include")
        : r.crossOrigin === "anonymous"
          ? (n.credentials = "omit")
          : (n.credentials = "same-origin"),
      n
    );
  }
  function i(r) {
    if (r.ep) return;
    r.ep = !0;
    const n = o(r);
    fetch(r.href, n);
  }
})();
It.extend(Kr);
const Ki = ne({
  setup() {
    return { store: oe() };
  },
  mounted() {
    if (typeof window.getCurrentProductInfo == "function") {
      const { variantId: e } = window.getCurrentProductInfo();
      (this.store.setSelectedVariant(e),
        window.addEventListener("changeVariant", () => {
          const { variantId: t } = window.getCurrentProductInfo();
          this.store.setSelectedVariant(t);
        }));
    } else this.store.setSelectedVariant("6242c404034e220009fd0ecc");
  },
});
function Wi(e, t, o, i, r, n) {
  return (l(), p("div"));
}
const sr = K(Ki, [["render", Wi]]),
  Hi = ne({
    name: "Buttons",
    props: {
      options: {
        type: Array,
        default() {
          return [];
        },
      },
      modelValue: {},
    },
    data() {
      return { val: this.modelValue };
    },
    methods: {
      isEqual: Xt,
      click(e) {
        this.$emit("update:modelValue", e);
      },
    },
  }),
  Yi = { class: "buttons-group" },
  Xi = ["onClick"];
function Qi(e, t, o, i, r, n) {
  return (
    l(),
    p("div", Yi, [
      (l(!0),
      p(
        I,
        null,
        ae(
          e.options,
          (a, u) => (
            l(),
            p(
              "div",
              {
                key: u,
                class: le({
                  btn: !0,
                  "btn-default": !0,
                  active: e.isEqual(e.modelValue, a.value),
                }),
                onClick: (d) => e.click(a.value),
              },
              V(a.label),
              11,
              Xi,
            )
          ),
        ),
        128,
      )),
    ])
  );
}
const Ve = K(Hi, [["render", Qi]]),
  Gi = ne({
    props: { title: { type: String, required: !0 }, active: { type: Boolean } },
  }),
  Zi = { class: "pb-tooltip" },
  Ji = { key: 0, class: "pb-tooltip-title" };
function xi(e, t, o, i, r, n) {
  return (
    l(),
    p("div", Zi, [
      e.active ? (l(), p("div", Ji, V(e.title), 1)) : v("", !0),
      Bt(e.$slots, "default"),
    ])
  );
}
const eo = K(Gi, [["render", xi]]),
  wt = (e, t = "") => {
    const i = new URLSearchParams(window.location.search).get(e);
    return i || t;
  },
  ea = (e) => e,
  lr = (e, t = 100, o = "px", i = !1, r = "") =>
    e ? `https://art.custfy.com/${String(e).replace(/^\/+/, "")}` : null,
  He = (e = null) =>
    (e ? `${e}_` : "") + Math.random().toString(36).substr(2, 9),
  ta = () => {
    const e = new Date(),
      t = e.getFullYear(),
      o = String(e.getMonth() + 1).padStart(2, "0"),
      i = String(e.getDate()).padStart(2, "0");
    return `${t}-${o}-${i}`;
  },
  ur = () => {
    const t = "abcdefghijklmnopqrstuvwxyz0123456789";
    let o = "";
    for (let i = 0; i < 24; i++) {
      const r = Math.floor(Math.random() * t.length);
      o += t[r];
    }
    return o + ".png";
  },
  Fd = (e, t, o, i) => e?.map((r) => (r?.slug == i && (r[o] = t), r)),
  Ed = (e, t) => {
    const o = e.some((r) => "artworkId" in r) ? e : t,
      i = o === e ? t : e;
    for (const r of o)
      if (
        (r.options || r).every(
          (u) => u.value === i.find((d) => d.name === u.name)?.value,
        )
      )
        return r.artworkId;
    return null;
  },
  Eo = (e, t) => {
    const o = Date.now(),
      i = t * 60 * 60 * 1e3;
    for (let r = 0; r < window.localStorage.length; r++) {
      const n = window.localStorage.key(r);
      if (!n?.includes(e)) continue;
      const a = window.localStorage.getItem(n);
      if (!a) return;
      try {
        const u = Wr.parse(a);
        u.timestamp && o - u.timestamp > i && window.localStorage.removeItem(n);
      } catch {
        console.warn(`Failed to parse persisted custom data for key: ${n}`);
      }
    }
  },
  oa = () => {
    try {
      const e = "__storage_test__";
      return (
        window.localStorage.setItem(
          e,
          new Array((1024 * 1024 * 1) / 2).join("a"),
        ),
        window.localStorage.removeItem(e),
        !1
      );
    } catch (e) {
      return (
        e instanceof DOMException &&
        (e.name === "QuotaExceededError" || e.name === "QUOTA_EXCEEDED_ERR") &&
        window.localStorage.length !== 0
      );
    }
  },
  ra = ne({
    name: "Color",
    components: { Tooltip: eo },
    props: {
      value: { type: String },
      options: { type: Array, default: () => [] },
    },
    emits: ["update:value"],
    setup() {
      return { store: oe() };
    },
    computed: {
      colors() {
        const { variants: e } = this.store;
        return e.map((t) => t.color);
      },
      displayMode() {
        const { storeSettings: e } = this.store;
        return B(e, "displayMode.enableColor", !1)
          ? B(e, "displayMode.swatchShape", "square")
          : B(e, "displayMode.optionStyle");
      },
      colorClassMap() {
        const e = {};
        return (
          this.colors?.forEach((t) => {
            const o = t.name,
              i = t.name?.replaceAll(" ", "-")?.toLowerCase() + "-swatch";
            o && (e[o] = i);
          }),
          e
        );
      },
    },
    methods: {
      style(e) {
        const { colors: t, displayMode: o } = this,
          { storeSettings: i } = this.store,
          r = B(i, "displayMode.size", 40),
          n = B(i, "displayMode.usingColorImagePattern", !1),
          a = {
            backgroundColor: `${B(
              t.find((u) => u.name === e),
              "code",
            )}`,
            width: `${r}px`,
            height: `${r}px`,
            borderRadius: "3px",
          };
        if ((o === "circle" && (a.borderRadius = "50%"), n)) {
          const u = B(
            t.find((d) => d === e),
            "pattern",
          );
          u &&
            ((a.backgroundImage = `url(${lr(u.key, 100)})`),
            (a.backgroundSize = "cover"));
        }
        return a;
      },
      classNameColor(e) {
        return this.colorClassMap[e] || "";
      },
      click(e) {
        this.$emit("update:value", e);
      },
    },
  }),
  ia = { key: 0, class: "pb-color-swatchs", style: { flex: "0 0 100%" } },
  aa = ["onClick"];
function na(e, t, o, i, r, n) {
  const a = eo;
  return e.displayMode === "square" || e.displayMode === "circle"
    ? (l(),
      p("div", ia, [
        (l(!0),
        p(
          I,
          null,
          ae(
            e.options,
            (u) => (
              l(),
              w(
                a,
                { key: u, title: u, active: u },
                {
                  default: ue(() => [
                    f(
                      "div",
                      {
                        style: st(e.style(u)),
                        onClick: (d) => e.click(u),
                        class: le([
                          { item: !0, active: u === e.value },
                          e.classNameColor(u),
                        ]),
                      },
                      null,
                      14,
                      aa,
                    ),
                  ]),
                  _: 2,
                },
                1032,
                ["title", "active"],
              )
            ),
          ),
          128,
        )),
      ]))
    : v("", !0);
}
const At = K(ra, [["render", na]]),
  sa = ne({
    setup() {
      const e = oe(),
        { product: t } = e;
      return { store: e, product: t };
    },
    data() {
      return {
        selectedVariant: null,
        attributes: [
          { id: "", name: "", option: "" },
          { id: "", name: "", option: "" },
          { id: "", name: "", option: "" },
        ],
      };
    },
    computed: {
      hideOne() {
        const { storeSettings: e } = this.store;
        return B(e, "displayMode.hiddenAttribute", !1);
      },
      validVariants() {
        const { product: e, variants: t } = this.store,
          o = B(e, "variants", []),
          i = t.map((r) => r.origin_id);
        return o.filter((r) => i.includes(r.id.toString()));
      },
      optionStyle() {
        const { storeSettings: e } = this.store;
        return B(e, "displayMode.optionStyle", "Dropdown");
      },
    },
    methods: {
      price(e) {
        return (window.money_format || "${{amount}}").replace(/{{.*}}/, e);
      },
      isColor(e) {
        const { storeSettings: t } = this.store;
        return (
          e.name.toLowerCase() === "color" &&
          B(t, "displayMode.enableColor", !1)
        );
      },
      getOptions(e) {
        const { validVariants: t, attributes: o } = this,
          { product: i } = this.store,
          r = [];
        for (let u = e - 1; u >= 0; u--) r.push(o[u]);
        const n = Qt(
            t
              .filter((u) => Hr(r, u.attributes, Xt).length === 0)
              .map((u) => u.attributes[e].option),
          ),
          a = B(i, `attributes[${e}].options`, []).filter((u) => n.includes(u));
        if (!a.includes(o[e].option)) {
          const u = wt(`attribute_${o[e].name.toLowerCase()}`);
          a.includes(u)
            ? (this.attributes[e].option = u || "")
            : (this.attributes[e].option = a[0]);
        }
        return a;
      },
    },
  }),
  la = { key: 0, class: "product__price", "aria-live": "polite" },
  ua = { class: "price__pricing-group" },
  da = ["innerHTML"],
  ca = { key: 0, class: "price__regular" },
  pa = ["innerHTML"],
  ma = { key: 1, class: "product-attributes", ref: "productAttributes" },
  fa = ["for"],
  ha = ["for"],
  ya = ["id", "onUpdate:modelValue"],
  ga = ["value"];
function va(e, t, o, i, r, n) {
  const a = At,
    u = Ve;
  return (
    l(),
    p("div", null, [
      e.selectedVariant
        ? (l(),
          p("div", la, [
            f("div", ua, [
              f(
                "div",
                {
                  class: "price__sale",
                  innerHTML: e.price(
                    e.selectedVariant.sale_price || e.selectedVariant.price,
                  ),
                },
                null,
                8,
                da,
              ),
              e.selectedVariant.regular_price &&
              parseFloat(e.selectedVariant.regular_price) >
                parseFloat(
                  e.selectedVariant.sale_price || e.selectedVariant.price,
                )
                ? (l(),
                  p("div", ca, [
                    f(
                      "del",
                      { innerHTML: e.price(e.selectedVariant.regular_price) },
                      null,
                      8,
                      pa,
                    ),
                  ]))
                : v("", !0),
            ]),
          ]))
        : v("", !0),
      e.product
        ? (l(),
          p(
            "div",
            ma,
            [
              (l(!0),
              p(
                I,
                null,
                ae(
                  e.product.attributes,
                  (d, s) => (
                    l(),
                    p(
                      I,
                      null,
                      [
                        e.isColor(d)
                          ? J(
                              (l(),
                              p(
                                "div",
                                {
                                  key: `option-${s}`,
                                  class: "product-form__item",
                                  style: { flex: "0 0 100%" },
                                },
                                [
                                  f(
                                    "label",
                                    { for: `product-option-${d.id}` },
                                    V(d.name),
                                    9,
                                    fa,
                                  ),
                                  $(
                                    a,
                                    {
                                      modelValue: e.attributes[s].option,
                                      "onUpdate:modelValue": (c) =>
                                        (e.attributes[s].option = c),
                                      options: e.getOptions(s),
                                    },
                                    null,
                                    8,
                                    [
                                      "modelValue",
                                      "onUpdate:modelValue",
                                      "options",
                                    ],
                                  ),
                                ],
                              )),
                              [[Ie, !(e.hideOne && d.options.length <= 1)]],
                            )
                          : J(
                              (l(),
                              p(
                                "div",
                                {
                                  class: le({
                                    "product-form__item": !0,
                                    [`pb_${e.optionStyle.toLowerCase()}`]: !0,
                                  }),
                                  key: d + s,
                                },
                                [
                                  f(
                                    "label",
                                    { for: `product-option-${d.id}` },
                                    V(d.name),
                                    9,
                                    ha,
                                  ),
                                  e.optionStyle === "Dropdown"
                                    ? (l(),
                                      p(
                                        I,
                                        { key: 0 },
                                        [
                                          e.attributes[s]
                                            ? J(
                                                (l(),
                                                p(
                                                  "select",
                                                  {
                                                    key: 0,
                                                    id: `product-option-${d.name}`,
                                                    class: "form-select",
                                                    "onUpdate:modelValue": (
                                                      c,
                                                    ) =>
                                                      (e.attributes[s].option =
                                                        c),
                                                  },
                                                  [
                                                    (l(!0),
                                                    p(
                                                      I,
                                                      null,
                                                      ae(
                                                        e.getOptions(s),
                                                        (c) => (
                                                          l(),
                                                          p(
                                                            "option",
                                                            {
                                                              key: c,
                                                              value: c,
                                                            },
                                                            V(c),
                                                            9,
                                                            ga,
                                                          )
                                                        ),
                                                      ),
                                                      128,
                                                    )),
                                                  ],
                                                  8,
                                                  ya,
                                                )),
                                                [[Te, e.attributes[s].option]],
                                              )
                                            : v("", !0),
                                        ],
                                        64,
                                      ))
                                    : (l(),
                                      w(
                                        u,
                                        {
                                          key: 1,
                                          modelValue: e.attributes[s].option,
                                          "onUpdate:modelValue": (c) =>
                                            (e.attributes[s].option = c),
                                          options: e
                                            .getOptions(s)
                                            .map((c) => ({
                                              value: c,
                                              label: c,
                                            })),
                                        },
                                        null,
                                        8,
                                        [
                                          "modelValue",
                                          "onUpdate:modelValue",
                                          "options",
                                        ],
                                      )),
                                ],
                                2,
                              )),
                              [[Ie, !(e.hideOne && d.options.length <= 1)]],
                            ),
                      ],
                      64,
                    )
                  ),
                ),
                256,
              )),
            ],
            512,
          ))
        : v("", !0),
    ])
  );
}
const dr = K(sa, [["render", va]]),
  wa = ne({
    components: { Color: At, Buttons: Ve },
    data() {
      return {
        selectedVariant: null,
        attributes: { option1: "", option2: "", option3: "" },
      };
    },
    setup() {
      const e = oe(),
        { product: t } = e;
      return { store: e, product: t };
    },
    mounted() {
      const e = wt("variant");
      if (e) {
        const { product: t } = this.store,
          { variants: o = [] } = t,
          i = o.find((r) => r.id.toString() === e.toString());
        i &&
          ((this.selectedVariant = i),
          (this.attributes = Ot(i, ["option1", "option2", "option3"])));
      }
    },
    computed: {
      hideOne() {
        const { storeSettings: e } = this.store;
        return B(e, "displayMode.hiddenAttribute", !1);
      },
      validVariants() {
        const { product: e, variants: t } = this.store,
          o = B(e, "variants", []),
          i = t.map((r) => r.origin_id);
        return o.filter((r) => i.includes(r.id));
      },
      optionStyle() {
        const { storeSettings: e } = this.store;
        return B(e, "displayMode.optionStyle", "Dropdown");
      },
    },
    methods: {
      isColor(e) {
        const { storeSettings: t } = this.store;
        return (
          e.name.toLowerCase() === "color" &&
          B(t, "displayMode.enableColor", !1)
        );
      },
      getOptions(e) {
        const { validVariants: t, attributes: o } = this,
          { product: i } = this.store,
          r = {};
        for (let u = e - 1; u > 0; u--) {
          const d = `option${u}`;
          r[d] = o[d];
        }
        const n = Qt(
            t
              .filter((u) => {
                let d = !0;
                return (
                  co(r, (s, c) => {
                    u[c] !== s && (d = !1);
                  }),
                  d
                );
              })
              .map((u) => u[`option${e}`]),
          ),
          a = B(i, `options[${e - 1}].values`, []).filter((u) => n.includes(u));
        return (
          a.length &&
            !a.includes(o[`option${e}`]) &&
            (this.attributes = { ...o, [`option${e}`]: a[0] }),
          console.log("color", a),
          a
        );
      },
    },
  }),
  ka = { key: 0, class: "product-attributes", ref: "productAttributes" },
  ba = ["for"],
  Sa = ["for"],
  Ca = ["id", "onUpdate:modelValue"],
  Ia = ["value"];
function _a(e, t, o, i, r, n) {
  const a = At,
    u = Ve;
  return e.product
    ? (l(),
      p(
        "div",
        ka,
        [
          (l(!0),
          p(
            I,
            null,
            ae(
              e.product.options,
              (d, s) => (
                l(),
                p(
                  I,
                  null,
                  [
                    e.isColor(d)
                      ? J(
                          (l(),
                          p(
                            "div",
                            {
                              key: d.id,
                              class: "product-form__item",
                              style: { flex: "0 0 100%" },
                            },
                            [
                              f(
                                "label",
                                { for: `product-option-${d.id}` },
                                V(d.name),
                                9,
                                ba,
                              ),
                              $(
                                a,
                                {
                                  options: e.getOptions(s + 1),
                                  id: `product-option-${d.id}`,
                                  modelValue: e.attributes[`option${s + 1}`],
                                  "onUpdate:modelValue": (c) =>
                                    (e.attributes[`option${s + 1}`] = c),
                                },
                                null,
                                8,
                                [
                                  "options",
                                  "id",
                                  "modelValue",
                                  "onUpdate:modelValue",
                                ],
                              ),
                            ],
                          )),
                          [[Ie, !(e.hideOne && d.values.length <= 1)]],
                        )
                      : J(
                          (l(),
                          p(
                            "div",
                            {
                              key: d.id + s,
                              class: le({
                                "product-form__item": !0,
                                [`pb_${e.optionStyle.toLowerCase()}`]: !0,
                              }),
                            },
                            [
                              f(
                                "label",
                                { for: `product-option-${d.id}` },
                                V(d.name),
                                9,
                                Sa,
                              ),
                              e.optionStyle === "Dropdown"
                                ? J(
                                    (l(),
                                    p(
                                      "select",
                                      {
                                        key: 0,
                                        id: `product-option-${d.id}`,
                                        class: "form-select",
                                        "onUpdate:modelValue": (c) =>
                                          (e.attributes[`option${s + 1}`] = c),
                                      },
                                      [
                                        (l(!0),
                                        p(
                                          I,
                                          null,
                                          ae(
                                            e.getOptions(s + 1),
                                            (c) => (
                                              l(),
                                              p(
                                                "option",
                                                { key: c, value: c },
                                                V(c),
                                                9,
                                                Ia,
                                              )
                                            ),
                                          ),
                                          128,
                                        )),
                                      ],
                                      8,
                                      Ca,
                                    )),
                                    [[Te, e.attributes[`option${s + 1}`]]],
                                  )
                                : (l(),
                                  w(
                                    u,
                                    {
                                      key: 1,
                                      modelValue:
                                        e.attributes[`option${s + 1}`],
                                      "onUpdate:modelValue": (c) =>
                                        (e.attributes[`option${s + 1}`] = c),
                                      options: e
                                        .getOptions(s + 1)
                                        .map((c) => ({ value: c, label: c })),
                                    },
                                    null,
                                    8,
                                    [
                                      "modelValue",
                                      "onUpdate:modelValue",
                                      "options",
                                    ],
                                  )),
                            ],
                            2,
                          )),
                          [[Ie, !(e.hideOne && d.values.length <= 1)]],
                        ),
                  ],
                  64,
                )
              ),
            ),
            256,
          )),
        ],
        512,
      ))
    : v("", !0);
}
const cr = K(wa, [["render", _a]]),
  Pa = ne({
    name: "Shopify",
    components: { Color: At, Buttons: Ve },
    data() {
      return {
        variant: null,
        attributes: { option1: null, option2: null, option3: null },
      };
    },
    setup() {
      const e = Se(),
        { isEditDesign: t, isDesignTrackOrder: o } = ee(e),
        i = oe(),
        { selectedVariant: r } = ee(i);
      return {
        store: i,
        isEditDesign: t,
        isDesignTrackOrder: o,
        selectedVariant: r,
      };
    },
    created() {
      let e = null;
      if (
        (this.isEditDesign
          ? (e =
              document.querySelector(".edit-design-cart-variant")?.value ||
              null)
          : (e = wt("variant")),
        e)
      ) {
        const { variants: t = [] } = this.store.product,
          o = t.find((i) => i.id.toString() == (+e).toString());
        o &&
          ((this.variant = o),
          (this.attributes = Ot(o, ["option1", "option2", "option3"])));
      }
    },
    mounted() {
      if (this.variant) return;
      const e = document.querySelector("[name=id]")?.value;
      if (e) {
        const { variants: t = [] } = this.store.product,
          o = t.find((i) => i.id.toString() == (+e).toString());
        o &&
          ((this.variant = o),
          (this.attributes = Ot(o, ["option1", "option2", "option3"])));
      }
    },
    computed: {
      hideOne() {
        const { storeSettings: e } = this.store;
        return B(e, "displayMode.hiddenAttribute", !1);
      },
      optionStyle() {
        const { storeSettings: e } = this.store;
        return B(e, "displayMode.optionStyle", "Dropdown");
      },
      validVariants() {
        const { product: e, variants: t } = this.store,
          o = B(e, "variants", []),
          i = t.map((r) => r.origin_id);
        return o.filter((r) => i.includes(`${r.id}`));
      },
      showAttribute() {
        return (
          !this.isEditDesign ||
          (this.isEditDesign && this.store.product.variants.length > 1)
        );
      },
    },
    methods: {
      getOptions(e) {
        const { validVariants: t, attributes: o } = this,
          { product: i } = this.store,
          r = {};
        for (let u = e - 1; u > 0; u--) {
          const d = `option${u}`;
          r[d] = this.attributes[d];
        }
        const n = Qt(
            t
              .filter((u) => {
                let d = !0;
                return (
                  co(r, (s, c) => {
                    u[c] !== s && (d = !1);
                  }),
                  d
                );
              })
              .map((u) => u[`option${e}`]),
          ),
          a = B(i, `options[${e - 1}].values`, []).filter((u) => n.includes(u));
        return (
          a.includes(o[`option${e}`]) ||
            (this.attributes = { ...o, [`option${e}`]: a[0] }),
          a
        );
      },
      isColor(e) {
        const { storeSettings: t } = this.store;
        return (
          e.name.toLowerCase() === "color" &&
          B(t, "displayMode.enableColor", !1)
        );
      },
      getSectionHTML(e, t) {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t);
      },
    },
    watch: {
      async variant(e) {
        if (e) {
          this.store.setSelectedVariant(e.id);
          const t = document.querySelector("[name=id]");
          if ((t && (t.value = e.id), !this.isEditDesign))
            window.history.pushState(
              {},
              "",
              `${window.location.pathname}?variant=${e.id}`,
            );
          else
            try {
              const o = document
                .querySelector(".slug-product")
                ?.getAttribute("data-handle");
              if (o) {
                const r = await (
                    await fetch(
                      `${window.Shopify?.routes?.root}products/${o}?variant=${e.id}`,
                      {
                        method: "GET",
                        headers: {
                          "X-Requested-With": "XMLHttpRequest",
                          "Content-Type": "application/json",
                        },
                      },
                    )
                  ).text(),
                  n = this.getSectionHTML(r, ".price.price--large");
                n &&
                  document.querySelector(".price.price--large") &&
                  (document.querySelector(".price.price--large").innerHTML =
                    n.innerHTML);
              }
            } catch (o) {
              console.warn("Failed to fetch variant price:", o);
            }
          document.dispatchEvent(new Event("sdkExecuted"));
        }
      },
      attributes: {
        handler(e) {
          const { validVariants: t } = this,
            o = {};
          (this.store.product.options.forEach((i, r) => {
            Object.assign(o, { [i.name]: e[`option${r + 1}`] });
          }),
            (this.variant = t.find((i) => {
              let r = !0;
              return (
                co(e, (n, a) => {
                  i[a] !== n && (r = !1);
                }),
                r
              );
            })));
        },
        deep: !0,
      },
      selectedVariant(e) {
        if (!e || e == B(this.variant, "id")) return;
        const { variants: t = [] } = this.store.product,
          o = t.find((i) => i.id == e);
        o &&
          ((this.variant = o),
          (this.attributes = Ot(o, ["option1", "option2", "option3"])));
      },
    },
  }),
  $a = { class: "price price--large" },
  Da = { key: 0, class: "product-attributes", ref: "productAttributes" },
  Aa = { key: 0, class: "product-form__item", style: { flex: "0 0 100%" } },
  Fa = ["for"],
  Ea = ["for"],
  La = ["id", "onUpdate:modelValue"],
  Ta = ["value"];
function Va(e, t, o, i, r, n) {
  const a = At,
    u = Ve;
  return (
    l(),
    p(
      I,
      null,
      [
        J(f("div", $a, null, 512), [[Ie, !e.isDesignTrackOrder]]),
        e.store.product
          ? J(
              (l(),
              p(
                "div",
                Da,
                [
                  e.showAttribute
                    ? (l(!0),
                      p(
                        I,
                        { key: 0 },
                        ae(
                          e.store.product.options,
                          (d, s) => (
                            l(),
                            p(
                              I,
                              { key: d.id + s },
                              [
                                e.isColor(d)
                                  ? J(
                                      (l(),
                                      p(
                                        "div",
                                        Aa,
                                        [
                                          f(
                                            "label",
                                            { for: `product-option-${d.id}` },
                                            V(d.name),
                                            9,
                                            Fa,
                                          ),
                                          $(
                                            a,
                                            {
                                              options: e.getOptions(s + 1),
                                              id: `product-option-${d.id}`,
                                              value:
                                                e.attributes[`option${s + 1}`],
                                              "onUpdate:value": (c) =>
                                                (e.attributes[
                                                  `option${s + 1}`
                                                ] = c),
                                            },
                                            null,
                                            8,
                                            [
                                              "options",
                                              "id",
                                              "value",
                                              "onUpdate:value",
                                            ],
                                          ),
                                        ],
                                        512,
                                      )),
                                      [
                                        [
                                          Ie,
                                          !(e.hideOne && d.values.length <= 1),
                                        ],
                                      ],
                                    )
                                  : J(
                                      (l(),
                                      p(
                                        "div",
                                        {
                                          key: 1,
                                          class: le({
                                            "product-form__item": !0,
                                            [`pb_${e.optionStyle.toLowerCase()}`]:
                                              !0,
                                          }),
                                        },
                                        [
                                          f(
                                            "label",
                                            { for: `product-option-${d.id}` },
                                            V(d.name),
                                            9,
                                            Ea,
                                          ),
                                          e.optionStyle === "Dropdown"
                                            ? J(
                                                (l(),
                                                p(
                                                  "select",
                                                  {
                                                    key: 0,
                                                    id: `product-option-${d.id}`,
                                                    class: "form-select",
                                                    "onUpdate:modelValue": (
                                                      c,
                                                    ) =>
                                                      (e.attributes[
                                                        `option${s + 1}`
                                                      ] = c),
                                                  },
                                                  [
                                                    (l(!0),
                                                    p(
                                                      I,
                                                      null,
                                                      ae(
                                                        e.getOptions(s + 1),
                                                        (c) => (
                                                          l(),
                                                          p(
                                                            "option",
                                                            {
                                                              key: c,
                                                              value: c,
                                                            },
                                                            V(c),
                                                            9,
                                                            Ta,
                                                          )
                                                        ),
                                                      ),
                                                      128,
                                                    )),
                                                  ],
                                                  8,
                                                  La,
                                                )),
                                                [
                                                  [
                                                    Te,
                                                    e.attributes[
                                                      `option${s + 1}`
                                                    ],
                                                  ],
                                                ],
                                              )
                                            : (l(),
                                              w(
                                                u,
                                                {
                                                  key: 1,
                                                  modelValue:
                                                    e.attributes[
                                                      `option${s + 1}`
                                                    ],
                                                  "onUpdate:modelValue": (c) =>
                                                    (e.attributes[
                                                      `option${s + 1}`
                                                    ] = c),
                                                  options: e
                                                    .getOptions(s + 1)
                                                    .map((c) => ({
                                                      value: c,
                                                      label: c,
                                                    })),
                                                },
                                                null,
                                                8,
                                                [
                                                  "modelValue",
                                                  "onUpdate:modelValue",
                                                  "options",
                                                ],
                                              )),
                                        ],
                                        2,
                                      )),
                                      [
                                        [
                                          Ie,
                                          !(e.hideOne && d.values.length <= 1),
                                        ],
                                      ],
                                    ),
                              ],
                              64,
                            )
                          ),
                        ),
                        128,
                      ))
                    : v("", !0),
                ],
                512,
              )),
              [[Ie, !e.isDesignTrackOrder]],
            )
          : v("", !0),
      ],
      64,
    )
  );
}
const pr = K(Pa, [["render", Va]]),
  Ma = ne({
    name: "ShopifyProduction",
    data() {
      return { observer: null };
    },
    setup() {
      const e = oe(),
        { variants: t } = ee(e);
      return { variants: t, store: e };
    },
    mounted() {
      let e = "";
      this.observer = new MutationObserver(() => {
        if (window.location.href !== e) {
          e = window.location.href;
          let o,
            i = wt("variant");
          (i
            ? (o = this.variants.find((r) => r.origin_id == i))
            : ((i = document.querySelector("product-form [name=id]")?.value),
              (o = this.variants.find((r) => r.origin_id == i))),
            o && this.store.setSelectedVariant(o.origin_id));
        }
      });
      const t = { subtree: !0, childList: !0 };
      this.observer.observe(document, t);
    },
    beforeUnmount() {
      this.observer && this.observer.disconnect();
    },
  });
function Ua(e, t, o, i, r, n) {
  return (l(), p("div"));
}
const mr = K(Ma, [["render", Ua]]),
  za = ne({
    components: {
      Shopify: pr,
      ShopifyProduction: mr,
      ShopBase: cr,
      ShopWoo: dr,
      LatteHub: sr,
    },
    setup() {
      const e = Se(),
        t = oe(),
        { platform: o, isEditDesign: i } = ee(e),
        { variants: r } = ee(t);
      return {
        store: e,
        variants: r,
        platform: o,
        isProdMode: di,
        isEditDesign: i,
      };
    },
    computed: {
      hasVariants() {
        return this.variants?.length > 0;
      },
    },
  });
function Oa(e, t, o, i, r, n) {
  const a = mr,
    u = pr,
    d = cr,
    s = dr,
    c = sr;
  return e.hasVariants
    ? (l(),
      p(
        I,
        { key: 0 },
        [
          e.platform === "shopify" && e.isProdMode() && !e.isEditDesign
            ? (l(), w(a, { key: 0 }))
            : e.platform === "shopify"
              ? (l(), w(u, { key: 1 }))
              : e.platform === "shopbase"
                ? (l(), w(d, { key: 2 }))
                : e.platform === "woocommerce"
                  ? (l(), w(s, { key: 3 }))
                  : e.platform === "lattehub"
                    ? (l(), w(c, { key: 4 }))
                    : v("", !0),
        ],
        64,
      ))
    : v("", !0);
}
const Na = K(za, [["render", Oa]]),
  Ra = ne({
    name: "option-pack",
    data() {
      return {
        packs: [
          {
            id: "pack-single-1",
            value: 1,
            title: "Single",
            subtitle: "Standard price",
            price: "€23.90 EUR",
            artwork: "packOne",
            isPopular: !1,
            currentPrice: 0,
            discount: 0,
          },
          {
            id: "pack-single-2",
            value: 2,
            title: "2 Pieces",
            subtitle: "Standard price",
            price: "€47.80 EUR",
            artwork: "packTwo",
            isPopular: !0,
            currentPrice: 0,
            discount: 10,
          },
          {
            id: "pack-single-3",
            value: 3,
            title: "3 Pieces",
            subtitle: "Standard price",
            price: "€71.69 EUR",
            artwork: "packThree",
            isPopular: !1,
            currentPrice: 0,
            discount: 15,
          },
          {
            id: "pack-single-5",
            value: 5,
            title: "5 Pieces",
            subtitle: "Standard price",
            price: "€119.49 EUR",
            artwork: "packFive",
            isPopular: !1,
            currentPrice: 0,
            discount: 20,
          },
        ],
      };
    },
    setup() {
      return { store: oe() };
    },
    mounted() {
      const { selectedVariant: e } = this.store;
      this.handlePrice(e);
      const t = document.querySelector(
          ".product-form__input.product-form__quantity",
        ),
        o = document.querySelector(".btn-preview"),
        i = document.querySelector("#btn-preview-desktop");
      t &&
        o &&
        i &&
        (t.classList.add("hide-preview"),
        o.classList.add("hide-preview"),
        i.classList.add("hide-preview"));
    },
    methods: {
      sendArtwork(e) {
        const { packs: t } = this,
          { selectedVariant: o, settings: i } = this.store;
        if (i?.settingsPack?.length == 0) return;
        const r = t?.find((d) => d.artwork === e)?.value,
          n = document.querySelector(
            ".price-per-item__container quantity-input input.quantity__input",
          );
        n && r !== void 0 && (n.value = r);
        const u = i.settingsPack
          ?.find((d) => d.pack === e)
          ?.options?.find((d) => d.variantID == o);
        u?.artworkID &&
          Yr()("send-artwork", { artworkID: u.artworkID, pack: e });
      },
      defaultOption(e, t) {
        return typeof e > "u" ? t : e;
      },
      formatWithDelimiters(e, t, o, i) {
        const { defaultOption: r } = this;
        if (
          ((t = r(t, 2)),
          (o = r(o, ",")),
          (i = r(i, ".")),
          isNaN(e) || e == null)
        )
          return 0;
        e = (e / 100).toFixed(t);
        const n = e.split("."),
          a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o),
          u = n[1] ? i + n[1] : "";
        return a + u;
      },
      handlePrice(e) {
        const { formatWithDelimiters: t } = this,
          { product: o } = this.store,
          i = /\{\{\s*(\w+)\s*\}\}/,
          r = (o?.variants).find((n) => n.id == e);
        r &&
          (this.packs = this.packs?.map((n) => {
            const a =
                window.Shopify.currency_settings.money_with_currency_format ||
                "${{amount_with_comma_separator}} USD",
              u =
                n.discount == 0
                  ? parseFloat(r.price) * n.value
                  : parseFloat(r.price) * n.value * (1 - n.discount / 100),
              d =
                n.discount == 0
                  ? parseFloat(r.compare_at_price) * n.value
                  : parseFloat(r?.compare_at_price) *
                    n.value *
                    (1 - n.discount / 100),
              s = t(u, 2, ".", ","),
              c = t(d, 2, ".", ",");
            return {
              ...n,
              price: a.replace(i, s),
              currentPrice: r?.compare_at_price ? a.replace(i, c) : 0,
            };
          }));
      },
    },
    watch: {
      selectedVariant(e) {
        this.handlePrice(e);
      },
    },
  }),
  Ba = { class: "template-pack-product" },
  qa = { class: "form-pack" },
  ja = ["id", "value", "checked"],
  Ka = ["for", "onClick"],
  Wa = { class: "lable-pack" },
  Ha = { class: "pack-content" },
  Ya = { class: "pack-content-title" },
  Xa = { class: "pack-content-sub" },
  Qa = { class: "pack-price" },
  Ga = { class: "pack-price-sale" },
  Za = { class: "price-item price-item--sale price-item--last money" },
  Ja = { key: 0, class: "pack-price-current" },
  xa = { key: 0, class: "popup-sale" };
function en(e, t, o, i, r, n) {
  return (
    l(),
    p("div", Ba, [
      t[1] ||
        (t[1] = f("p", { class: "title-pack" }, "Buy More Save More", -1)),
      f("div", qa, [
        (l(!0),
        p(
          I,
          null,
          ae(
            e.packs,
            (a, u) => (
              l(),
              p("div", { key: a.id, class: "pack-item" }, [
                f(
                  "input",
                  {
                    type: "radio",
                    id: a.id,
                    name: "product-item-pack",
                    value: a.value,
                    checked: u === 1,
                  },
                  null,
                  8,
                  ja,
                ),
                f(
                  "label",
                  { for: a.id, onClick: (d) => e.sendArtwork(a.artwork) },
                  [
                    f("div", Wa, [
                      t[0] ||
                        (t[0] = f("div", { class: "pack-icon" }, null, -1)),
                      f("div", Ha, [
                        f("p", Ya, V(a.title), 1),
                        f(
                          "p",
                          Xa,
                          V(
                            a.discount != 0
                              ? `You save ${a.discount}%`
                              : a.subtitle,
                          ),
                          1,
                        ),
                      ]),
                      f("div", Qa, [
                        f("p", Ga, [f("span", Za, V(a.price), 1)]),
                        a.currentPrice != 0
                          ? (l(), p("p", Ja, V(a.currentPrice), 1))
                          : v("", !0),
                      ]),
                    ]),
                    a.isPopular
                      ? (l(), p("div", xa, " MOST POPULAR "))
                      : v("", !0),
                  ],
                  8,
                  Ka,
                ),
              ])
            ),
          ),
          128,
        )),
      ]),
    ])
  );
}
const tn = K(Ra, [["render", en]]),
  on = ne({
    name: "preview-top-drawer",
    props: { show: { type: Boolean } },
    data() {
      return {
        forceClose: !1,
        isDrawerVisible: !1,
        zoom: 1,
        observer: null,
        previewBtnObserver: null,
        isPreviewBtnScrolledPast: !1,
        previewImage: "",
        updatePreviewThrottle: null,
        isDragging: !1,
        translateX: 0,
        translateY: 0,
        dragStartX: 0,
        dragStartY: 0,
        initialTranslateX: 0,
        initialTranslateY: 0,
      };
    },
    setup() {
      const e = Se(),
        t = he(),
        o = oe(),
        { loadings: i } = ee(e),
        r = Fe(() => o.settings),
        n = Fe(() => !!r.value?.isPackMode),
        a = Fe(() => {
          if (!n.value) return 1;
          const s = r.value?.packAttribute;
          if (!s || !o.variantInfo?.option) return 1;
          const c = o.variantInfo.option.find((m) => m.name === s);
          if (!c) return 1;
          const h = r.value?.packQuantities?.[c.value];
          return typeof h == "number" && h > 0 ? h : 1;
        }),
        u = Fe(() => t.activePackIndex),
        d = Fe(() => o.product?.product_type || o.product?.type || "Item");
      return {
        loadings: i,
        formStore: t,
        isPackMode: n,
        packQuantity: a,
        activePackIndex: u,
        packItemLabel: d,
      };
    },
    computed: {
      isLoading() {
        return Xr(this.loadings).some((e) => Qr(e).some((t) => t === !0));
      },
      imageTransformStyle() {
        return this.zoom > 1
          ? {
              transformOrigin: "0px 0px",
              transform: `translate(${this.translateX}px, ${this.translateY}px) scale(${this.zoom})`,
              transition: this.isDragging ? "none" : "transform 0.2s ease",
            }
          : {
              transform: `scale(${this.zoom})`,
              transition: "transform 0.2s ease",
            };
      },
      isDrawerShown() {
        return (
          this.isDrawerVisible &&
          this.show &&
          !this.forceClose &&
          !this.isPreviewBtnScrolledPast
        );
      },
    },
    watch: {
      isDrawerShown: {
        handler(e) {
          document.documentElement.style.setProperty(
            "--mc-drawer-height",
            e ? "260px" : "0px",
          );
        },
        immediate: !0,
      },
      zoom(e) {
        if (e <= 1) ((this.translateX = 0), (this.translateY = 0));
        else {
          const o = this.$refs.previewImgContainer.parentElement;
          if (!o) return;
          const i = o.getBoundingClientRect();
          ((this.translateX = (i.width - i.width * e) / 2),
            (this.translateY = (i.height - i.height * e) / 2));
        }
      },
    },
    mounted() {
      (this.createObserver(),
        this.createPreviewBtnObserver(),
        (this.updatePreviewThrottle = Gr(this.updatePreview, 500)),
        this.$emitter.on("canvas-after-render", this.updatePreviewThrottle),
        document.addEventListener("mousemove", this.handleDragMove),
        document.addEventListener("mouseup", this.handleDragEnd),
        document.addEventListener("touchmove", this.handleDragMove, {
          passive: !1,
        }),
        document.addEventListener("touchend", this.handleDragEnd));
    },
    beforeUnmount() {
      (this.observer && this.observer.disconnect(),
        this.previewBtnObserver && this.previewBtnObserver.disconnect(),
        this.$emitter.off("canvas-after-render", this.updatePreviewThrottle),
        document.removeEventListener("mousemove", this.handleDragMove),
        document.removeEventListener("mouseup", this.handleDragEnd),
        document.removeEventListener("touchmove", this.handleDragMove),
        document.removeEventListener("touchend", this.handleDragEnd),
        document.documentElement.style.removeProperty("--mc-drawer-height"));
    },
    methods: {
      createObserver() {
        const e = document.getElementById("mc-mockup-container");
        e &&
          ((this.observer = new IntersectionObserver(
            (t) => {
              t[0].isIntersecting
                ? (this.isDrawerVisible = !1)
                : (this.isDrawerVisible = !0);
            },
            { threshold: 0.1 },
          )),
          this.observer.observe(e));
      },
      createPreviewBtnObserver() {
        const e = document.getElementById("btn-preview-desktop");
        e &&
          ((this.previewBtnObserver = new IntersectionObserver(
            (t) => {
              const o = t[0],
                i = o.boundingClientRect;
              !o.isIntersecting && i.bottom < 0
                ? (this.isPreviewBtnScrolledPast = !0)
                : (this.isPreviewBtnScrolledPast = !1);
            },
            { threshold: 0 },
          )),
          this.previewBtnObserver.observe(e));
      },
      updatePreview() {
        this.observer && this.observer.takeRecords();
        const e = document.getElementById("canvas"),
          o = Zr(e).toDataURL(Zt);
        ((this.previewImage = o), sessionStorage.setItem(tr, o));
      },
      zoomIn() {
        this.zoom = Math.min(this.zoom + 0.5, 2.5);
      },
      zoomOut() {
        this.zoom = Math.max(this.zoom - 0.5, 1);
      },
      getEventCoordinates(e) {
        if ("touches" in e) {
          const t = e.touches?.[0] || e.changedTouches?.[0];
          return t ? { x: t.clientX, y: t.clientY } : { x: 0, y: 0 };
        }
        return { x: e.clientX, y: e.clientY };
      },
      handleDragStart(e) {
        if (this.zoom <= 1) return;
        (e.preventDefault(), (this.isDragging = !0));
        const t = this.getEventCoordinates(e);
        ((this.dragStartX = t.x),
          (this.dragStartY = t.y),
          (this.initialTranslateX = this.translateX),
          (this.initialTranslateY = this.translateY));
      },
      handleDragMove(e) {
        if (!this.isDragging || this.zoom <= 1) return;
        e.preventDefault();
        const t = this.getEventCoordinates(e),
          o = t.x - this.dragStartX,
          i = t.y - this.dragStartY,
          r = this.calculateBounds();
        let n = this.initialTranslateX + o,
          a = this.initialTranslateY + i;
        ((n = Math.max(r.minX, Math.min(r.maxX, n))),
          (a = Math.max(r.minY, Math.min(r.maxY, a))),
          (this.translateX = n),
          (this.translateY = a));
      },
      handleDragEnd() {
        this.isDragging = !1;
      },
      calculateBounds() {
        const e = this.$refs.previewImgContainer;
        if (!e) return { minX: 0, maxX: 0, minY: 0, maxY: 0 };
        const t = e.parentElement;
        if (!t) return { minX: 0, maxX: 0, minY: 0, maxY: 0 };
        const o = t.getBoundingClientRect(),
          i = o.height * this.zoom,
          r = o.width * this.zoom,
          a = o.width - r,
          u = 0,
          s = o.height - i;
        return { minX: a, maxX: u, minY: s, maxY: 0 };
      },
      prevPackItem() {
        this.activePackIndex > 0 &&
          this.formStore.setActivePackIndex(this.activePackIndex - 1);
      },
      nextPackItem() {
        this.activePackIndex < this.packQuantity - 1 &&
          this.formStore.setActivePackIndex(this.activePackIndex + 1);
      },
    },
  }),
  rn = ["src"],
  an = { class: "canvas-preview-loader" },
  nn = { class: "close-btn sf-btn-icon-s" },
  sn = { class: "zoom-control-container" },
  ln = { class: "sf-btn-icon-s zoom-btn-icon" },
  un = { class: "sf-btn-icon-s zoom-btn-icon" },
  dn = { class: "pack-drawer-label" };
function cn(e, t, o, i, r, n) {
  const a = dt;
  return (
    l(),
    p(
      "div",
      {
        class: le([
          "mc-top-drawer-preview",
          {
            show:
              e.isDrawerVisible &&
              e.show &&
              !e.forceClose &&
              !e.isPreviewBtnScrolledPast,
          },
        ]),
      },
      [
        f(
          "div",
          {
            class: le(["mc-preview-container", { draggable: e.zoom > 1 }]),
            ref: "previewImgContainer",
            style: st(e.imageTransformStyle),
            onMousedown:
              t[0] ||
              (t[0] = (...u) => e.handleDragStart && e.handleDragStart(...u)),
            onTouchstart:
              t[1] ||
              (t[1] = (...u) => e.handleDragStart && e.handleDragStart(...u)),
          },
          [f("img", { src: e.previewImage }, null, 8, rn)],
          38,
        ),
        J(f("span", an, null, 512), [[Ie, e.isLoading]]),
        f(
          "div",
          {
            class: "btn-wapper-m close-btn-wapper",
            onClick: t[2] || (t[2] = (u) => (e.forceClose = !0)),
          },
          [f("div", nn, [$(a, { type: "preview-close" })])],
        ),
        f("div", sn, [
          f(
            "div",
            {
              class: "zoom-btn btn-wapper-m",
              onClick: t[3] || (t[3] = (...u) => e.zoomIn && e.zoomIn(...u)),
            },
            [f("div", ln, [$(a, { type: "guide-zoom-in" })])],
          ),
          f(
            "div",
            {
              class: "zoom-btn btn-wapper-m",
              onClick: t[4] || (t[4] = (...u) => e.zoomOut && e.zoomOut(...u)),
            },
            [f("div", un, [$(a, { type: "guide-zoom-out" })])],
          ),
        ]),
        e.isPackMode && e.packQuantity > 1
          ? (l(),
            p(
              I,
              { key: 0 },
              [
                f(
                  "div",
                  {
                    class: le([
                      "pack-arrow pack-arrow-left",
                      { disabled: e.activePackIndex <= 0 },
                    ]),
                    onClick:
                      t[5] ||
                      (t[5] = (...u) => e.prevPackItem && e.prevPackItem(...u)),
                  },
                  [
                    ...(t[7] ||
                      (t[7] = [
                        f(
                          "svg",
                          {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                          [f("polyline", { points: "15 18 9 12 15 6" })],
                          -1,
                        ),
                      ])),
                  ],
                  2,
                ),
                f(
                  "div",
                  {
                    class: le([
                      "pack-arrow pack-arrow-right",
                      { disabled: e.activePackIndex >= e.packQuantity - 1 },
                    ]),
                    onClick:
                      t[6] ||
                      (t[6] = (...u) => e.nextPackItem && e.nextPackItem(...u)),
                  },
                  [
                    ...(t[8] ||
                      (t[8] = [
                        f(
                          "svg",
                          {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                          [f("polyline", { points: "9 6 15 12 9 18" })],
                          -1,
                        ),
                      ])),
                  ],
                  2,
                ),
                f(
                  "span",
                  dn,
                  V(e.packItemLabel) +
                    " " +
                    V(e.activePackIndex + 1) +
                    "/" +
                    V(e.packQuantity),
                  1,
                ),
              ],
              64,
            ))
          : v("", !0),
      ],
      2,
    )
  );
}
const to = K(on, [
    ["render", cn],
    ["__scopeId", "data-v-f84365a5"],
  ]),
  pn = ne({
    name: "Grid",
    computed: {
      style() {
        return { gap: "8px", flexWrap: "wrap" };
      },
    },
  });
function mn(e, t, o, i, r, n) {
  return (
    l(),
    p(
      "div",
      { class: "swatch-container", style: st(e.style) },
      [Bt(e.$slots, "default", {}, void 0, !0)],
      4,
    )
  );
}
const kt = K(pn, [
    ["render", mn],
    ["__scopeId", "data-v-00468adf"],
  ]),
  fn = {
    props: {
      src: { type: String },
      color: { type: String },
      width: { type: Number, default: 76 },
      height: { type: Number, default: 76 },
      title: { type: String, default: null },
      trim: {
        type: Boolean,
        default() {
          return !0;
        },
      },
      isThumbnail: { type: Boolean, default: !0 },
    },
    computed: {
      style() {
        return {
          height: `${this.height}px`,
          width: `${this.width}px`,
          objectFit: "contain",
          borderRadius: "8px",
          cursor: "pointer",
        };
      },
    },
    methods: { getImageURL: Me },
  },
  hn = ["src", "title"],
  yn = ["title"];
function gn(e, t, o, i, r, n) {
  return o.color
    ? (l(),
      p(
        "div",
        {
          key: 1,
          class: "image-item",
          title: o.title,
          style: st({
            ...n.style,
            width: "100%",
            height: "auto",
            aspectRatio: "1 / 1",
          }),
        },
        [
          f(
            "div",
            { class: "image-color", style: st({ backgroundColor: o.color }) },
            null,
            4,
          ),
        ],
        12,
        yn,
      ))
    : (l(),
      p(
        "div",
        {
          key: 0,
          class: "image-item",
          style: st({
            ...n.style,
            width: "100%",
            height: "auto",
            aspectRatio: "1 / 1",
          }),
        },
        [
          f(
            "img",
            { src: n.getImageURL(o.src, !0), title: o.title },
            null,
            8,
            hn,
          ),
        ],
        4,
      ));
}
const vn = K(fn, [["render", gn]]),
  wn = ne({
    components: { Grid: kt, "v-img": vn, Tooltip: eo },
    props: {
      activeId: { type: String },
      modelValue: { type: [String, Number, Object, null] },
      options: {
        type: Array,
        default: function () {
          return [];
        },
      },
      trim: {
        type: Boolean,
        default() {
          return !0;
        },
      },
      tooltip: {
        type: Boolean,
        default() {
          return !1;
        },
      },
    },
    emits: ["update:modelValue"],
    data() {
      return { val: null };
    },
    mounted() {
      this.val = this.modelValue ?? null;
    },
    watch: {
      modelValue(e) {
        this.val = e;
      },
      val(e) {
        this.$emit("update:modelValue", e);
      },
    },
    methods: {
      handleClick: function (e, t) {
        (e.preventDefault(), (this.val = t));
      },
    },
  });
function kn(e, t, o, i, r, n) {
  const a = ut("v-img"),
    u = eo,
    d = kt;
  return (
    l(),
    w(d, null, {
      default: ue(() => [
        (l(!0),
        p(
          I,
          null,
          ae(
            e.options,
            (s, c) => (
              l(),
              p("div", { key: c, style: { position: "relative" } }, [
                $(
                  u,
                  {
                    active: e.tooltip,
                    title: s?.title,
                    class: le(
                      e.val === s.value || e.activeId === s.value
                        ? "active"
                        : "",
                    ),
                  },
                  {
                    default: ue(() => [
                      $(
                        a,
                        {
                          class: le(
                            e.val === s.value || e.activeId === s.value
                              ? "active"
                              : "",
                          ),
                          src: s.image,
                          trim: e.trim,
                          color: s.color,
                          isThumbnail: s.isThumbnail,
                          onClick: (h) => e.handleClick(h, s.value),
                        },
                        null,
                        8,
                        [
                          "class",
                          "src",
                          "trim",
                          "color",
                          "isThumbnail",
                          "onClick",
                        ],
                      ),
                    ]),
                    _: 2,
                  },
                  1032,
                  ["active", "title", "class"],
                ),
              ])
            ),
          ),
          128,
        )),
      ]),
      _: 1,
    })
  );
}
const Qe = K(wn, [["render", kn]]),
  bn = ne({
    emits: ["update:value"],
    props: {
      artwork: { type: Object, required: !0 },
      value: { type: Number, required: !0 },
    },
    data() {
      return { template: 0 };
    },
    mounted() {
      this.template = this.value ?? null;
    },
    components: { Buttons: Ve, "a-form-item": Oe.Item },
    computed: {
      rules() {
        const { artwork: e } = this;
        return [
          { required: !0, message: `${e.templateDisplayLabel} is required` },
        ];
      },
    },
    watch: {
      value(e) {
        this.template = e;
      },
      template(e) {
        this.$emit("update:value", e);
      },
    },
  }),
  Sn = ["value"];
function Cn(e, t, o, i, r, n) {
  const a = Ve,
    u = Qe,
    d = vt;
  return (
    l(),
    w(
      d,
      {
        label: e.artwork.templateDisplayLabel,
        class: "template-select",
        name: "template",
        rules: e.rules,
        validateTrigger: "onSubmit",
      },
      {
        default: ue(() => [
          e.artwork.templateDisplayMode === "dropdown"
            ? J(
                (l(),
                p(
                  "select",
                  {
                    key: 0,
                    class: "form-select",
                    "onUpdate:modelValue":
                      t[0] || (t[0] = (s) => (e.template = s)),
                  },
                  [
                    (l(!0),
                    p(
                      I,
                      null,
                      ae(
                        e.artwork.templates,
                        (s, c) => (
                          l(),
                          p("option", { key: c, value: c }, V(s.title), 9, Sn)
                        ),
                      ),
                      128,
                    )),
                  ],
                  512,
                )),
                [[Te, e.template]],
              )
            : v("", !0),
          e.artwork.templateDisplayMode === "button"
            ? (l(),
              w(
                a,
                {
                  key: 1,
                  modelValue: e.template,
                  "onUpdate:modelValue":
                    t[1] || (t[1] = (s) => (e.template = s)),
                  options: e.artwork.templates.map((s, c) => ({
                    value: c,
                    label: s.title,
                  })),
                },
                null,
                8,
                ["modelValue", "options"],
              ))
            : v("", !0),
          e.artwork.templateDisplayMode === "image"
            ? (l(),
              w(
                u,
                {
                  key: 2,
                  modelValue: e.template,
                  "onUpdate:modelValue":
                    t[2] || (t[2] = (s) => (e.template = s)),
                  options: e.artwork.templates.map((s, c) => ({
                    value: c,
                    image: s.thumbnail || s.preview,
                    title: s?.title,
                  })),
                },
                null,
                8,
                ["modelValue", "options"],
              ))
            : v("", !0),
        ]),
        _: 1,
      },
      8,
      ["label", "rules"],
    )
  );
}
const fr = K(bn, [["render", Cn]]),
  In = {},
  _n = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
  };
function Pn(e, t) {
  return (
    l(),
    p("svg", _n, [
      ...(t[0] ||
        (t[0] = [
          f(
            "path",
            {
              d: "M12 15L7.10325 10.1033C6.7593 9.7593 7.0592 9.17653 7.539 9.2565L11.5068 9.9178C11.8333 9.97222 12.1667 9.97222 12.4932 9.9178L16.461 9.2565C16.9408 9.17653 17.2407 9.7593 16.8967 10.1033L12 15Z",
              fill: "#312B36",
            },
            null,
            -1,
          ),
        ])),
    ])
  );
}
const bt = K(In, [["render", Pn]]),
  Ft = Jr("system", {
    state: () => ({ isLowDevice: !1, sessionID: "" }),
    actions: {
      setIsLowDevice(e) {
        this.isLowDevice = e;
      },
      setSessionID(e) {
        this.sessionID = e;
      },
    },
  }),
  fo = (e, t) => t.title.toLowerCase().indexOf(e.toLowerCase()) >= 0;
function hr() {
  return io("div", { class: "ant-select-not-found-container" }, [
    io(dt, { type: "not-found" }),
    io("span", null, "Hmm… nothing seems to match"),
  ]);
}
const $n = ne({
    name: "accessory-clipart",
    components: {
      Grid: kt,
      ImageSwitch: Qe,
      "a-skeleton": Gt,
      "a-select": Xe,
      "a-option": Xe.Option,
      IconArrowDown: bt,
    },
    props: {
      category: { type: Object, required: !0 },
      value: { type: Object },
      layer: { type: Object, required: !0 },
      formState: { type: Object, required: !0 },
    },
    emits: ["update:value"],
    data() {
      return {
        selectedClipart: this.value?.id,
        categoryClipart: {},
        cliparts: [],
        loading: !0,
      };
    },
    setup() {
      const e = Ft(),
        { isLowDevice: t } = ee(e);
      return { isLowDevice: t };
    },
    mounted() {
      this.handleMappingWithParentLayer();
    },
    watch: {
      formState: {
        handler() {
          (this.handleMappingWithParentLayer(), this.handleSelectedClipart());
        },
        deep: !0,
        immediate: !0,
      },
      categoryClipart: {
        handler(e) {
          e &&
            (this.handleSelectedClipart(),
            (!this.value || !this.value.key) &&
              (this.selectedClipart =
                e.cliparts.find((t) => t.default)?.id || null));
        },
        deep: !0,
      },
      selectedClipart: {
        handler(e) {
          const t = this.cliparts?.find((o) => o.id === e);
          t
            ? this.$emit("update:value", {
                id: t?.id,
                layerID: this.layer.id,
                key: t?.file?.key,
                categoryID: t?.categoryID,
                title: t?.title,
                position: t?.position,
              })
            : this.$emit("update:value", void 0);
        },
        immediate: !0,
      },
    },
    methods: {
      handleSelectedClipart() {
        let e;
        if (this.categoryClipart?.cliparts?.length == 1)
          e = this.categoryClipart?.cliparts[0];
        else if (this.value) {
          const t = B(this.value, "position");
          e = this.categoryClipart?.cliparts.find((o) => o.position == t);
        }
        (e || (e = this.categoryClipart?.cliparts.find((t) => t.default)),
          (this.selectedClipart = e?.id ?? void 0));
      },
      handleMappingWithParentLayer() {
        this.loading = !0;
        const { layer: e, formState: t, category: o } = this,
          i = Object.entries(t)
            .filter(([r]) => r.startsWith(`${e.layerNumber}_category`))
            .sort(([r], [n]) => r.localeCompare(n, void 0, { numeric: !0 }))
            .map((r) => r[1])
            .map((r) => r.position);
        ((this.categoryClipart = this.getCategoryByPosition(o.children, i)),
          (this.cliparts = this.categoryClipart?.cliparts),
          (this.loading = !1));
      },
      getCategoryByPosition(e, t, o = 0) {
        if (o >= t.length || !e || e.length === 0) return null;
        const i = t[o],
          r = e[i];
        return r
          ? o === t.length - 1
            ? r
            : this.getCategoryByPosition(r.children || [], t, o + 1)
          : null;
      },
      filterOption: fo,
      renderNotFoundContent: hr,
    },
  }),
  Dn = ["title", "value"],
  An = { key: 1, class: "btn-group" },
  Fn = ["onClick"];
function En(e, t, o, i, r, n) {
  const a = bt,
    u = ut("a-option"),
    d = Xe,
    s = Gt,
    c = kt,
    h = Qe;
  return (
    l(),
    p(
      I,
      null,
      [
        e.categoryClipart?.displaySettings.displayMode === "Dropdown"
          ? (l(),
            p(
              I,
              { key: 0 },
              [
                e.isLowDevice
                  ? J(
                      (l(),
                      p(
                        "select",
                        {
                          key: 0,
                          "onUpdate:modelValue":
                            t[0] || (t[0] = (m) => (e.selectedClipart = m)),
                          class: "form-select",
                          placeholder: "--Select an option--",
                          "dropdown-style": {
                            maxHeight: "250px",
                            overflow: "auto",
                            zIndex: 1,
                          },
                        },
                        [
                          t[4] ||
                            (t[4] = f(
                              "option",
                              { value: void 0, disabled: "" },
                              "--Select an option--",
                              -1,
                            )),
                          (l(!0),
                          p(
                            I,
                            null,
                            ae(
                              e.cliparts,
                              (m) => (
                                l(),
                                p(
                                  "option",
                                  { title: m.title, value: m.id, key: m.id },
                                  V(m.title),
                                  9,
                                  Dn,
                                )
                              ),
                            ),
                            128,
                          )),
                        ],
                        512,
                      )),
                      [[Te, e.selectedClipart]],
                    )
                  : (l(),
                    w(
                      d,
                      {
                        key: 1,
                        value: e.selectedClipart,
                        "onUpdate:value":
                          t[1] || (t[1] = (m) => (e.selectedClipart = m)),
                        class: "form-select",
                        placeholder: "--Select an option--",
                        showSearch: "",
                        "not-found-content": e.renderNotFoundContent(),
                        "filter-option": e.filterOption,
                        showArrow: !0,
                        "dropdown-style": {
                          maxHeight: "250px",
                          overflow: "auto",
                          zIndex: 1,
                        },
                      },
                      {
                        suffixIcon: ue(() => [$(a)]),
                        default: ue(() => [
                          (l(!0),
                          p(
                            I,
                            null,
                            ae(
                              e.cliparts,
                              (m) => (
                                l(),
                                w(
                                  u,
                                  { title: m.title, value: m.id, key: m.id },
                                  {
                                    default: ue(() => [Ue(V(m.title), 1)]),
                                    _: 2,
                                  },
                                  1032,
                                  ["title", "value"],
                                )
                              ),
                            ),
                            128,
                          )),
                        ]),
                        _: 1,
                      },
                      8,
                      ["value", "not-found-content", "filter-option"],
                    )),
              ],
              64,
            ))
          : v("", !0),
        e.categoryClipart?.displaySettings.displayMode === "Button"
          ? (l(),
            p("div", An, [
              (l(!0),
              p(
                I,
                null,
                ae(
                  e.cliparts,
                  (m) => (
                    l(),
                    p(
                      "button",
                      {
                        class: le({
                          btn: !0,
                          "btn-primary": m.id === e.selectedClipart,
                        }),
                        key: m.id,
                        onClick: (y) => (e.selectedClipart = m.id),
                      },
                      V(m.title),
                      11,
                      Fn,
                    )
                  ),
                ),
                128,
              )),
            ]))
          : v("", !0),
        e.categoryClipart?.displaySettings.displayMode === "ColorSwitcher"
          ? (l(),
            p(
              I,
              { key: 2 },
              [
                e.loading
                  ? (l(),
                    w(
                      c,
                      { key: 0 },
                      {
                        default: ue(() => [
                          $(s, {
                            active: !0,
                            title: !1,
                            avatar: { shape: "square", size: 80 },
                          }),
                          $(s, {
                            active: !0,
                            title: !1,
                            avatar: { shape: "square", size: 80 },
                          }),
                          $(s, {
                            active: !0,
                            title: !1,
                            avatar: { shape: "square", size: 80 },
                          }),
                        ]),
                        _: 1,
                      },
                    ))
                  : (l(),
                    w(
                      h,
                      {
                        key: 1,
                        options: e.cliparts.map((m) => ({
                          value: m.id,
                          image: m.file.key,
                          color: m.color,
                          title: m.title,
                        })),
                        modelValue: e.selectedClipart,
                        "onUpdate:modelValue":
                          t[2] || (t[2] = (m) => (e.selectedClipart = m)),
                        tooltip: e.categoryClipart?.displaySettings.tooltip,
                      },
                      null,
                      8,
                      ["options", "modelValue", "tooltip"],
                    )),
              ],
              64,
            ))
          : v("", !0),
        e.categoryClipart?.displaySettings.displayMode === "ImageSwitcher"
          ? (l(),
            p(
              I,
              { key: 3 },
              [
                e.loading
                  ? (l(),
                    w(
                      c,
                      { key: 0 },
                      {
                        default: ue(() => [
                          $(s, {
                            active: !0,
                            title: !1,
                            avatar: { shape: "square", size: 80 },
                          }),
                          $(s, {
                            active: !0,
                            title: !1,
                            avatar: { shape: "square", size: 80 },
                          }),
                          $(s, {
                            active: !0,
                            title: !1,
                            avatar: { shape: "square", size: 80 },
                          }),
                        ]),
                        _: 1,
                      },
                    ))
                  : (l(),
                    w(
                      h,
                      {
                        key: 1,
                        options: e.cliparts.map((m) => ({
                          value: m.id,
                          image: m.thumbnail || m.file.key,
                          title: m.title,
                          isThumbnail: !!m.thumbnail,
                        })),
                        modelValue: e.selectedClipart,
                        "onUpdate:modelValue":
                          t[3] || (t[3] = (m) => (e.selectedClipart = m)),
                        tooltip: e.categoryClipart?.displaySettings.tooltip,
                      },
                      null,
                      8,
                      ["options", "modelValue", "tooltip"],
                    )),
              ],
              64,
            ))
          : v("", !0),
      ],
      64,
    )
  );
}
const yr = K($n, [["render", En]]),
  Ln = ne({
    name: "accessory-field",
    components: { "a-form-item": Oe.Item, AccessoryClipart: yr },
    props: {
      layer: { type: Object, required: !0 },
      formState: { type: Object, required: !0 },
    },
    emits: ["update:value"],
    data() {
      return {
        category: null,
        maxDepthCate: 0,
        categoryClipart: null,
        dependLayer: null,
      };
    },
    setup() {
      const e = oe(),
        { clipartCategories: t } = ee(e);
      return { productStore: e, clipartCategories: t };
    },
    created() {
      const { layer: e, clipartCategories: t } = this,
        o = B(e, "personalized.clipartCategory"),
        i = t.find((r) => r.id === o);
      ((this.category = i), (this.maxDepthCate = this.findMaxDepth(i)));
    },
    computed: {
      label() {
        return B(this.layer, "personalized.label", this.layer.title);
      },
      required() {
        return B(this.layer, "personalized.required", !1);
      },
      fieldName() {
        return `${this.layer.layerNumber}_accessory_${this.layer.accessoryNo || 0}`;
      },
      parentLayerForm() {
        const { layer: e, formState: t, maxDepthCate: o } = this;
        return Object.keys(t).some((i) =>
          i.startsWith(`${e.layerNumber}_category_${o - 1}`),
        );
      },
      rules() {
        return [
          { required: this.required, message: `${this.label} is required` },
        ];
      },
    },
    methods: {
      findMaxDepth(e) {
        return !e || !e.children || e.children.length === 0
          ? 0
          : 1 + Math.max(...e.children.map(this.findMaxDepth));
      },
      handleChange(e) {
        this.$emit("update:value", { key: this.fieldName, value: e });
      },
    },
  }),
  Tn = { key: 0 };
function Vn(e, t, o, i, r, n) {
  const a = yr,
    u = vt;
  return e.parentLayerForm
    ? (l(),
      p("div", Tn, [
        $(
          u,
          {
            label: e.label,
            name: e.fieldName,
            rules: e.rules,
            validateTrigger: "onSubmit",
          },
          {
            default: ue(() => [
              $(
                a,
                {
                  value: e.formState[e.fieldName],
                  "onUpdate:value": e.handleChange,
                  layer: e.layer,
                  category: e.category,
                  formState: e.formState,
                },
                null,
                8,
                ["value", "onUpdate:value", "layer", "category", "formState"],
              ),
            ]),
            _: 1,
          },
          8,
          ["label", "name", "rules"],
        ),
      ]))
    : v("", !0);
}
const gr = K(Ln, [["render", Vn]]),
  Mn = {
    components: { "a-form-item": Oe.Item, ImageSwitch: Qe, Buttons: Ve },
    name: "option-field",
    props: {
      layer: { type: Object, required: !0 },
      formState: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return { val: this.formState?.[this.layer.layerNumber] };
    },
    computed: {
      rules() {
        return [{ required: !0, message: `${this.layer.title} is required` }];
      },
      fieldName() {
        return `${this.layer.layerNumber}`;
      },
      label() {
        return B(this.layer, "personalized.label", this.layer.title);
      },
    },
    watch: {
      val(e) {
        this.$emit("update:value", { key: this.fieldName, value: e });
      },
    },
  },
  Un = ["value"];
function zn(e, t, o, i, r, n) {
  const a = Qe,
    u = Ve,
    d = vt;
  return (
    l(),
    w(
      d,
      {
        name: n.fieldName,
        label: n.label,
        rules: n.rules,
        validateTrigger: "onSubmit",
      },
      {
        default: ue(() => [
          o.layer.displayMode === "color"
            ? (l(),
              w(
                a,
                {
                  key: 0,
                  modelValue: r.val,
                  "onUpdate:modelValue": t[0] || (t[0] = (s) => (r.val = s)),
                  options: o.layer.options?.map((s) => ({
                    ...s,
                    title: s.label,
                  })),
                },
                null,
                8,
                ["modelValue", "options"],
              ))
            : v("", !0),
          o.layer.displayMode === "dropdown"
            ? J(
                (l(),
                p(
                  "select",
                  {
                    key: 1,
                    style: { width: "100%" },
                    class: "form-select",
                    "onUpdate:modelValue": t[1] || (t[1] = (s) => (r.val = s)),
                  },
                  [
                    t[4] ||
                      (t[4] = f(
                        "option",
                        { value: "", disabled: "" },
                        "--Select an option--",
                        -1,
                      )),
                    (l(!0),
                    p(
                      I,
                      null,
                      ae(
                        o.layer.options,
                        (s) => (
                          l(),
                          p(
                            "option",
                            { key: s.value, value: s.value },
                            V(s.label),
                            9,
                            Un,
                          )
                        ),
                      ),
                      128,
                    )),
                  ],
                  512,
                )),
                [[Te, r.val]],
              )
            : v("", !0),
          o.layer.displayMode === "button"
            ? (l(),
              w(
                u,
                {
                  key: 2,
                  modelValue: r.val,
                  "onUpdate:modelValue": t[2] || (t[2] = (s) => (r.val = s)),
                  options: o.layer.options,
                },
                null,
                8,
                ["modelValue", "options"],
              ))
            : v("", !0),
          o.layer.displayMode === "image"
            ? (l(),
              w(
                a,
                {
                  key: 3,
                  modelValue: r.val,
                  "onUpdate:modelValue": t[3] || (t[3] = (s) => (r.val = s)),
                  options: o.layer.options?.map((s) => ({
                    ...s,
                    title: s.label,
                  })),
                },
                null,
                8,
                ["modelValue", "options"],
              ))
            : v("", !0),
        ]),
        _: 1,
      },
      8,
      ["name", "label", "rules"],
    )
  );
}
const vr = K(Mn, [["render", zn]]),
  On = {},
  Nn = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
  };
function Rn(e, t) {
  return (
    l(),
    p("svg", Nn, [
      ...(t[0] ||
        (t[0] = [
          f(
            "path",
            {
              d: "M10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5ZM10 8.7915C9.53998 8.79166 9.16681 9.16482 9.16667 9.62484V12.9582C9.16677 13.4182 9.53996 13.7913 10 13.7915C10.46 13.7913 10.8332 13.4182 10.8333 12.9582V9.62484C10.8332 9.16482 10.46 8.79167 10 8.7915ZM9.95687 6.2085C9.49749 6.20955 9.1253 6.58245 9.12516 7.04183V7.12484C9.12526 7.58489 9.49846 7.95801 9.9585 7.95817H10.0415C10.5015 7.95801 10.8747 7.58489 10.8748 7.12484V7.04102C10.8747 6.81994 10.7864 6.60801 10.6299 6.45182C10.4733 6.2956 10.261 6.20733 10.0399 6.20768L9.95687 6.2085Z",
              fill: "#312B36",
            },
            null,
            -1,
          ),
        ])),
    ])
  );
}
const wr = K(On, [["render", Rn]]),
  Bn = ne({
    components: {
      Grid: kt,
      ImageSwitch: Qe,
      "a-skeleton": Gt,
      "a-select": Xe,
      "a-option": Xe.Option,
      IconArrowDown: bt,
    },
    props: {
      value: { type: Object },
      categoryID: { type: String, required: !0 },
      category: { type: Object, default: () => null },
      layer: { type: Object },
    },
    emits: ["update:value"],
    data() {
      return { selectedClipart: this.value?.id, loading: !0, cliparts: [] };
    },
    setup() {
      const e = Ft(),
        { isLowDevice: t } = ee(e);
      return { isLowDevice: t };
    },
    created() {
      (this.loadCategory(), this.handleSelectedClipart());
    },
    watch: {
      categoryID() {
        this.loadCategory();
      },
      category: {
        handler(e) {
          e &&
            (this.handleSelectedClipart(),
            (!this.value || !this.value.key) &&
              (this.selectedClipart =
                e.cliparts.find((t) => t.default)?.id || null));
        },
        deep: !0,
      },
      value(e) {
        this.selectedClipart = e?.id;
      },
      selectedClipart(e) {
        const t = this.cliparts?.find((o) => o.id === e);
        t
          ? this.$emit("update:value", {
              id: t?.id,
              layerID: this.layer?.id,
              key: t?.file?.key,
              categoryID: t?.categoryID,
              title: t?.title,
              position: t?.position,
              positionParent: t?.positionParent,
              numberChild: this.category?.numberChild,
            })
          : this.$emit("update:value", void 0);
      },
    },
    methods: {
      handleSelectedClipart() {
        let e;
        if (this.category?.cliparts?.length == 1)
          e = this.category?.cliparts[0];
        else if (this.value) {
          const t = B(this.value, "position");
          e = this.category?.cliparts.find((o) => o.position == t);
        }
        (e || (e = this.category?.cliparts.find((t) => t.default)),
          (this.selectedClipart = e?.id ?? void 0));
      },
      convertCategoryObject(e) {
        const { categoryID: t } = this;
        return e?.cliparts.map((o) => ({
          ...o,
          parentID: this.category?.parentID,
          positionParent: this.category?.position,
          categoryID: t,
          isChildren: this.category?.isChildren,
        }));
      },
      loadCategory() {
        ((this.loading = !0),
          (this.cliparts = this.convertCategoryObject(this.category)),
          (this.loading = !1));
      },
      filterOption: fo,
    },
  }),
  qn = { key: 0 },
  jn = ["title", "value"],
  Kn = { key: 1, class: "btn-group" },
  Wn = ["onClick"];
function Hn(e, t, o, i, r, n) {
  const a = bt,
    u = ut("a-option"),
    d = Xe,
    s = Gt,
    c = kt,
    h = Qe;
  return e.category
    ? J(
        (l(),
        p(
          "div",
          qn,
          [
            e.category.displaySettings.displayMode === "Dropdown"
              ? (l(),
                p(
                  I,
                  { key: 0 },
                  [
                    e.isLowDevice
                      ? J(
                          (l(),
                          p(
                            "select",
                            {
                              key: 0,
                              "onUpdate:modelValue":
                                t[0] || (t[0] = (m) => (e.selectedClipart = m)),
                              class: "form-select",
                              placeholder: "--Select an option--",
                              "dropdown-style": {
                                maxHeight: "250px",
                                overflow: "auto",
                                zIndex: 1,
                              },
                            },
                            [
                              t[4] ||
                                (t[4] = f(
                                  "option",
                                  { value: void 0, disabled: "" },
                                  "--Select an option--",
                                  -1,
                                )),
                              (l(!0),
                              p(
                                I,
                                null,
                                ae(
                                  e.cliparts,
                                  (m) => (
                                    l(),
                                    p(
                                      "option",
                                      {
                                        title: m.title,
                                        value: m.id,
                                        key: m.id,
                                      },
                                      V(m.title),
                                      9,
                                      jn,
                                    )
                                  ),
                                ),
                                128,
                              )),
                            ],
                            512,
                          )),
                          [[Te, e.selectedClipart]],
                        )
                      : (l(),
                        w(
                          d,
                          {
                            key: 1,
                            value: e.selectedClipart,
                            "onUpdate:value":
                              t[1] || (t[1] = (m) => (e.selectedClipart = m)),
                            class: "form-select",
                            placeholder: "--Select an option--",
                            "filter-option": e.filterOption,
                            showArrow: !0,
                            "dropdown-style": {
                              maxHeight: "250px",
                              overflow: "auto",
                              zIndex: 1,
                            },
                          },
                          {
                            suffixIcon: ue(() => [$(a)]),
                            default: ue(() => [
                              (l(!0),
                              p(
                                I,
                                null,
                                ae(
                                  e.cliparts,
                                  (m) => (
                                    l(),
                                    w(
                                      u,
                                      {
                                        title: m.title,
                                        value: m.id,
                                        key: m.id,
                                      },
                                      {
                                        default: ue(() => [Ue(V(m.title), 1)]),
                                        _: 2,
                                      },
                                      1032,
                                      ["title", "value"],
                                    )
                                  ),
                                ),
                                128,
                              )),
                            ]),
                            _: 1,
                          },
                          8,
                          ["value", "filter-option"],
                        )),
                  ],
                  64,
                ))
              : v("", !0),
            e.category.displaySettings.displayMode === "Button"
              ? (l(),
                p("div", Kn, [
                  (l(!0),
                  p(
                    I,
                    null,
                    ae(
                      e.cliparts,
                      (m) => (
                        l(),
                        p(
                          "button",
                          {
                            class: le({
                              btn: !0,
                              "btn-primary": m.id === e.selectedClipart,
                            }),
                            key: m.id,
                            onClick: (y) => (e.selectedClipart = m.id),
                          },
                          V(m.title),
                          11,
                          Wn,
                        )
                      ),
                    ),
                    128,
                  )),
                ]))
              : v("", !0),
            e.category.displaySettings.displayMode === "ColorSwitcher"
              ? (l(),
                p(
                  I,
                  { key: 2 },
                  [
                    e.loading
                      ? (l(),
                        w(
                          c,
                          { key: 0 },
                          {
                            default: ue(() => [
                              $(s, {
                                active: !0,
                                title: !1,
                                avatar: { shape: "square", size: 80 },
                              }),
                              $(s, {
                                active: !0,
                                title: !1,
                                avatar: { shape: "square", size: 80 },
                              }),
                              $(s, {
                                active: !0,
                                title: !1,
                                avatar: { shape: "square", size: 80 },
                              }),
                            ]),
                            _: 1,
                          },
                        ))
                      : (l(),
                        w(
                          h,
                          {
                            key: 1,
                            tooltip: e.category.displaySettings.tooltip,
                            options: e.cliparts.map((m) => ({
                              value: m.id,
                              image: m.file.key,
                              color: m.color,
                              title: m.title,
                            })),
                            modelValue: e.selectedClipart,
                            "onUpdate:modelValue":
                              t[2] || (t[2] = (m) => (e.selectedClipart = m)),
                          },
                          null,
                          8,
                          ["tooltip", "options", "modelValue"],
                        )),
                  ],
                  64,
                ))
              : v("", !0),
            e.category.displaySettings.displayMode === "ImageSwitcher"
              ? (l(),
                p(
                  I,
                  { key: 3 },
                  [
                    e.loading
                      ? (l(),
                        w(
                          c,
                          { key: 0 },
                          {
                            default: ue(() => [
                              $(s, {
                                active: !0,
                                title: !1,
                                avatar: { shape: "square", size: 80 },
                              }),
                              $(s, {
                                active: !0,
                                title: !1,
                                avatar: { shape: "square", size: 80 },
                              }),
                              $(s, {
                                active: !0,
                                title: !1,
                                avatar: { shape: "square", size: 80 },
                              }),
                            ]),
                            _: 1,
                          },
                        ))
                      : (l(),
                        w(
                          h,
                          {
                            key: 1,
                            tooltip: e.category.displaySettings.tooltip,
                            options: e.cliparts.map((m) => ({
                              value: m.id,
                              image: m.thumbnail || m.file.key,
                              title: m.title,
                              isThumbnail: !!m.thumbnail,
                            })),
                            modelValue: e.selectedClipart,
                            "onUpdate:modelValue":
                              t[3] || (t[3] = (m) => (e.selectedClipart = m)),
                          },
                          null,
                          8,
                          ["tooltip", "options", "modelValue"],
                        )),
                  ],
                  64,
                ))
              : v("", !0),
          ],
          512,
        )),
        [[Ie, e.cliparts?.length > 1 || e.category.displaySettings.alwayShow]],
      )
    : v("", !0);
}
const kr = K(Bn, [["render", Hn]]),
  Yn = ne({
    name: "clipart-category",
    props: {
      category: { type: Object, required: !0 },
      layer: { type: Object, required: !0 },
      label: { type: String, required: !0 },
      numberChild: { type: Number, default: 0 },
      isSubCategory: {
        type: Boolean,
        default() {
          return !1;
        },
      },
      value: Object,
      formState: { type: Object, required: !0 },
    },
    emits: ["update:value", "cliparts"],
    components: {
      "a-form-item": Oe.Item,
      "a-select": Xe,
      "a-option": Xe.Option,
      Buttons: Ve,
      ImageSwitch: Qe,
      IconArrowDown: bt,
    },
    data() {
      return { val: this.value?.id, dataLoaded: !1, selectedChildren: null };
    },
    setup() {
      return { isLowDevice: Ft().isLowDevice };
    },
    created() {
      if (((this.dataLoaded = !0), this.category?.children?.length)) {
        const e = this.category.children.find((t) => t.id === this.val);
        e?.children?.length
          ? (this.selectedChildren = e)
          : e && this.$emit("cliparts", e);
      }
      this.setDefaultValueCategory();
    },
    computed: {
      displayMode() {
        const { category: e } = this;
        return B(e, "displaySettings.displayMode", "Dropdown");
      },
      fieldName() {
        return `${this.layer.layerNumber}_category_${this.numberChild}`;
      },
      rulesCat() {
        return [{ required: !0, message: `${this.label} is required` }];
      },
    },
    watch: {
      val: {
        handler(e) {
          if (!this.dataLoaded) return;
          const { category: t } = this,
            o = t.children.find((i) => i.id === e);
          o &&
            (this.$emit("update:value", {
              key: this.fieldName,
              value: {
                id: o.id,
                title: o.title,
                categoryID: t.id,
                displaySettings: o.displaySettings,
                isChildren: o?.children?.length > 0,
                position: o.position,
              },
            }),
            o && o?.children?.length > 0
              ? (this.selectedChildren = o)
              : o &&
                ((this.selectedChildren = null),
                (o.numberChild = this.numberChild),
                this.$emit("cliparts", o)));
        },
        immediate: !0,
      },
      category: {
        handler(e, t) {
          e &&
            !Xt(e, t) &&
            (this.val = e.children?.find((o) => o.default)?.id ?? void 0);
        },
        deep: !0,
      },
    },
    methods: {
      setDefaultValueCategory() {
        const { category: e } = this;
        let t;
        (this.value && this.value?.categoryID != e.id
          ? (t =
              e?.children.find((o) => this.value?.position == o.position) ??
              e?.children[0])
          : this.value || (t = e?.children.find((o) => o.default)),
          t &&
            ((this.val = t?.id),
            t?.children?.length == 0 && this.handleChange(t)));
      },
      handleChange(e) {
        this.$emit("cliparts", e);
      },
      capitalizeFirstLetter(e) {
        return e
          .split(" ")
          .map((t) => t.charAt(0).toUpperCase() + t.slice(1))
          .join(" ");
      },
      onChildCategoryChange(e) {
        this.$emit("update:value", e);
      },
      filterOption: fo,
      renderNotFoundContent: hr,
    },
  }),
  Xn = ["title", "value"];
function Qn(e, t, o, i, r, n) {
  const a = bt,
    u = ut("a-option"),
    d = Xe,
    s = Ve,
    c = Qe,
    h = vt,
    m = ut("clipart-category", !0);
  return (
    l(),
    p(
      I,
      null,
      [
        $(
          h,
          {
            name: e.fieldName,
            label: e.label,
            rules: e.rulesCat,
            validateTrigger: "onSubmit",
          },
          {
            default: ue(() => [
              e.displayMode === "Dropdown"
                ? (l(),
                  p(
                    I,
                    { key: 0 },
                    [
                      e.isLowDevice
                        ? J(
                            (l(),
                            p(
                              "select",
                              {
                                key: 0,
                                "onUpdate:modelValue":
                                  t[0] || (t[0] = (y) => (e.val = y)),
                                class: "form-select",
                                placeholder: "--Select an option--",
                                "dropdown-style": {
                                  maxHeight: "250px",
                                  overflow: "auto",
                                  zIndex: 1,
                                },
                              },
                              [
                                t[5] ||
                                  (t[5] = f(
                                    "option",
                                    { value: void 0, disabled: "" },
                                    "--Select an option--",
                                    -1,
                                  )),
                                (l(!0),
                                p(
                                  I,
                                  null,
                                  ae(
                                    e.category.children,
                                    (y) => (
                                      l(),
                                      p(
                                        "option",
                                        {
                                          title: y.title,
                                          value: y.id,
                                          key: y.id,
                                        },
                                        V(y.title),
                                        9,
                                        Xn,
                                      )
                                    ),
                                  ),
                                  128,
                                )),
                              ],
                              512,
                            )),
                            [[Te, e.val]],
                          )
                        : (l(),
                          w(
                            d,
                            {
                              key: 1,
                              class: "form-select",
                              placeholder: "--Select an option--",
                              "filter-option": e.filterOption,
                              showArrow: !0,
                              "dropdown-style": {
                                maxHeight: "250px",
                                overflow: "auto",
                              },
                              value: e.val,
                              "onUpdate:value":
                                t[1] || (t[1] = (y) => (e.val = y)),
                            },
                            {
                              suffixIcon: ue(() => [$(a)]),
                              default: ue(() => [
                                (l(!0),
                                p(
                                  I,
                                  null,
                                  ae(
                                    e.category.children,
                                    (y) => (
                                      l(),
                                      w(
                                        u,
                                        {
                                          title: y.title,
                                          value: y.id,
                                          key: y.id,
                                        },
                                        {
                                          default: ue(() => [
                                            Ue(V(y.title), 1),
                                          ]),
                                          _: 2,
                                        },
                                        1032,
                                        ["title", "value"],
                                      )
                                    ),
                                  ),
                                  128,
                                )),
                              ]),
                              _: 1,
                            },
                            8,
                            ["filter-option", "value"],
                          )),
                    ],
                    64,
                  ))
                : v("", !0),
              e.displayMode === "Button"
                ? (l(),
                  w(
                    s,
                    {
                      key: 1,
                      modelValue: e.val,
                      "onUpdate:modelValue":
                        t[2] || (t[2] = (y) => (e.val = y)),
                      options: e.category.children.map((y) => ({
                        value: y.id,
                        label: y.title,
                      })),
                    },
                    null,
                    8,
                    ["modelValue", "options"],
                  ))
                : v("", !0),
              e.displayMode === "ImageSwitcher"
                ? (l(),
                  w(
                    c,
                    {
                      key: 2,
                      options: e.category.children.map((y) => ({
                        value: y.id,
                        image: y.displaySettings.value,
                        title: y.title,
                      })),
                      trim: !1,
                      activeId: e.val,
                      modelValue: e.val,
                      "onUpdate:modelValue":
                        t[3] || (t[3] = (y) => (e.val = y)),
                      tooltip: e.category.displaySettings.tooltip,
                    },
                    null,
                    8,
                    ["options", "activeId", "modelValue", "tooltip"],
                  ))
                : v("", !0),
              e.displayMode === "ColorSwitcher"
                ? (l(),
                  w(
                    c,
                    {
                      key: 3,
                      modelValue: e.val,
                      "onUpdate:modelValue":
                        t[4] || (t[4] = (y) => (e.val = y)),
                      options: e.category.children.map((y) => ({
                        value: y.id,
                        color: y.displaySettings.value,
                        title: y.title,
                      })),
                      activeId: e.val,
                      tooltip: e.category.displaySettings.tooltip,
                    },
                    null,
                    8,
                    ["modelValue", "options", "activeId", "tooltip"],
                  ))
                : v("", !0),
            ]),
            _: 1,
          },
          8,
          ["name", "label", "rules"],
        ),
        e.selectedChildren
          ? (l(),
            w(
              m,
              {
                layer: e.layer,
                numberChild: e.numberChild + 1,
                formState: e.formState,
                value:
                  e.formState[
                    `${e.layer.layerNumber}_category_${e.numberChild + 1}`
                  ],
                label: e.capitalizeFirstLetter(e.selectedChildren.title),
                "onUpdate:value": e.onChildCategoryChange,
                onCliparts: e.handleChange,
                category: e.selectedChildren,
                isSubCategory: !0,
                key: e.selectedChildren?.id,
              },
              null,
              8,
              [
                "layer",
                "numberChild",
                "formState",
                "value",
                "label",
                "onUpdate:value",
                "onCliparts",
                "category",
              ],
            ))
          : v("", !0),
      ],
      64,
    )
  );
}
const br = K(Yn, [["render", Qn]]),
  Gn = {},
  Zn = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
  };
function Jn(e, t) {
  return (
    l(),
    p("svg", Zn, [
      ...(t[0] ||
        (t[0] = [
          f(
            "path",
            {
              d: "M6.57812 0C6.92322 0 7.20299 0.279934 7.20312 0.625C7.20312 0.970178 6.9233 1.25 6.57812 1.25H2.29199C1.7167 1.25 1.25 1.7167 1.25 2.29199V9.78906C1.28438 9.74722 1.3213 9.70721 1.36035 9.66895L3.39551 7.6748C3.96997 7.11201 4.88392 7.09608 5.47754 7.63867L10.1475 11.9072H10.8652C11.4402 11.907 11.907 11.4402 11.9072 10.8652V6.57812C11.9074 6.23309 12.1872 5.95312 12.5322 5.95312C12.877 5.95348 13.1571 6.23331 13.1572 6.57812V10.8652C13.157 12.1306 12.1306 13.157 10.8652 13.1572H2.29199C1.02646 13.1572 0.000192396 12.1307 0 10.8652V2.29199C1.07378e-07 1.02634 1.02634 0 2.29199 0H6.57812ZM10.1484 0C10.448 0.000132462 10.6904 0.243339 10.6904 0.542969V1.74512C10.6904 2.4683 10.691 2.46875 11.4141 2.46875H12.6143C12.9138 2.46875 13.157 2.7112 13.1572 3.01074C13.1572 3.31045 12.914 3.55371 12.6143 3.55371H11.4141C10.6909 3.55371 10.6904 3.5539 10.6904 4.27734V5.47949C10.6903 5.77903 10.448 6.02135 10.1484 6.02148C9.84879 6.02148 9.60558 5.77911 9.60547 5.47949V4.27734C9.60547 3.55378 9.6054 3.55371 8.88184 3.55371H7.68164C7.38193 3.55371 7.13867 3.31045 7.13867 3.01074C7.13887 2.7112 7.38205 2.46875 7.68164 2.46875H8.88184C9.60532 2.46875 9.60547 2.46843 9.60547 1.74512V0.542969C9.60547 0.243257 9.84873 0 10.1484 0Z",
              fill: "#FAF8F5",
            },
            null,
            -1,
          ),
        ])),
    ])
  );
}
const Sr = K(Gn, [["render", Jn]]),
  xn = "PendingUploadsDB",
  es = 1,
  ze = "pending-uploads";
function oo() {
  return new Promise((e, t) => {
    if (typeof indexedDB > "u") {
      t(new Error("IndexedDB not available"));
      return;
    }
    const o = indexedDB.open(xn, es);
    ((o.onupgradeneeded = () => {
      const i = o.result;
      i.objectStoreNames.contains(ze) ||
        i.createObjectStore(ze, { keyPath: "key" });
    }),
      (o.onsuccess = () => e(o.result)),
      (o.onerror = () => t(o.error)));
  });
}
async function ts(e) {
  try {
    const t = await oo();
    return new Promise((o, i) => {
      const r = t.transaction(ze, "readwrite");
      (r.objectStore(ze).put(e),
        (r.oncomplete = () => {
          (t.close(), o());
        }),
        (r.onerror = () => {
          (t.close(), i(r.error));
        }));
    });
  } catch (t) {
    console.warn("[PendingUploadDB] savePendingUpload failed:", t);
  }
}
async function os(e) {
  try {
    const t = await oo();
    return new Promise((o, i) => {
      const a = t.transaction(ze, "readonly").objectStore(ze).get(e);
      ((a.onsuccess = () => {
        (t.close(), o(a.result ?? null));
      }),
        (a.onerror = () => {
          (t.close(), i(a.error));
        }));
    });
  } catch (t) {
    return (
      console.warn("[PendingUploadDB] getPendingUpload failed:", t),
      null
    );
  }
}
async function Vt(e) {
  try {
    const t = await oo();
    return new Promise((o, i) => {
      const r = t.transaction(ze, "readwrite");
      (r.objectStore(ze).delete(e),
        (r.oncomplete = () => {
          (t.close(), o());
        }),
        (r.onerror = () => {
          (t.close(), i(r.error));
        }));
    });
  } catch (t) {
    console.warn("[PendingUploadDB] removePendingUpload failed:", t);
  }
}
async function rs(e = 24 * 60 * 60 * 1e3) {
  try {
    const t = await oo(),
      o = t.transaction(ze, "readwrite"),
      i = o.objectStore(ze),
      r = i.getAll();
    return (
      (r.onsuccess = () => {
        const n = Date.now(),
          a = r.result;
        for (const u of a) n - u.metadata.timestamp > e && i.delete(u.key);
      }),
      new Promise((n) => {
        ((o.oncomplete = () => {
          (t.close(), n());
        }),
          (o.onerror = () => {
            (t.close(), n());
          }));
      })
    );
  } catch (t) {
    console.warn("[PendingUploadDB] cleanupStaleEntries failed:", t);
  }
}
function is() {
  return (
    window.location.href.split("/products/")[1]?.split("?")[0] ?? "unknown"
  );
}
function mt(e) {
  return `${is()}-${e}`;
}
let Lo = !1;
function as(e) {
  Lo || ((Lo = !0), rs(e));
}
const ns = {},
  ss = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
  };
function ls(e, t) {
  return (
    l(),
    p("svg", ss, [
      ...(t[0] ||
        (t[0] = [
          f(
            "path",
            {
              d: "M12.8534 3.98535C12.5471 4.07134 12.4369 4.15732 11.776 4.81831L11.1445 5.44975L12.7379 7.04042L14.3286 8.63379L14.9224 8.04266C15.2502 7.71754 15.5645 7.37898 15.621 7.293C15.895 6.87383 15.9058 6.30957 15.6425 5.89309C15.5296 5.71307 14.1432 4.31854 13.9443 4.18688C13.861 4.13045 13.7213 4.05522 13.6353 4.02297C13.4338 3.94774 13.0576 3.92893 12.8534 3.98535Z",
              fill: "currentColor",
            },
            null,
            -1,
          ),
          f(
            "path",
            {
              d: "M7.95751 8.63915C6.38028 10.2191 5.07711 11.5357 5.06099 11.5652C5.04487 11.5975 4.8326 12.4251 4.58809 13.4004C4.16892 15.0798 4.14743 15.1873 4.1743 15.2974C4.21192 15.4479 4.36507 15.5957 4.51285 15.6225C4.59615 15.6387 4.94814 15.5607 6.42864 15.1926L8.24233 14.7439L10.5209 12.4546C11.773 11.1944 13.0734 9.88321 13.4066 9.53928L14.0166 8.91053L12.4447 7.34135C11.5795 6.47884 10.8594 5.77217 10.846 5.77217C10.8325 5.77217 9.53206 7.06191 7.95751 8.63915Z",
              fill: "currentColor",
            },
            null,
            -1,
          ),
        ])),
    ])
  );
}
const us = K(ns, [["render", ls]]),
  ds = ne({
    name: "image-upload-form",
    components: { Toast: or, IconUpload: Sr, IconEdit: us, IconReplace: rr },
    inject: { personalizedFormId: { default: null } },
    props: {
      value: {
        type: Object,
        default() {
          return null;
        },
      },
      layer: { type: Object, default: null },
      form: { type: Object },
    },
    emits: ["update:value"],
    data() {
      return {
        keyAI: null,
        file: null,
        blobFile: null,
        timeCreateUri: 0,
        preSignS3: null,
        userAgent: null,
        uri: null,
        cutoutResponseUrl: null,
        loading: !1,
        filesName: null,
        fileKey: null,
        fileSize: 0,
        filter: this.value?.filter ?? "origin",
        keyUpload: null,
        thirdPartyProcess: !0,
        replacePhotoModal: !1,
        maxCutoutFileSize: 15,
        maxRemoveBgFileSize: 22,
        previewImage: void 0,
      };
    },
    setup() {
      const e = he(),
        t = oe(),
        o = Se(),
        i = Ft(),
        { isLowDevice: r } = ee(i);
      return { formStore: e, productStore: t, siteStore: o, isLowDevice: r };
    },
    computed: {
      isPhotoAI() {
        return (
          this.layer.isRemoveBg ||
          this.layer?.isCutoutFace ||
          this.layer.isRemoveBackground ||
          this.isHandwritingLetter
        );
      },
      isWebview() {
        return ci();
      },
      isRemoveBg() {
        return this.layer.isRemoveBg && !this.layer.isRemoveBackground;
      },
      isHandwritingLetter() {
        return (
          !!this.layer.isHandwritingLetter && !this.layer.isAIPreviewBlocked
        );
      },
      isShowFile() {
        return this.value && (this.value?.uri || this.value?.key);
      },
      isInformation() {
        return !!(this.filesName !== null || this.value?.filesName);
      },
    },
    methods: {
      async loadImage(e) {
        try {
          const { files: t } = e.target,
            { layer: o, isPhotoAI: i } = this,
            { autoFilter: r } = o;
          let n = null;
          if ((t && (n = t[0]), !n)) return;
          this.loading = !0;
          const a = await pi(n, 2560);
          this.fileSize = (a?.size ?? 0) / 1024 ** 2;
          const u = await mi(a),
            { currentArtwork: d } = this.formStore;
          ts({
            key: mt(o.layerNumber),
            file: a,
            metadata: {
              layerNumber: o.layerNumber,
              artworkID: d,
              filter: r ? "blackwhite" : "origin",
              filesName: u,
              blobFileInfo: { type: a.type, size: a.size, name: u },
              formType: "normal",
              timestamp: Date.now(),
            },
          });
          const s = this.uri,
            c =
              this.file && this.blobFile?.uri && !i ? this.blobFile.uri : null,
            m = (await fi(a)).uri;
          ((this.blobFile = { uri: m, type: a.type, size: a.size, name: u }),
            (this.uri = m),
            (this.timeCreateUri = new Date().getTime()),
            s && s.startsWith("blob:") && URL.revokeObjectURL(s),
            c && c.startsWith("blob:") && c !== s && URL.revokeObjectURL(c),
            (this.preSignS3 = null),
            this.createPreSignS3(a));
          const y = r && this.productStore.settings?.autoFilterUseModal;
          if ((this.isLowDevice || r) && !y) {
            ((this.file = a),
              r && (this.filter = "blackwhite"),
              this.handleFlowDevicePhoto(a));
            return;
          }
          if (
            (r ? (this.filter = "blackwhite") : (this.filter = "origin"),
            this.formStore.setLayerUploadSelect(o),
            this.personalizedFormId)
          ) {
            const S = qt(this.personalizedFormId);
            S &&
              S.packIndex !== this.formStore.activePackIndex &&
              this.formStore.setActivePackIndex(S.packIndex);
          }
          (this.formStore.setShowUploadModal(!0), (this.file = a));
          const C = { name: u, uri: m, filter: this.filter, skipLoad: !1 };
          (i && (C.skipLoad = !0),
            this.$emitter.emit("saveFileFormModal", { ...C, layer: o }),
            (this.loading = !1),
            this.processingUploadPhoto(this.blobFile));
        } catch (t) {
          ((this.loading = !1),
            console.log("error", t),
            alert(
              "uploaded file is expired or broken, please upload your file again.",
            ));
        }
      },
      async handleFlowDevicePhoto(e) {
        const {
            layer: t,
            fileSize: o,
            maxCutoutFileSize: i,
            maxRemoveBgFileSize: r,
            isPhotoAI: n,
            isRemoveBg: a,
          } = this,
          { storeName: u } = this.siteStore,
          { layerNumber: d } = t;
        try {
          ((this.loading = !0),
            this.formStore.setLayerUploadSelect(t),
            this.saveNewInputForm(d, !0, !1));
          let s,
            c = null,
            h = null;
          if (this.isHandwritingLetter) {
            if (((s = await this.uploadFileLarge(this.file)), !s))
              throw new Error("Image Upload failed");
            ((this.fileKey = s.url), this.saveNewInputForm(d, !0, !0));
            const A = await ao(s.url).catch(() => null);
            (A
              ? ((this.thirdPartyProcess = !0),
                (this.uri = A.url),
                (this.keyAI = A.key),
                this.saveNewInputForm(d, !0, !1))
              : ((this.thirdPartyProcess = !1),
                this.saveNewInputForm(d, !0, !1)),
              (this.loading = !1),
              this.formStore.setUploadStates({ layerNumber: d, loading: !1 }));
            return;
          }
          const m = !a && n && !(n && o > (a ? r : i));
          if (a && !(o > r)) {
            if (o <= 5) {
              const [A, Y] = await Promise.all([
                this.uploadFileLarge(this.file),
                Lt(u, e).catch(() => null),
              ]);
              ((s = A), (h = Y));
            } else if (((s = await this.uploadFileLarge(this.file)), s)) {
              const A = Me(s?.url);
              h = await Tt(u, A).catch(() => null);
            }
          } else if (m) {
            const [A, Y] = await Promise.all([
              this.uploadFileLarge(this.file),
              this.processingCutoutFromFile(this.file).catch(() => null),
            ]);
            ((s = A), (c = Y));
          } else s = await this.uploadFileLarge(this.file);
          if (!s) throw new Error("Image Upload failed");
          if (((this.fileKey = s?.url), this.saveNewInputForm(d, !0, !0), !n)) {
            ((this.uri = null),
              this.saveNewInputForm(d, !0, !1),
              this.formStore.setUploadStates({ layerNumber: d, loading: !1 }),
              (this.loading = !1));
            return;
          }
          const y = a ? r : n ? i : 0;
          if (n && o > y) {
            (this.$refs.toast.show({
              message: `Cannot remove background of image file larger than ${y}MB`,
              type: "error",
              position: "top center",
              duration: 4500,
            }),
              this.saveNewInputForm(d, !0, !1),
              this.formStore.setUploadStates({ layerNumber: d, loading: !1 }),
              (this.loading = !1));
            return;
          }
          let S;
          if (!a && t.isRemoveBackground && !h && !c)
            if (o <= 5) h = await Lt(u, this.file).catch(() => null);
            else {
              const A = Me(s?.url);
              h = await Tt(u, A).catch(() => null);
            }
          if (
            (a
              ? h
                ? (S = { imageBase64: h.image })
                : c && (S = c)
              : c
                ? (S = c)
                : t.isRemoveBackground && h && (S = { imageBase64: h.image }),
            S)
          ) {
            this.thirdPartyProcess = !0;
            const A = this.file?.type || "image/png";
            ((this.uri = `data:${A};base64,` + S?.imageBase64),
              (this.cutoutResponseUrl = S?.imageUrl),
              this.saveNewInputForm(t.layerNumber, !0, !1),
              (this.loading = !1),
              this.formStore.setUploadStates({ layerNumber: d, loading: !1 }));
          } else
            ((this.thirdPartyProcess = !1),
              (this.loading = !1),
              this.saveNewInputForm(t.layerNumber, !0, !1),
              this.formStore.setUploadStates({ layerNumber: d, loading: !1 }));
        } catch (s) {
          ((this.loading = !1),
            this.formStore.setUploadStates({ layerNumber: d, loading: !1 }),
            console.log("error", s),
            alert(
              "uploaded file is expired or broken, please upload your file again.",
            ));
        }
      },
      async processingUploadPhoto(e) {
        const {
            layer: t,
            filter: o,
            fileSize: i,
            maxCutoutFileSize: r,
            maxRemoveBgFileSize: n,
            isPhotoAI: a,
            isRemoveBg: u,
          } = this,
          { storeName: d } = this.siteStore,
          { layerNumber: s } = t;
        try {
          if (!a) return;
          ((this.loading = !0),
            this.formStore.setUploadStates({ layerNumber: s, loading: !0 }));
          let c;
          const h = { name: e?.name, filter: o },
            m = u ? n : a ? r : 0,
            y = a && i > m;
          if (this.isHandwritingLetter) {
            const N = await this.uploadFileLarge(this.file);
            if (!N) throw new Error("Image Upload failed");
            const F = await ao(N.url).catch(() => null);
            if (F) {
              this.thirdPartyProcess = !0;
              const U = F.url,
                X = F.key;
              U &&
                ((h.uri = U), (h.keyAI = X), (this.uri = U), (this.keyAI = X));
              const j = { ...h, layer: t, skipLoad: !1 };
              this.$emitter.emit("saveFileFormModal", j);
            } else
              ((this.thirdPartyProcess = !1),
                this.$emitter.emit("saveFileFormModal", {
                  uri: this.uri,
                  name: this.blobFile?.name,
                  skipLoad: !1,
                  layer: t,
                }));
            ((this.loading = !1),
              this.formStore.setUploadStates({ layerNumber: s, loading: !1 }),
              Vt(mt(s)));
            return;
          }
          let C,
            S = null,
            A = null;
          const Y = !u && a && !y;
          if (u && !y) {
            if (i <= 5) {
              const [N, F] = await Promise.all([
                this.uploadFileLarge(this.file),
                Lt(d, this.file).catch(() => null),
              ]);
              ((C = N), (A = F));
            } else if (((C = await this.uploadFileLarge(this.file)), C)) {
              const N = Me(C?.url);
              A = await Tt(d, N).catch(() => null);
            }
          } else if (Y) {
            const [N, F] = await Promise.all([
              this.uploadFileLarge(this.file),
              this.processingCutoutFromFile(this.file).catch(() => null),
            ]);
            ((C = N), (S = F));
          } else C = await this.uploadFileLarge(this.file);
          if (!C) throw new Error("Image Upload failed");
          if (y)
            this.$refs.toast.show({
              message: `Cannot remove background of image file larger than ${m}MB`,
              type: "error",
              position: "top right",
              duration: 4500,
            });
          else if (a) {
            if (!u && t.isRemoveBackground && !S)
              if (i <= 5) A = await Lt(d, this.file).catch(() => null);
              else {
                const N = Me(C?.url);
                A = await Tt(d, N).catch(() => null);
              }
            u
              ? A && (c = { imageBase64: A.image })
              : S
                ? (c = S)
                : A && (c = { imageBase64: A.image });
          }
          if (c) {
            this.thirdPartyProcess = !0;
            const N = this.file?.type || "image/png";
            ((h.uri = `data:${N};base64,` + c?.imageBase64),
              (h.cutoutResponseUrl = c?.imageUrl),
              (this.uri = `data:${N};base64,` + c?.imageBase64),
              (this.cutoutResponseUrl = c?.imageUrl));
            const F = { ...h, layer: t, skipLoad: !1 };
            (this.$emitter.emit("saveFileFormModal", F),
              this.blobFile?.uri?.startsWith("blob:") &&
                URL.revokeObjectURL(this.blobFile.uri),
              (this.loading = !1),
              this.formStore.setUploadStates({ layerNumber: s, loading: !1 }),
              Vt(mt(s)));
          } else
            ((this.thirdPartyProcess = !1),
              (this.loading = !1),
              this.formStore.setUploadStates({ layerNumber: s, loading: !1 }),
              this.$emitter.emit("saveFileFormModal", {
                uri: this.uri,
                cutoutResponseUrl: this.cutoutResponseUrl,
                name: this.blobFile?.name,
                skipLoad: !1,
                layer: t,
              }),
              Vt(mt(s)));
        } catch {
          ((this.loading = !1),
            this.formStore.setUploadStates({ layerNumber: s, loading: !1 }),
            (this.thirdPartyProcess = !1),
            (this.file = null));
          const c = this.blobFile?.name;
          (this.blobFile?.uri?.startsWith("blob:") &&
            URL.revokeObjectURL(this.blobFile.uri),
            (this.blobFile = null),
            this.$emitter.emit("saveFileFormModal", {
              name: c,
              skipLoad: !1,
              layer: t,
            }),
            this.formStore.setShowUploadModal(!1),
            this.$emit("update:value", null),
            alert(
              "uploaded file is expired or broken, please upload your file again.",
            ));
        }
      },
      handlerFile() {
        ((this.$refs.value = ""), this.$refs.input.click());
      },
      getUrlImage: Me,
      async savePreviewCanvas(e, t) {
        if (!this.file && !this.value?.key) return;
        const o = e.get("layerNumber");
        try {
          if (this.file) {
            if (
              ((this.loading = !0),
              this.formStore.setUploadStates({ layerNumber: o, loading: !0 }),
              this.isPhotoAI)
            ) {
              ((this.fileKey = this.preSignS3?.fields?.Key),
                this.saveNewInputForm(o, !0, !1, !1, e),
                (this.loading = !1));
              const n = ko() ? 1e3 : 500;
              (setTimeout(() => {
                ((this.loading = !1),
                  (this.file = null),
                  (this.blobFile = null),
                  (this.uri = null));
              }, n),
                this.formStore.setUploadStates({
                  layerNumber: o,
                  loading: !1,
                }));
              return;
            }
            (this.preSignS3 && (this.fileKey = this.preSignS3?.fields?.Key),
              this.value?.uri &&
                this.uri &&
                this.uri != this.value.uri &&
                URL.revokeObjectURL(this.value.uri),
              this.saveNewInputForm(o, !0, !1));
            const i = await this.uploadFileLarge(this.file);
            if (xe(i)) throw new Error("cannot upload image");
            ((this.fileKey = i?.url), this.saveNewInputForm(o, !0, !1));
            const r = ko() ? 1500 : 1e3;
            setTimeout(() => {
              ((this.loading = !1),
                (this.file = null),
                (this.blobFile = null),
                (this.uri = null),
                this.formStore.setUploadStates({
                  layerNumber: o,
                  loading: !1,
                }));
            }, r);
            return;
          }
          this.saveNewInputForm(o, !1, !1, t, e);
        } catch (i) {
          (console.log("error", i),
            this.$refs.toast.show({
              message: "Cannot upload file. Please try again",
              type: "error",
              position: "top right",
              duration: 4500,
              style: "compact",
            }),
            (this.loading = !1),
            this.$emit("update:value", null));
        }
      },
      saveNewInputForm(e, t, o, i, r) {
        const { layer: n, formStore: a } = this,
          { layerUploadsEditMode: u } = a;
        if (
          (r || (r = u[e] ?? window.__layerUpload[e]),
          !r && !this.layer?.autoFilter && !this.isLowDevice)
        )
          return;
        const d = r?.originScale ? r?.originScale : this.value?.originScale,
          s = {
            id: n?.id,
            key: t ? this.fileKey : this.value?.key,
            filter: this.filter ? this.filter : this.value?.filter,
            frame: { width: r?.width, height: r?.height },
            width: n?.width,
            height: n?.height,
            angle: r?.angle ?? 0,
            scaleX: r?.scaleX,
            scaleY: r?.scaleY,
            originScale: d,
            newFlow: !0,
            maskScale: r?.maskScale,
            angleArtwork: r?.angleArtwork ?? 0,
            maskScaleFill: r?.maskScaleFill,
            offset: r?.offset,
            filesName: this.file ? this.filesName : this.value.filesName,
            layerNumber: e,
            thirdPartyProcess: this.thirdPartyProcess,
          };
        (o && (s.skipLoad = o),
          i && (s.isPopupModal = i),
          (this.isPhotoAI || t) &&
            ((s.uri = t ? this.uri : this.value?.uri),
            (s.cutoutResponseUrl = t
              ? this.cutoutResponseUrl
              : this.value?.cutoutResponseUrl)),
          this.isHandwritingLetter &&
            this.keyAI &&
            (s.keyAI = t ? this.keyAI : this.value?.keyAI),
          ((!this.thirdPartyProcess && this.isPhotoAI) || this.userAgent) &&
            (s.userAgent = navigator.userAgent),
          this.$emit("update:value", s));
      },
      async createPreSignS3(e) {
        const t = await hi(
            this.siteStore.sessionID,
            this.siteStore.storeName,
            this.layer.layerNumber,
            e,
          ),
          o = Date.now() - this.timeCreateUri > 3e3 * 1e3;
        t &&
          (!this.preSignS3 || o) &&
          ((this.filesName = t?.fields?.FileName), (this.preSignS3 = t));
      },
      async uploadFileLarge(e) {
        const t = await yi({
          sessionID: this.siteStore.sessionID,
          storeName: this.siteStore.storeName,
          layerNumber: this.layer.layerNumber,
          file: e,
          blobFile: this.blobFile,
          preSignS3: this.preSignS3,
          timeCreateUri: this.timeCreateUri,
          fileSize: this.fileSize,
        });
        return (
          t.preSignS3 && (this.preSignS3 = t.preSignS3),
          t.filesName && (this.filesName = t.filesName),
          t.result || (this.userAgent = navigator.userAgent),
          t.result && Vt(mt(this.layer.layerNumber)),
          t.result
        );
      },
      async processingCutoutFromUrl(e) {
        const t = await bo();
        let o;
        return (
          this.layer?.isCutoutFace ? (o = So) : (o = Co),
          gi(o, t.uid, t.signExpireTime, t.sign, e)
        );
      },
      async processingCutoutFromFile(e) {
        const t = await bo();
        let o;
        return (
          this.layer?.isCutoutFace ? (o = So) : (o = Co),
          vi(o, t.uid, t.signExpireTime, t.sign, e)
        );
      },
      async uploadFileFormBase64(e, t) {
        return (
          (this.userAgent = navigator.userAgent),
          wi(e, t, this.fileSize)
        );
      },
      replacePhoto(e) {
        (e.preventDefault(),
          this.formStore.setShowUploadModal(!1),
          this.$refs.input.click());
      },
      information(e) {
        return this[e] || (this.value && this.value[e]);
      },
      editPhoto(e) {
        (e.preventDefault(),
          window.dispatchEvent(new CustomEvent(rt.CANVAS_RENDERED)));
        const {
          setLayerUploadSelect: t,
          setPersonalizedModal: o,
          currentArtwork: i,
        } = this.formStore;
        t(this.layer);
        const r = this.personalizedFormId || i;
        if (this.personalizedFormId) {
          const n = qt(this.personalizedFormId);
          n &&
            n.packIndex !== this.formStore.activePackIndex &&
            this.formStore.setActivePackIndex(n.packIndex);
        }
        (o({ artworkID: i, data: ot(this.formStore.personalized[r]) }),
          this.formStore.setShowUploadModal(!0));
      },
      saveFileInput(e) {
        this.formStore.layerUploadSelect?.layerNumber ==
          this.layer?.layerNumber &&
          ((this.file = e.file), (this.fileKey = e.fileKey));
      },
      saveInputFormUpload(e) {
        if (this.productStore.settings?.isPackMode && this.personalizedFormId) {
          const i = Jt(
            this.formStore.currentArtwork,
            this.formStore.activePackIndex,
          );
          if (this.personalizedFormId !== i) return;
        }
        if (e && e.type == "resetInput") {
          ((this.file = null), (this.filesName = this.value?.filesName));
          return;
        }
        e.filter && (this.filter = e.filter);
        const { isPopupModal: t, target: o } = e;
        this.savePreviewCanvas(o, t);
      },
      replacePhotoEvent() {
        this.formStore.layerUploadSelect?.id == this.layer.id &&
          (this.replacePhotoModal = !0);
      },
      async resumePendingUpload() {
        try {
          const e = mt(this.layer.layerNumber),
            t = await os(e);
          if (!t || this.value?.key) return;
          const { file: o, metadata: i } = t;
          ((this.file = o),
            (this.filesName = i.filesName),
            (this.filter = i.filter),
            (this.fileSize = (o?.size ?? 0) / 1024 ** 2));
          const r = URL.createObjectURL(o);
          ((this.blobFile = { uri: r, ...i.blobFileInfo }),
            (this.uri = r),
            (this.timeCreateUri = Date.now()),
            this.$refs.toast?.show({
              message: "Restoring your previous upload...",
              type: "info",
              position: "top center",
              duration: 2500,
            }));
          const n = {
            name: i.filesName,
            uri: r,
            filter: i.filter,
            skipLoad: this.isPhotoAI,
          };
          (this.formStore.setLayerUploadSelect(this.layer),
            this.$emitter.emit("saveFileFormModal", {
              ...n,
              layer: this.layer,
            }),
            this.isPhotoAI && this.processingUploadPhoto(this.blobFile));
        } catch (e) {
          console.warn("[PendingUpload] Resume failed:", e);
        }
      },
    },
    async mounted() {
      if (
        (this.$emitter.on("saveFileInput", this.saveFileInput),
        this.$emitter.on("replacePhotoModal", this.replacePhotoEvent),
        this.$emitter.on(
          `saveInputFormUpload-${this.layer.layerNumber}`,
          this.saveInputFormUpload,
        ),
        as(),
        this.resumePendingUpload(),
        this.value?.key && this.siteStore.isEditDesign)
      ) {
        if (
          ((this.loading = !0),
          this.formStore.setUploadStates({
            layerNumber: this.layer.layerNumber,
            loading: !0,
          }),
          this.formStore.setLayerUploadSelect(this.layer),
          this.isHandwritingLetter)
        ) {
          const e = await ao(this.value.key).catch(() => null);
          if (e && ((this.uri = e.url), (this.keyAI = e.key), this.uri)) {
            const t = { ...this.value, uri: this.uri, keyAI: this.keyAI };
            this.$emit("update:value", t);
          }
        } else if (this.isPhotoAI) {
          const e = await this.processingCutoutFromUrl(
            Me(this.value.key) ?? "",
          );
          if (e) {
            ((this.uri =
              `data:${this.file?.type || "image/png"};base64,` +
              e?.imageBase64),
              (this.cutoutResponseUrl = e?.imageUrl));
            const t = {
              ...this.value,
              uri: this.uri,
              cutoutResponseUrl: this.cutoutResponseUrl,
            };
            this.$emit("update:value", t);
          }
        }
        ((this.loading = !1),
          this.formStore.setUploadStates({
            layerNumber: this.layer.layerNumber,
            loading: !1,
          }));
      }
    },
    watch: {
      value: {
        handler: async function (e) {
          if (e)
            if (e.uri)
              try {
                const o = await (await fetch(e.uri)).blob();
                o && o.size > 0
                  ? (this.previewImage = e.uri)
                  : (this.previewImage = Me(e.key));
              } catch {
                this.previewImage = Me(e.key);
              }
            else this.previewImage = Me(e.key);
        },
        immediate: !0,
        deep: !0,
      },
      replacePhotoModal(e) {
        e &&
          ((this.replacePhotoModal = !1),
          this.formStore.layerUploadSelect?.layerNumber ==
            this.layer.layerNumber && this.handlerFile());
      },
    },
    beforeUnmount() {
      (this.loading &&
        ((this.fileKey =
          this.preSignS3?.fields?.Key ??
          ki(
            this.siteStore.storeName,
            this.siteStore.sessionID,
            this.layer.layerNumber,
            bi(this.file ? this.file.name : this.filesName),
          )),
        this.saveNewInputForm(this.layer.layerNumber, !0, !1)),
        this.$emitter.off("saveFileInput", this.saveFileInput),
        this.$emitter.off("replacePhotoModal", this.replacePhotoEvent),
        this.$emitter.off(
          `saveInputFormUpload-${this.layer.layerNumber}`,
          this.saveInputFormUpload,
        ));
    },
  }),
  cs = { key: 0, class: "box-file-upload" },
  ps = { class: "d-flex items-center information-file" },
  ms = ["src"],
  fs = { class: "box-action-btn" },
  hs = ["disabled"],
  ys = ["disabled"],
  gs = ["disabled"];
function vs(e, t, o, i, r, n) {
  const a = or,
    u = rr,
    d = Sr;
  return (
    l(),
    p(
      I,
      null,
      [
        $(a, { ref: "toast", closable: "" }, null, 512),
        e.isShowFile
          ? (l(),
            p("div", cs, [
              f("div", ps, [
                f(
                  "img",
                  { src: e.previewImage, class: "custom-image img-preview" },
                  null,
                  8,
                  ms,
                ),
                f("div", null, [
                  J(f("span", null, V(e.information("filesName")), 513), [
                    [Ie, e.isInformation],
                  ]),
                ]),
              ]),
              f("div", fs, [
                (!e.isLowDevice && !e.layer?.autoFilter) ||
                e.productStore.settings.autoFilterUseModal
                  ? (l(),
                    p(
                      "div",
                      {
                        key: 0,
                        class: le(
                          `btn-edit-file sf-text-label-s-medium btn  ${e.loading && "loading"}`,
                        ),
                        disabled: e.loading,
                        onClick:
                          t[0] ||
                          (t[0] = (...s) => e.editPhoto && e.editPhoto(...s)),
                      },
                      " Edit ",
                      10,
                      hs,
                    ))
                  : (l(),
                    p(
                      "div",
                      {
                        key: 1,
                        disabled: e.loading,
                        class: le([
                          "btn",
                          "box-file-upload__label",
                          e.loading && "btn-upload__label--loading",
                        ]),
                        onClick:
                          t[1] ||
                          (t[1] = (...s) =>
                            e.replacePhoto && e.replacePhoto(...s)),
                      },
                      [
                        e.loading ? v("", !0) : (l(), w(u, { key: 0 })),
                        t[5] || (t[5] = Ue(" Replace Photo ", -1)),
                      ],
                      10,
                      ys,
                    )),
              ]),
            ]))
          : v("", !0),
        J(
          f(
            "div",
            null,
            [
              f(
                "input",
                {
                  type: "file",
                  ref: "input",
                  onClick: t[2] || (t[2] = (s) => (e.$refs.input.value = "")),
                  onChange: t[3] || (t[3] = (s) => e.loadImage(s)),
                  accept: "image/*",
                  style: { display: "none" },
                },
                null,
                544,
              ),
              f(
                "div",
                {
                  class: le(["btn-upload", e.loading && "btn-upload--loading"]),
                  onClick:
                    t[4] ||
                    (t[4] = (...s) => e.handlerFile && e.handlerFile(...s)),
                  disabled: e.loading,
                },
                [
                  t[7] ||
                    (t[7] = f(
                      "span",
                      { class: "btn-upload__sub-label" },
                      "Choose and upload photo...",
                      -1,
                    )),
                  f(
                    "span",
                    {
                      class: le([
                        "btn-upload__label btn",
                        e.loading && "btn-upload__label--loading",
                      ]),
                    },
                    [$(d), t[6] || (t[6] = Ue(" Select Photo ", -1))],
                    2,
                  ),
                ],
                10,
                gs,
              ),
            ],
            512,
          ),
          [[Ie, !e.isShowFile]],
        ),
      ],
      64,
    )
  );
}
const To = K(ds, [["render", vs]]),
  ws = ye(() =>
    ge(
      () => import("./ImageUploadAIForm.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([0, 1, 2, 3, 4]),
      import.meta.url,
    ),
  ),
  Vo = ye(() =>
    ge(
      () => import("./ImageUploadAIGenForm.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([5, 1, 2, 3, 4]),
      import.meta.url,
    ),
  ),
  ks = ye(() =>
    ge(
      () => import("./modals.js?v=1-0-2-28d679f1").then((e) => e.aD),
      __vite__mapDeps([1, 2, 3, 4]),
      import.meta.url,
    ),
  ),
  bs = ne({
    name: "image-field",
    components: {
      "a-form-item": Oe.Item,
      ClipartCategory: br,
      ClipartsByCategory: kr,
      IconInfo: wr,
      PhotoGuideModal: ks,
      ImageUploadForm: To,
    },
    props: {
      layer: { type: Object, required: !0 },
      layers: { type: Object, required: !0 },
      artworkID: String,
      personalized: { type: Object },
      formState: { type: Object, required: !0 },
    },
    emits: ["update:value"],
    data() {
      return {
        category: null,
        categoryCliparts: null,
        selectedCategoryID: null,
        helpTexT: null,
        uploadValue: null,
        showPhotoGuideModal: !1,
      };
    },
    setup() {
      const e = oe(),
        t = he(),
        { clipartCategories: o } = ee(e),
        { formValues: i } = ee(t);
      return { productStore: e, clipartCategories: o, formValues: i };
    },
    created() {
      const { layer: e, clipartCategories: t } = this,
        o = B(e, "personalized.clipartCategory"),
        i = t?.find((r) => r.id === o);
      ((this.category = i),
        (this.uploadValue = this.formState?.[this.fieldName]));
    },
    watch: {
      category(e) {
        e &&
          !e?.hasChild &&
          ((e.numberChild = 0),
          (this.categoryCliparts = e),
          (this.selectedCategoryID = e.id));
      },
      filterColorByClipartMapping: {
        handler(e) {
          e &&
            this.uploadValue &&
            this.onClipartChange({ ...this.uploadValue, filterColor: e.code });
        },
        immediate: !0,
      },
    },
    computed: {
      personalizedType() {
        return B(this.layer, "personalized.type", "images");
      },
      required() {
        return B(this.layer, "personalized.required", !1);
      },
      isChildren() {
        return this.category?.hasChild ?? !1;
      },
      subCategoryTitle() {
        return this.categoryCliparts?.cliparts?.length == 1 &&
          !this.categoryCliparts?.displaySettings?.alwayShow
          ? null
          : this.categoryCliparts
            ? this.categoryCliparts?.displaySettings?.label
              ? this.categoryCliparts?.displaySettings?.label
              : this.categoryCliparts.title
            : null;
      },
      label() {
        return (
          B(this.layer, "personalized.label", this.layer.title) ||
          this.layer.title
        );
      },
      fieldName() {
        return `${this.layer.layerNumber}`;
      },
      fieldCat() {
        return `${this.layer.layerNumber}_category_0`;
      },
      rules() {
        return [{ required: !0, message: `${this.label} is required` }];
      },
      filterColorByClipartMapping() {
        if (
          this.layer?.filterPipeline &&
          this.layer?.enableFilterColorList &&
          this.layer?.filterColorMapLayerID
        ) {
          const e = this.layers?.find(
            (i) => i.id == this.layer?.filterColorMapLayerID,
          )?.layerNumber;
          if (!e) return null;
          const t = this.formState?.[e];
          if (!t) return null;
          const o = this.layer?.filterColors?.[t.position - 1 || 0];
          return o || null;
        }
        return null;
      },
      uploadComponent() {
        return this.layer?.loveAI && !this.layer?.isAIPreviewBlocked
          ? ws
          : (this.layer?.geminiAI && !this.layer?.isAIPreviewBlocked) ||
              this.layer?.replicateAI ||
              this.layer?.isRenderAIStyle
            ? Vo
            : To;
      },
      uploadExtraProps() {
        return (this.layer?.geminiAI && !this.layer?.isAIPreviewBlocked) ||
          this.layer?.replicateAI
          ? { aiModel: "gemini" }
          : this.layer?.isRenderAIStyle
            ? { aiModel: "runpod" }
            : {};
      },
    },
    methods: {
      onCategoryChange(e) {
        ((this.selectedCategoryID = e?.id), (this.categoryCliparts = e));
      },
      onChangeCategoryClipart(e) {
        this.$emit("update:value", e);
      },
      onClipartChange(e) {
        this.filterColorByClipartMapping
          ? ((this.uploadValue = {
              ...e,
              filterColor: this.filterColorByClipartMapping.code,
            }),
            this.$emit("update:value", {
              key: this.fieldName,
              value: {
                ...e,
                filterColor: this.filterColorByClipartMapping.code,
              },
            }))
          : ((this.uploadValue = e),
            this.$emit("update:value", { key: this.fieldName, value: e }));
      },
    },
  }),
  Ss = { class: "photo-guide-wrapper" },
  Cs = { class: "photo-guide-label" };
function Is(e, t, o, i, r, n) {
  const a = br,
    u = kr,
    d = vt,
    s = wr,
    c = ut("photo-guide-modal");
  return (
    l(),
    p(
      I,
      null,
      [
        e.personalizedType === "clipartCategory"
          ? (l(),
            p(
              I,
              { key: 0 },
              [
                e.category && e.isChildren
                  ? (l(),
                    w(
                      a,
                      {
                        key: 0,
                        category: e.category,
                        layer: e.layer,
                        label: e.label,
                        value: e.formState[e.fieldCat],
                        "onUpdate:value": e.onChangeCategoryClipart,
                        onCliparts: e.onCategoryChange,
                        formState: e.formState,
                      },
                      null,
                      8,
                      [
                        "category",
                        "layer",
                        "label",
                        "value",
                        "onUpdate:value",
                        "onCliparts",
                        "formState",
                      ],
                    ))
                  : v("", !0),
                e.selectedCategoryID
                  ? (l(),
                    w(
                      d,
                      {
                        key: 1,
                        label:
                          e.category && e.isChildren
                            ? e.subCategoryTitle
                            : e.label,
                        extra:
                          (e.categoryCliparts?.cliparts?.length ?? 0) > 1
                            ? e.layer?.personalized?.help
                            : "",
                        name: e.fieldName,
                        rules: e.rules,
                        "validate-trigger": "submit",
                      },
                      {
                        default: ue(() => [
                          $(
                            u,
                            {
                              categoryID: e.selectedCategoryID,
                              value: e.formState[e.fieldName],
                              "onUpdate:value": e.onClipartChange,
                              layer: e.layer,
                              category: e.categoryCliparts,
                            },
                            null,
                            8,
                            [
                              "categoryID",
                              "value",
                              "onUpdate:value",
                              "layer",
                              "category",
                            ],
                          ),
                        ]),
                        _: 1,
                      },
                      8,
                      ["label", "extra", "name", "rules"],
                    ))
                  : v("", !0),
              ],
              64,
            ))
          : (l(),
            w(
              d,
              {
                key: 1,
                name: e.fieldName,
                extra: e.layer?.personalized?.help,
                rules: e.rules,
              },
              {
                label: ue(() => [
                  f("div", Ss, [
                    f("span", Cs, V(e.label), 1),
                    f(
                      "div",
                      {
                        class: "view-photo-guide",
                        onClick:
                          t[0] || (t[0] = (h) => (e.showPhotoGuideModal = !0)),
                      },
                      [
                        $(s),
                        t[2] ||
                          (t[2] = f(
                            "span",
                            { class: "sf-text-label-s" },
                            "View Photo Guide",
                            -1,
                          )),
                      ],
                    ),
                  ]),
                ]),
                default: ue(() => [
                  (l(),
                  w(
                    _t(e.uploadComponent),
                    po(
                      {
                        value: e.formState[e.fieldName],
                        "onUpdate:value": e.onClipartChange,
                        layer: e.layer,
                        artworkID: e.artworkID,
                      },
                      e.uploadExtraProps,
                    ),
                    null,
                    16,
                    ["value", "onUpdate:value", "layer", "artworkID"],
                  )),
                ]),
                _: 1,
              },
              8,
              ["name", "extra", "rules"],
            )),
        $(
          c,
          {
            visible: e.showPhotoGuideModal,
            "onUpdate:visible":
              t[1] || (t[1] = (h) => (e.showPhotoGuideModal = h)),
          },
          null,
          8,
          ["visible"],
        ),
      ],
      64,
    )
  );
}
const Cr = K(bs, [["render", Is]]),
  Mo = /,|\.|-| |:|\/|\\/,
  Uo = /D+/,
  zo = /M+/,
  Oo = /Y+/,
  No = /h+/i,
  Ro = /m+/,
  Bo = /s+/,
  qo = /A/,
  _s = {
    props: {
      modelValue: { type: [String, Object], default: "" },
      format: { type: String, default: "YYYY-MM-DD" },
      displayFormat: { type: String },
      editable: { type: Boolean, default: !0 },
      hasInputElement: { type: Boolean, default: !0 },
      inputAttributes: { type: Object },
      selectableYearRange: { type: [Number, Object, Function], default: 150 },
      startPeriod: { type: Object },
      parseDate: { type: Function },
      formatDate: { type: Function },
      pickTime: { type: Boolean, default: !1 },
      pickMinutes: { type: Boolean, default: !0 },
      pickSeconds: { type: Boolean, default: !1 },
      use12HourClock: { type: Boolean, default: !1 },
      isDateDisabled: { type: Function, default: () => !1 },
      placeholder: String,
      nextMonthCaption: { type: String, default: "Next month" },
      prevMonthCaption: { type: String, default: "Previous month" },
      setTimeCaption: { type: String, default: "Set time:" },
      mobileBreakpointWidth: { type: Number, default: 500 },
      weekdays: {
        type: Array,
        default: () => ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      },
      months: {
        type: Array,
        default: () => [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
      },
      startWeekOnSunday: { type: Boolean, default: !1 },
      hideYear: { type: Boolean, default: !1 },
    },
    emits: ["update:modelValue", "periodChange"],
    data() {
      return {
        inputValue: this.valueToInputFormat(this.modelValue),
        direction: void 0,
        positionClass: void 0,
        opened: !this.hasInputElement,
        currentPeriod:
          this.startPeriod || this.getPeriodFromValue(this.value, this.format),
        closeEventListener: null,
        positionEventListener: null,
      };
    },
    computed: {
      valueDate() {
        const e = this.modelValue,
          t = this.format;
        return e ? this.parseDateString(e, t) : void 0;
      },
      isReadOnly() {
        return (
          !this.editable ||
          (this.inputAttributes && this.inputAttributes.readonly)
        );
      },
      isValidValue() {
        const e = this.valueDate;
        return this.modelValue ? !!e : !0;
      },
      currentPeriodDates() {
        const { year: e, month: t } = this.currentPeriod,
          o = [],
          i = new Date(e, t, 1),
          r = new Date(),
          n = i.getDay(),
          a = this.startWeekOnSunday ? n : n === 0 ? 6 : n - 1;
        if (a)
          for (let d = a; d > 0; d--) {
            const s = new Date(i);
            (s.setDate(-(d - 1)), o.push({ outOfRange: !0, date: s }));
          }
        for (; i.getMonth() === t;)
          (o.push({ date: new Date(i) }), i.setDate(i.getDate() + 1));
        const u = o.length % 7;
        if (u > 0) {
          const d = 7 - u;
          for (let s = 1; s <= d; s++) {
            const c = new Date(i);
            (c.setDate(s), o.push({ outOfRange: !0, date: c }));
          }
        }
        return (
          o.forEach((d) => {
            ((d.disabled = this.isDateDisabled(d.date)),
              (d.today = jo(d.date, r)),
              (d.dateKey = [
                d.date.getFullYear(),
                d.date.getMonth() + 1,
                d.date.getDate(),
              ].join("-")),
              (d.selected = this.valueDate ? jo(d.date, this.valueDate) : !1));
          }),
          Ps(o, 7)
        );
      },
      yearRange() {
        const e = this.currentPeriod.year,
          t = this.selectableYearRange,
          o = typeof t;
        let i = [];
        return (
          o === "number"
            ? (i = Ko(e - t, e + t))
            : o === "object"
              ? (i = Ko(t.from, t.to))
              : o === "function" && (i = t(this)),
          i.indexOf(e) < 0 && (i.push(e), (i = i.sort())),
          i
        );
      },
      currentTime() {
        const e = this.valueDate;
        if (!e) return;
        const t = e.getHours(),
          o = e.getMinutes(),
          i = e.getSeconds();
        return {
          hours: t,
          minutes: o,
          seconds: i,
          isPM: lo(t),
          hoursFormatted: (this.use12HourClock ? Wo(t) : t).toString(),
          minutesFormatted: Ee(o, 2),
          secondsFormatted: Ee(i, 2),
        };
      },
      directionClass() {
        return this.direction ? `vdp${this.direction}Direction` : void 0;
      },
      weekdaysSorted() {
        if (this.startWeekOnSunday) {
          const e = this.weekdays.slice();
          return (e.unshift(e.pop()), e);
        } else return this.weekdays;
      },
    },
    watch: {
      modelValue(e) {
        this.isValidValue &&
          ((this.inputValue = this.valueToInputFormat(e)),
          (this.currentPeriod = this.getPeriodFromValue(e, this.format)));
      },
      currentPeriod(e, t) {
        const o = new Date(e.year, e.month).getTime(),
          i = new Date(t.year, t.month).getTime();
        ((this.direction = o !== i ? (o > i ? "Next" : "Prev") : void 0),
          o !== i &&
            this.$emit("periodChange", { year: e.year, month: e.month }));
      },
    },
    beforeDestroy() {
      (this.removeCloseEvents(), this.teardownPosition());
    },
    methods: {
      valueToInputFormat(e) {
        return (
          (this.displayFormat &&
            this.formatDateToString(
              this.parseDateString(e, this.format),
              this.displayFormat,
            )) ||
          e
        );
      },
      getPeriodFromValue(e, t) {
        const o = this.parseDateString(e, t) || new Date();
        return { month: o.getMonth(), year: o.getFullYear() };
      },
      parseDateString(e, t) {
        return e
          ? this.parseDate
            ? this.parseDate(e, t)
            : this.parseSimpleDateString(e, t)
          : void 0;
      },
      formatDateToString(e, t) {
        return e
          ? this.formatDate
            ? this.formatDate(e, t)
            : this.formatSimpleDateToString(e, t)
          : "";
      },
      parseSimpleDateString(e, t) {
        let o, i, r, n, a, u;
        const d = e.split(Mo),
          s = t.split(Mo),
          c = s.length;
        for (let m = 0; m < c; m++)
          s[m].match(Uo)
            ? (o = parseInt(d[m], 10))
            : s[m].match(zo)
              ? (i = parseInt(d[m], 10))
              : s[m].match(Oo)
                ? (r = parseInt(d[m], 10))
                : s[m].match(No)
                  ? (n = parseInt(d[m], 10))
                  : s[m].match(Ro)
                    ? (a = parseInt(d[m], 10))
                    : s[m].match(Bo) && (u = parseInt(d[m], 10));
        const h = new Date([Ee(r, 4), Ee(i, 2), Ee(o, 2)].join("-"));
        if (!isNaN(h.getTime())) {
          if (!r || !i) return;
          const m = new Date(r, i - 1, o);
          return (
            [
              [r, "setFullYear"],
              [n, "setHours"],
              [a, "setMinutes"],
              [u, "setSeconds"],
            ].forEach(([C, S]) => {
              typeof C < "u" && m[S].call(m, C);
            }),
            m
          );
        }
      },
      formatSimpleDateToString(e, t) {
        return t
          .replace(Oo, (o) => e.getFullYear().toString().slice(-o.length))
          .replace(zo, (o) => Ee(e.getMonth() + 1, o.length) ?? "")
          .replace(Uo, (o) => Ee(e.getDate(), o.length) ?? "")
          .replace(
            No,
            (o) =>
              Ee(qo.test(t) ? Wo(e.getHours()) : e.getHours(), o.length) ?? "",
          )
          .replace(Ro, (o) => Ee(e.getMinutes(), o.length) ?? "")
          .replace(Bo, (o) => Ee(e.getSeconds(), o.length) ?? "")
          .replace(qo, (o) => (lo(e.getHours()) ? "PM" : "AM"));
      },
      incrementMonth(e = 1) {
        const t = new Date(this.currentPeriod.year, this.currentPeriod.month),
          o = new Date(t.getFullYear(), t.getMonth() + e);
        this.currentPeriod = { month: o.getMonth(), year: o.getFullYear() };
      },
      processUserInput(e) {
        const t = this.parseDateString(e, this.displayFormat || this.format);
        ((this.inputValue = e),
          this.$emit(
            "update:modelValue",
            t ? this.formatDateToString(t, this.format) : e,
          ));
      },
      toggle() {
        return this.opened ? this.close() : this.open();
      },
      open() {
        (this.opened ||
          ((this.opened = !0),
          (this.currentPeriod =
            this.startPeriod ||
            this.getPeriodFromValue(this.modelValue, this.format)),
          this.addCloseEvents(),
          this.setupPosition()),
          (this.direction = void 0));
      },
      close() {
        this.opened &&
          ((this.opened = !1),
          (this.direction = void 0),
          this.removeCloseEvents(),
          this.teardownPosition());
      },
      closeViaOverlay(e) {
        this.hasInputElement &&
          e.target === this.$refs.outerWrap &&
          this.close();
      },
      addCloseEvents() {
        this.closeEventListener ||
          ((this.closeEventListener = (e) => this.inspectCloseEvent(e)),
          ["click", "keyup"].forEach(
            (e) =>
              this.closeEventListener &&
              document.addEventListener(e, this.closeEventListener),
          ));
      },
      inspectCloseEvent(e) {
        "keyCode" in e && e.keyCode
          ? e.keyCode === 27 && this.close()
          : e.target !== this.$el &&
            !this.$el.contains(e.target) &&
            this.close();
      },
      removeCloseEvents() {
        this.closeEventListener &&
          (["click", "keyup"].forEach(
            (e) =>
              this.closeEventListener &&
              document.removeEventListener(e, this.closeEventListener),
          ),
          (this.closeEventListener = null));
      },
      setupPosition() {
        (this.positionEventListener ||
          ((this.positionEventListener = () => this.positionFloater()),
          window.addEventListener("resize", this.positionEventListener)),
          this.positionFloater());
      },
      positionFloater() {
        const e = this.$el.getBoundingClientRect();
        let t = "vdpPositionTop",
          o = "vdpPositionLeft";
        const i = () => {
          const r = this.$refs.outerWrap.getBoundingClientRect(),
            n = r.height,
            a = r.width;
          window.innerWidth > this.mobileBreakpointWidth
            ? (e.top + e.height + n > window.innerHeight &&
                e.top - n > 0 &&
                (t = "vdpPositionBottom"),
              e.left + a > window.innerWidth && (o = "vdpPositionRight"),
              (this.positionClass = ["vdpPositionReady", t, o].join(" ")))
            : (this.positionClass = "vdpPositionFixed");
        };
        this.$refs.outerWrap ? i() : this.$nextTick(i);
      },
      teardownPosition() {
        this.positionEventListener &&
          ((this.positionClass = void 0),
          window.removeEventListener("resize", this.positionEventListener),
          (this.positionEventListener = null));
      },
      clear() {
        this.$emit("update:modelValue", "");
      },
      selectDateItem(e) {
        if (!e.disabled) {
          const t = new Date(e.date);
          (this.currentTime &&
            (t.setHours(this.currentTime.hours),
            t.setMinutes(this.currentTime.minutes),
            t.setSeconds(this.currentTime.seconds)),
            this.$emit(
              "update:modelValue",
              this.formatDateToString(t, this.format),
            ),
            this.hasInputElement && !this.pickTime && this.close());
        }
      },
      set12HourClock(e) {
        const t = new Date(this.valueDate),
          o = t.getHours();
        (t.setHours(e === "PM" ? o + 12 : o - 12),
          this.$emit(
            "update:modelValue",
            this.formatDateToString(t, this.format),
          ));
      },
      inputHours(e) {
        const t = new Date(this.valueDate),
          o = t.getHours(),
          i = parseInt(e.target.value, 10) || 0,
          r = this.use12HourClock ? 1 : 0,
          n = this.use12HourClock ? 12 : 23,
          a = Ho(i, r, n);
        (t.setHours(this.use12HourClock ? $s(a, lo(o)) : a),
          (e.target.value = Ee(a, 1) ?? ""),
          this.$emit(
            "update:modelValue",
            this.formatDateToString(t, this.format),
          ));
      },
      inputTime(e, t) {
        const o = new Date(this.valueDate),
          i = parseInt(t.target.value) || 0,
          r = Ho(i, 0, 59);
        ((t.target.value = Ee(r, 2) ?? ""),
          o[e].call(o, r),
          this.$emit(
            "update:modelValue",
            this.formatDateToString(o, this.format),
          ));
      },
      onTimeInputFocus(e) {
        e.target.select && e.target.select();
      },
    },
  };
function Ee(e, t) {
  return typeof e < "u"
    ? e.toString().length > t
      ? e.toString()
      : new Array(t - e.toString().length + 1).join("0") + e
    : void 0;
}
function Ps(e, t) {
  const o = [];
  for (; e.length;) o.push(e.splice(0, t));
  return o;
}
function jo(e, t) {
  return (
    e.getDate() === t.getDate() &&
    e.getMonth() === t.getMonth() &&
    e.getFullYear() === t.getFullYear()
  );
}
function Ko(e, t) {
  const o = [];
  for (let i = e; i <= t; i++) o.push(i);
  return o;
}
function Wo(e) {
  const t = e % 12;
  return t === 0 ? 12 : t;
}
function $s(e, t) {
  return t ? (e === 12 ? e : e + 12) : e === 12 ? 0 : e;
}
function lo(e) {
  return e >= 12;
}
function Ho(e, t, o) {
  return Math.min(Math.max(e, t), o);
}
const Ds = { class: "calendar-input-wrapper" },
  As = ["placeholder", "readonly", "value"],
  Fs = { class: "vdpInnerWrap" },
  Es = { class: "vdpHeader" },
  Ls = ["title"],
  Ts = ["title"],
  Vs = { class: "vdpPeriodControls" },
  Ms = { class: "vdpPeriodControl" },
  Us = ["value"],
  zs = { key: 0, class: "vdpPeriodControl" },
  Os = ["value"],
  Ns = { class: "vdpTable" },
  Rs = { class: "vdpHeadCellContent" },
  Bs = ["data-id", "onClick"],
  qs = { class: "vdpCellContent" },
  js = { key: 0, class: "vdpTimeControls" },
  Ks = { class: "vdpTimeCaption" },
  Ws = { class: "vdpTimeUnit" },
  Hs = ["disabled", "value"],
  Ys = { key: 0, class: "vdpTimeSeparator" },
  Xs = { key: 1, class: "vdpTimeUnit" },
  Qs = ["disabled", "value"],
  Gs = { key: 2, class: "vdpTimeSeparator" },
  Zs = { key: 3, class: "vdpTimeUnit" },
  Js = ["disabled", "value"],
  xs = ["disabled"];
function el(e, t, o, i, r, n) {
  return (
    l(),
    p(
      "div",
      { class: le(["vdpComponent", { vdpWithInput: o.hasInputElement }]) },
      [
        Bt(
          e.$slots,
          "default",
          {
            open: n.open,
            close: n.close,
            toggle: n.toggle,
            inputValue: r.inputValue,
            processUserInput: n.processUserInput,
            valueToInputFormat: n.valueToInputFormat,
          },
          () => [
            f("div", Ds, [
              o.hasInputElement
                ? (l(),
                  p(
                    "input",
                    po(
                      { key: 0, type: "text", placeholder: o.placeholder },
                      o.inputAttributes,
                      {
                        readonly: n.isReadOnly,
                        value: r.inputValue,
                        onClick: t[0] || (t[0] = (a) => o.editable && n.open()),
                        onInput:
                          t[1] ||
                          (t[1] = (a) =>
                            o.editable && n.processUserInput(a.target?.value)),
                        onFocus: t[2] || (t[2] = (a) => o.editable && n.open()),
                        class: "form-control",
                      },
                    ),
                    null,
                    16,
                    As,
                  ))
                : v("", !0),
              f(
                "i",
                {
                  class: "calendar-icon",
                  onClick: t[3] || (t[3] = (a) => n.open()),
                },
                [
                  ...(t[16] ||
                    (t[16] = [
                      Zo(
                        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 5C4.44772 5 4 5.44772 4 6V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V6C20 5.44772 19.5523 5 19 5H5ZM2 6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V6Z" fill="#AEAEB2"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16 1C16.5523 1 17 1.44772 17 2V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V2C15 1.44772 15.4477 1 16 1Z" fill="#AEAEB2"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1C8.55228 1 9 1.44772 9 2V6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6V2C7 1.44772 7.44772 1 8 1Z" fill="#AEAEB2"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M2 10C2 9.44772 2.44772 9 3 9H21C21.5523 9 22 9.44772 22 10C22 10.5523 21.5523 11 21 11H3C2.44772 11 2 10.5523 2 10Z" fill="#AEAEB2"></path></svg>',
                        1,
                      ),
                    ])),
                ],
              ),
            ]),
          ],
        ),
        $(
          xr,
          { name: "vdp-toggle-calendar" },
          {
            default: ue(() => [
              r.opened
                ? (l(),
                  p(
                    "div",
                    {
                      key: 0,
                      class: le([
                        "vdpOuterWrap",
                        [r.positionClass, { vdpFloating: o.hasInputElement }],
                      ]),
                      ref: "outerWrap",
                      onClick:
                        t[15] ||
                        (t[15] = (...a) =>
                          n.closeViaOverlay && n.closeViaOverlay(...a)),
                    },
                    [
                      f("div", Fs, [
                        f("header", Es, [
                          f(
                            "button",
                            {
                              class: "vdpArrow vdpArrowPrev",
                              title: o.prevMonthCaption,
                              type: "button",
                              onClick:
                                t[4] || (t[4] = (a) => n.incrementMonth(-1)),
                            },
                            V(o.prevMonthCaption),
                            9,
                            Ls,
                          ),
                          f(
                            "button",
                            {
                              class: "vdpArrow vdpArrowNext",
                              type: "button",
                              title: o.nextMonthCaption,
                              onClick:
                                t[5] || (t[5] = (a) => n.incrementMonth(1)),
                            },
                            V(o.nextMonthCaption),
                            9,
                            Ts,
                          ),
                          f("div", Vs, [
                            f("div", Ms, [
                              (l(),
                              p(
                                "button",
                                {
                                  class: le(n.directionClass),
                                  key: r.currentPeriod.month,
                                  type: "button",
                                },
                                V(o.months[r.currentPeriod.month]),
                                3,
                              )),
                              J(
                                f(
                                  "select",
                                  {
                                    "onUpdate:modelValue":
                                      t[6] ||
                                      (t[6] = (a) =>
                                        (r.currentPeriod.month = a)),
                                  },
                                  [
                                    (l(!0),
                                    p(
                                      I,
                                      null,
                                      ae(
                                        o.months,
                                        (a, u) => (
                                          l(),
                                          p(
                                            "option",
                                            { value: u, key: a },
                                            V(a),
                                            9,
                                            Us,
                                          )
                                        ),
                                      ),
                                      128,
                                    )),
                                  ],
                                  512,
                                ),
                                [[Te, r.currentPeriod.month]],
                              ),
                            ]),
                            o.hideYear
                              ? v("", !0)
                              : (l(),
                                p("div", zs, [
                                  (l(),
                                  p(
                                    "button",
                                    {
                                      class: le(n.directionClass),
                                      key: r.currentPeriod.year,
                                      type: "button",
                                    },
                                    V(r.currentPeriod.year),
                                    3,
                                  )),
                                  J(
                                    f(
                                      "select",
                                      {
                                        "onUpdate:modelValue":
                                          t[7] ||
                                          (t[7] = (a) =>
                                            (r.currentPeriod.year = a)),
                                      },
                                      [
                                        (l(!0),
                                        p(
                                          I,
                                          null,
                                          ae(
                                            n.yearRange,
                                            (a) => (
                                              l(),
                                              p(
                                                "option",
                                                { value: a, key: a },
                                                V(a),
                                                9,
                                                Os,
                                              )
                                            ),
                                          ),
                                          128,
                                        )),
                                      ],
                                      512,
                                    ),
                                    [[Te, r.currentPeriod.year]],
                                  ),
                                ])),
                          ]),
                        ]),
                        f("table", Ns, [
                          f("thead", null, [
                            f("tr", null, [
                              (l(!0),
                              p(
                                I,
                                null,
                                ae(
                                  n.weekdaysSorted,
                                  (a, u) => (
                                    l(),
                                    p("th", { class: "vdpHeadCell", key: u }, [
                                      f("span", Rs, V(a), 1),
                                    ])
                                  ),
                                ),
                                128,
                              )),
                            ]),
                          ]),
                          (l(),
                          p(
                            "tbody",
                            {
                              key:
                                r.currentPeriod.year +
                                "-" +
                                r.currentPeriod.month,
                              class: le(n.directionClass),
                            },
                            [
                              (l(!0),
                              p(
                                I,
                                null,
                                ae(
                                  n.currentPeriodDates,
                                  (a, u) => (
                                    l(),
                                    p("tr", { class: "vdpRow", key: u }, [
                                      (l(!0),
                                      p(
                                        I,
                                        null,
                                        ae(
                                          a,
                                          (d) => (
                                            l(),
                                            p(
                                              "td",
                                              {
                                                class: le([
                                                  "vdpCell",
                                                  {
                                                    selectable:
                                                      o.editable && !d.disabled,
                                                    selected: d.selected,
                                                    disabled: d.disabled,
                                                    today: d.today,
                                                    outOfRange: d.outOfRange,
                                                  },
                                                ]),
                                                "data-id": d.dateKey,
                                                key: d.dateKey,
                                                onClick: (s) =>
                                                  n.selectDateItem(d),
                                              },
                                              [
                                                Bt(
                                                  e.$slots,
                                                  "cellContent",
                                                  { item: d },
                                                  () => [
                                                    f(
                                                      "div",
                                                      qs,
                                                      V(d.date.getDate()),
                                                      1,
                                                    ),
                                                  ],
                                                ),
                                              ],
                                              10,
                                              Bs,
                                            )
                                          ),
                                        ),
                                        128,
                                      )),
                                    ])
                                  ),
                                ),
                                128,
                              )),
                            ],
                            2,
                          )),
                        ]),
                        o.pickTime && n.currentTime
                          ? (l(),
                            p("div", js, [
                              f("span", Ks, V(o.setTimeCaption), 1),
                              f("div", Ws, [
                                f("pre", null, [
                                  f(
                                    "span",
                                    null,
                                    V(n.currentTime.hoursFormatted),
                                    1,
                                  ),
                                  t[17] || (t[17] = f("br", null, null, -1)),
                                ]),
                                f(
                                  "input",
                                  {
                                    type: "number",
                                    pattern: "\\d*",
                                    class: "vdpHoursInput",
                                    onInput:
                                      t[8] ||
                                      (t[8] = Go(
                                        (...a) =>
                                          n.inputHours && n.inputHours(...a),
                                        ["prevent"],
                                      )),
                                    onFocusin:
                                      t[9] ||
                                      (t[9] = (...a) =>
                                        n.onTimeInputFocus &&
                                        n.onTimeInputFocus(...a)),
                                    disabled: !o.editable,
                                    value: n.currentTime.hoursFormatted,
                                  },
                                  null,
                                  40,
                                  Hs,
                                ),
                              ]),
                              o.pickMinutes
                                ? (l(), p("span", Ys, ":"))
                                : v("", !0),
                              o.pickMinutes
                                ? (l(),
                                  p("div", Xs, [
                                    f("pre", null, [
                                      f(
                                        "span",
                                        null,
                                        V(n.currentTime.minutesFormatted),
                                        1,
                                      ),
                                      t[18] ||
                                        (t[18] = f("br", null, null, -1)),
                                    ]),
                                    o.pickMinutes
                                      ? (l(),
                                        p(
                                          "input",
                                          {
                                            key: 0,
                                            type: "number",
                                            pattern: "\\d*",
                                            class: "vdpMinutesInput",
                                            onInput:
                                              t[10] ||
                                              (t[10] = (a) =>
                                                n.inputTime("setMinutes", a)),
                                            onFocusin:
                                              t[11] ||
                                              (t[11] = (...a) =>
                                                n.onTimeInputFocus &&
                                                n.onTimeInputFocus(...a)),
                                            disabled: !o.editable,
                                            value:
                                              n.currentTime.minutesFormatted,
                                          },
                                          null,
                                          40,
                                          Qs,
                                        ))
                                      : v("", !0),
                                  ]))
                                : v("", !0),
                              o.pickSeconds
                                ? (l(), p("span", Gs, ":"))
                                : v("", !0),
                              o.pickSeconds
                                ? (l(),
                                  p("div", Zs, [
                                    f("pre", null, [
                                      f(
                                        "span",
                                        null,
                                        V(n.currentTime.secondsFormatted),
                                        1,
                                      ),
                                      t[19] ||
                                        (t[19] = f("br", null, null, -1)),
                                    ]),
                                    o.pickSeconds
                                      ? (l(),
                                        p(
                                          "input",
                                          {
                                            key: 0,
                                            type: "number",
                                            pattern: "\\d*",
                                            class: "vdpSecondsInput",
                                            onInput:
                                              t[12] ||
                                              (t[12] = (a) =>
                                                n.inputTime("setSeconds", a)),
                                            onFocusin:
                                              t[13] ||
                                              (t[13] = (...a) =>
                                                n.onTimeInputFocus &&
                                                n.onTimeInputFocus(...a)),
                                            disabled: !o.editable,
                                            value:
                                              n.currentTime.secondsFormatted,
                                          },
                                          null,
                                          40,
                                          Js,
                                        ))
                                      : v("", !0),
                                  ]))
                                : v("", !0),
                              o.use12HourClock
                                ? (l(),
                                  p(
                                    "button",
                                    {
                                      key: 4,
                                      type: "button",
                                      class: "vdp12HourToggleBtn",
                                      disabled: !o.editable,
                                      onClick:
                                        t[14] ||
                                        (t[14] = (a) =>
                                          n.set12HourClock(
                                            n.currentTime.isPM ? "AM" : "PM",
                                          )),
                                    },
                                    V(n.currentTime.isPM ? "PM" : "AM"),
                                    9,
                                    xs,
                                  ))
                                : v("", !0),
                            ]))
                          : v("", !0),
                      ]),
                    ],
                    2,
                  ))
                : v("", !0),
            ]),
            _: 3,
          },
        ),
      ],
      2,
    )
  );
}
const Ir = K(_s, [["render", el]]),
  tl = ne({
    name: "vue2-date-picker",
    components: { DatePicker: Ir },
    props: {
      modelValue: { type: [String, Object] },
      format: { type: String, default: "" },
      placeholder: { type: String, default: "" },
      hideYear: { type: Boolean, default: !1 },
    },
    emits: ["update:modelValue"],
    data() {
      return { val: this.modelValue };
    },
    computed: {
      dateFormat() {
        return ir(this.format);
      },
    },
    methods: {
      parseDate(e, t) {
        const o = It(e, t);
        if (o.isValid()) return o.toDate();
      },
      formatDate(e, t) {
        return It(e).format(t);
      },
    },
    watch: {
      val(e) {
        const t = It(e);
        this.$emit("update:modelValue", t.toDate());
      },
    },
  });
function ol(e, t, o, i, r, n) {
  const a = Ir;
  return (
    l(),
    w(
      a,
      {
        modelValue: e.val,
        "onUpdate:modelValue": t[0] || (t[0] = (u) => (e.val = u)),
        placeholder: e.placeholder,
        displayFormat: e.dateFormat,
        parseDate: e.parseDate,
        formatDate: e.formatDate,
        editable: !0,
        mobileBreakpointWidth: 767,
        inputAttributes: { readonly: !0 },
        hideYear: e.hideYear,
      },
      null,
      8,
      [
        "modelValue",
        "placeholder",
        "displayFormat",
        "parseDate",
        "formatDate",
        "hideYear",
      ],
    )
  );
}
const _r = K(tl, [["render", ol]]),
  rl = {
    name: "layer-date-text-field",
    components: { "date-picker-wrapper": _r },
    props: {
      format: { type: String },
      placeholder: { type: String },
      value: { type: String },
    },
    emits: ["update:value", "input"],
    data() {
      return { val: this.value };
    },
    watch: {
      val: {
        handler(e) {
          (this.$emit("input", e),
            this.$emit("update:value", It(e).format(ir(this.format ?? ""))));
        },
      },
    },
  };
function il(e, t, o, i, r, n) {
  const a = _r;
  return (
    l(),
    w(
      a,
      {
        style: { width: "100%" },
        modelValue: r.val,
        "onUpdate:modelValue": t[0] || (t[0] = (u) => (r.val = u)),
        format: o.format,
        placeholder: o.placeholder,
      },
      null,
      8,
      ["modelValue", "format", "placeholder"],
    )
  );
}
const Pr = K(rl, [["render", il]]),
  al = ne({
    name: "text-area",
    props: {
      value: String,
      type: String,
      minlength: Number,
      maxlength: Number,
      allowSpace: { type: Boolean, default: void 0 },
      restrict: String,
      regex: String,
      maxLines: Number,
      charLimit: Number,
    },
    data() {
      return { val: this.value };
    },
    emits: ["update:value", "input"],
    watch: {
      val(e) {
        const t =
          /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
        if (
          ((e =
            this.allowSpace === !1
              ? e.replace(t, "").replace(/[^\S\r\n]/g, "")
              : e.replace(t, "")),
          this.restrict)
        ) {
          let o;
          (this.regex
            ? (o = new RegExp(this.regex))
            : (o = this.getAllowRegex(this.restrict)),
            (e = this.replaceUnmatched(e, o, "")));
        }
        ((this.val = e),
          this.$emit("input", this.val),
          this.$emit("update:value", this.val));
      },
    },
    methods: {
      onInput(e) {
        const t = e.target;
        this.val = t.value;
      },
      onKeyPress(e) {
        if (e.key == " " && this.allowSpace === !1) {
          e.preventDefault();
          return;
        }
        if (this.type === "number") {
          if (e.keyCode < 48 || e.keyCode > 57) {
            e.preventDefault();
            return;
          }
        } else if (
          /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g.test(
            e.key,
          )
        ) {
          e.preventDefault();
          return;
        }
        if (this.restrict) {
          let t;
          if (
            (this.regex
              ? (t = new RegExp(this.regex))
              : (t = this.getAllowRegex(this.restrict)),
            !t.test(e.key))
          ) {
            e.preventDefault();
            return;
          }
        }
      },
      getAllowRegex(e) {
        switch (e) {
          case "2":
            return /^[0-9 ]+$/;
          case "3":
            return /^\d+$/;
          case "4":
            return /^[a-zA-Z ]+$/;
          case "5":
            return /^[a-zA-Z]+$/;
          default:
            return /[\s\S]/;
        }
      },
      replaceUnmatched(e, t, o = "") {
        const i = typeof t == "string" ? new RegExp(t) : t;
        return e
          .split("")
          .map((r) => (i.test(r) ? r : o))
          .join("");
      },
      onKeyup() {
        let e =
          this.val?.split(`
`) ?? [];
        if (this.charLimit) {
          const t = this.charLimit;
          for (let o = 0; o < e.length; o++) {
            if (e[o].length <= t) continue;
            let i = 0,
              r = t;
            for (; i++ <= t;) e[o].charAt(i) === " " && (r = i);
            ((e[o + 1] = e[o].substring(r) + (e[o + 1] || "")),
              (e[o] = e[o].substring(0, r)));
          }
        }
        (this.maxLines &&
          e.length > this.maxLines &&
          (e = e.slice(0, this.maxLines)),
          (this.val = e.join(`
`)));
      },
    },
  }),
  nl = ["value", "minlength", "maxlength", "rows"];
function sl(e, t, o, i, r, n) {
  return (
    l(),
    p(
      "textarea",
      {
        onInput: t[0] || (t[0] = (...a) => e.onInput && e.onInput(...a)),
        value: e.val,
        onKeypress:
          t[1] || (t[1] = (...a) => e.onKeyPress && e.onKeyPress(...a)),
        onKeyup: t[2] || (t[2] = (...a) => e.onKeyup && e.onKeyup(...a)),
        minlength: e.minlength,
        maxlength: e.maxlength,
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        spellcheck: "false",
        rows: e.maxLines ? e.maxLines : 1,
      },
      null,
      40,
      nl,
    )
  );
}
const $r = K(al, [["render", sl]]),
  ll = ne({
    name: "a2-input",
    props: {
      value: String,
      type: String,
      minlength: Number,
      maxlength: Number,
      allowSpace: { type: Boolean, default: void 0 },
      restrict: String,
      regex: String,
    },
    emits: ["update:value"],
    data() {
      return { val: this.value };
    },
    watch: {
      val(e) {
        const t =
          /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
        if (
          ((e =
            this.allowSpace === !1
              ? e.replace(t, "").replace(/\s+/g, "")
              : e.replace(t, "")),
          this.restrict)
        ) {
          let o;
          (this.regex
            ? (o = new RegExp(this.regex))
            : (o = this.getAllowRegex(this.restrict)),
            (e = this.replaceUnmatched(e, o, "")));
        }
        ((this.val = e), this.$emit("update:value", this.val));
      },
    },
    methods: {
      onInput(e) {
        const t = e.target;
        this.val = t.value;
      },
      onKeyPress(e) {
        if (e.key == " " && this.allowSpace === !1) {
          e.preventDefault();
          return;
        }
        if (this.type === "number") {
          if (e.keyCode < 48 || e.keyCode > 57) {
            e.preventDefault();
            return;
          }
        } else if (
          /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g.test(
            e.key,
          )
        ) {
          e.preventDefault();
          return;
        }
        if (this.restrict) {
          let t;
          if (
            (this.regex
              ? (t = new RegExp(this.regex))
              : (t = this.getAllowRegex(this.restrict)),
            !t.test(e.key))
          ) {
            e.preventDefault();
            return;
          }
        }
      },
      getAllowRegex(e) {
        switch (e) {
          case "2":
            return /^[0-9 ]+$/;
          case "3":
            return /^\d+$/;
          case "4":
            return /^[a-zA-Z ]+$/;
          case "5":
            return /^[a-zA-Z]+$/;
          default:
            return /./;
        }
      },
      replaceUnmatched(e, t, o = "") {
        const i = typeof t == "string" ? new RegExp(t) : t;
        return e
          .split("")
          .map((r) => (i.test(r) ? r : o))
          .join("");
      },
    },
  }),
  ul = ["value", "minlength", "maxlength"];
function dl(e, t, o, i, r, n) {
  return (
    l(),
    p(
      "input",
      {
        onInput: t[0] || (t[0] = (...a) => e.onInput && e.onInput(...a)),
        value: e.val,
        onKeypress:
          t[1] || (t[1] = (...a) => e.onKeyPress && e.onKeyPress(...a)),
        minlength: e.minlength,
        maxlength: e.maxlength,
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        spellcheck: "false",
      },
      null,
      40,
      ul,
    )
  );
}
const Dr = K(ll, [["render", dl]]),
  cl = ne({
    name: "layer-text-field",
    components: {
      "a-form-item": Oe.Item,
      "a2-input": Dr,
      "date-text": Pr,
      "text-area": $r,
    },
    emits: ["update:value"],
    props: {
      layer: { type: Object, required: !0 },
      layers: { type: Object, required: !0 },
      value: { type: [String, Object], default: () => {} },
      formState: { type: Object, default: () => ({}) },
    },
    setup() {
      const e = oe(),
        t = he(),
        { variantInfo: o } = ee(e),
        { currentArtwork: i, formValues: r } = ee(t);
      return { variantInfo: o, currentArtwork: i, formValues: r };
    },
    computed: {
      currentText() {
        return typeof this.value == "string" ? this.value : this.value?.text;
      },
      required() {
        return B(this.layer, "personalized.required", !1);
      },
      label() {
        let e = B(this.layer, "personalized.label", this.layer.title);
        return (
          this.layer?.personalized?.max &&
            this.currentText?.length &&
            (e =
              e +
              ` (${this.currentText?.length}/${this.layer.personalized.max})`),
          e
        );
      },
      fieldName() {
        return `${this.layer.layerNumber}`;
      },
      rules() {
        return [
          {
            required: !0,
            validator: async (e, t) => {
              const o = typeof t == "object" ? t?.text : t;
              return o
                ? o
                  ? o &&
                    this.layer.personalized?.min &&
                    o.length < +this.layer.personalized?.min
                    ? Promise.reject(
                        `${this.label} must be at least ${this.layer.personalized?.min} characters`,
                      )
                    : Promise.resolve()
                  : Promise.reject(`${this.label} is required`)
                : Promise.reject(`${this.label} is required`);
            },
          },
        ];
      },
      fillColorByVariant() {
        return this.layer?.colors && this.layer?.colors?.length > 0
          ? this.layer?.colors?.find((t) =>
              ar(this.variantInfo, t?.optionVariants),
            )
          : null;
      },
      fillColorByClipartMapping() {
        if (this.layer?.colors?.length && this.layer?.colorMapLayerID) {
          const e = this.layers?.find(
            (i) => i.id == this.layer?.colorMapLayerID,
          )?.layerNumber;
          if (!e) return null;
          const t = this.formState?.[e];
          if (!t) return null;
          const o = this.layer?.colors?.[t.position - 1 || 0];
          return o || null;
        }
        return null;
      },
      fillStrokeColorByClipartMapping() {
        if (
          this.layer?.strokeColors?.length &&
          this.layer?.strokeColorMapLayerID
        ) {
          const e = this.layers?.find(
            (i) => i.id == this.layer?.strokeColorMapLayerID,
          )?.layerNumber;
          if (!e) return null;
          const t = this.formState?.[e];
          if (!t) return null;
          const o = this.layer?.strokeColors?.[t.position - 1 || 0];
          return o || null;
        }
        return null;
      },
    },
    watch: {
      fillColorByVariant() {
        this.onChange(this.currentText);
      },
      fillColorByClipartMapping: {
        handler(e) {
          e &&
            ((this.currentText && this.currentText != this.value?.text) ||
              (this.value &&
                (this.value?.name != e.name || this.value?.fill != e.code))) &&
            this.onChange(this.currentText);
        },
        immediate: !0,
      },
      fillStrokeColorByClipartMapping: {
        handler(e) {
          e &&
            ((this.currentText && this.currentText != this.value?.text) ||
              (this.value &&
                (this.value?.strokeName != e.name ||
                  this.value?.stroke != e.code))) &&
            this.onChange(this.currentText);
        },
        immediate: !0,
      },
    },
    methods: {
      onChange(e) {
        if (
          this.fillColorByClipartMapping ||
          this.fillStrokeColorByClipartMapping
        ) {
          const t = {
            ...(typeof this.value == "object" ? this.value : {}),
            text: e,
            fill: this.fillColorByClipartMapping?.code,
            name: this.fillColorByClipartMapping?.name,
            stroke: this.fillStrokeColorByClipartMapping?.code,
            strokeName: this.fillStrokeColorByClipartMapping?.name,
          };
          this.$emit("update:value", { key: this.layer.layerNumber, value: t });
          return;
        }
        if (this.fillColorByVariant) {
          this.$emit("update:value", {
            key: this.layer.layerNumber,
            value: {
              ...(typeof this.value == "object" ? this.value : {}),
              fill: this.fillColorByVariant.code,
              name: this.fillColorByVariant.name,
              text: e,
            },
          });
          return;
        }
        this.$emit("update:value", { key: this.layer.layerNumber, value: e });
      },
    },
  }),
  pl = { key: 0, class: "input-count" };
function ml(e, t, o, i, r, n) {
  const a = Dr,
    u = vt,
    d = $r,
    s = Pr;
  return e.layer.restric != "7" && !e.layer?.isTextArea
    ? (l(),
      w(
        u,
        {
          key: 0,
          label: e.label,
          name: e.fieldName,
          extra: e.layer.personalized?.help,
          rules: e.rules,
        },
        {
          default: ue(() => [
            $(
              a,
              {
                type: e.layer.personalized?.numberic ? "number" : "text",
                placeholder: e.layer.personalized?.placeholder,
                maxlength: parseInt(e.layer.personalized?.max ?? "-1"),
                restrict: e.layer.restric,
                regex: e.layer.regex,
                value: e.currentText,
                "onUpdate:value": e.onChange,
                minlength: parseInt(e.layer.personalized?.min ?? "0"),
                class: "form-control",
              },
              null,
              8,
              [
                "type",
                "placeholder",
                "maxlength",
                "restrict",
                "regex",
                "value",
                "onUpdate:value",
                "minlength",
              ],
            ),
            e.layer.personalized?.max
              ? (l(),
                p(
                  "span",
                  pl,
                  V(e.currentText?.length || 0) +
                    "/" +
                    V(e.layer.personalized.max),
                  1,
                ))
              : v("", !0),
          ]),
          _: 1,
        },
        8,
        ["label", "name", "extra", "rules"],
      ))
    : e.layer.restric != "7" && e.layer?.isTextArea
      ? (l(),
        w(
          u,
          {
            key: 1,
            label: e.label,
            name: e.fieldName,
            extra: e.layer.personalized?.help,
            rules: e.rules,
          },
          {
            default: ue(() => [
              $(
                d,
                {
                  type: e.layer.personalized?.numberic ? "number" : "text",
                  placeholder: e.layer.personalized?.placeholder,
                  charLimit: e.layer.charLimit,
                  maxLines: e.layer.maxLines,
                  maxlength: parseInt(e.layer.personalized?.max ?? "-1"),
                  restrict: e.layer.restric,
                  regex: e.layer.regex,
                  minlength: parseInt(e.layer.personalized?.min ?? "0"),
                  class: "form-control",
                  value: e.currentText,
                  "onUpdate:value": e.onChange,
                },
                null,
                8,
                [
                  "type",
                  "placeholder",
                  "charLimit",
                  "maxLines",
                  "maxlength",
                  "restrict",
                  "regex",
                  "minlength",
                  "value",
                  "onUpdate:value",
                ],
              ),
            ]),
            _: 1,
          },
          8,
          ["label", "name", "extra", "rules"],
        ))
      : (l(),
        w(
          u,
          {
            key: 2,
            label: e.label,
            name: e.fieldName,
            extra: e.layer.personalized?.help,
            rules: e.rules,
          },
          {
            default: ue(() => [
              $(
                s,
                {
                  style: { width: "100%" },
                  format: e.layer.dateFormat,
                  placeholder: e.layer.personalized?.placeholder,
                  value: e.currentText,
                  "onUpdate:value": e.onChange,
                },
                null,
                8,
                ["format", "placeholder", "value", "onUpdate:value"],
              ),
            ]),
            _: 1,
          },
          8,
          ["label", "name", "extra", "rules"],
        ));
}
const Ar = K(cl, [["render", ml]]),
  fl = ye(() =>
    ge(
      () => import("./StarmapField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([6, 1, 2, 3, 4]),
      import.meta.url,
    ),
  ),
  hl = ye(() =>
    ge(
      () => import("./MapField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([7, 1, 2, 3, 4]),
      import.meta.url,
    ),
  ),
  yl = ye(() =>
    ge(
      () => import("./CalendarField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([8, 1, 2, 3, 4, 9]),
      import.meta.url,
    ),
  ),
  gl = ye(() =>
    ge(
      () => import("./ClockField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([10, 1, 2, 3, 4, 9]),
      import.meta.url,
    ),
  ),
  vl = ye(() =>
    ge(
      () => import("./PuzzleField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([11, 12, 2, 3, 1, 4, 9]),
      import.meta.url,
    ),
  ),
  wl = ye(() =>
    ge(
      () => import("./AudioField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([13, 14, 1, 2, 3, 4]),
      import.meta.url,
    ),
  ),
  kl = ye(() =>
    ge(
      () => import("./ClipartFrameField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([15, 2, 3, 1, 4]),
      import.meta.url,
    ),
  ),
  bl = ye(() =>
    ge(
      () => import("./WordSearchField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([16, 12, 2, 3, 1, 4, 9]),
      import.meta.url,
    ),
  ),
  Sl = ye(() =>
    ge(
      () => import("./WaveformField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([17, 2, 3, 1, 4, 14]),
      import.meta.url,
    ),
  ),
  Cl = ye(() =>
    ge(
      () => import("./WordCloudField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([18, 2, 3, 1, 4, 12, 9]),
      import.meta.url,
    ),
  ),
  Il = ye(() =>
    ge(
      () => import("./BirthFlowerField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([19, 20, 1, 2, 3, 4]),
      import.meta.url,
    ),
  ),
  _l = ye(() =>
    ge(
      () => import("./AIPromptField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([21, 2, 3, 1, 4, 20]),
      import.meta.url,
    ),
  ),
  Pl = ye(() =>
    ge(
      () => import("./CoordinateField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([22, 2, 3, 1, 4]),
      import.meta.url,
    ),
  ),
  $l = ye(() =>
    ge(
      () => import("./AlbumField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([23, 1, 2, 3, 4]),
      import.meta.url,
    ),
  ),
  Dl = ye(() =>
    ge(
      () => import("./RingTextField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([24, 12, 2, 3, 1, 4]),
      import.meta.url,
    ),
  ),
  Al = ye(() =>
    ge(
      () => import("./SpiralTextField.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([25, 2, 3, 1, 4]),
      import.meta.url,
    ),
  ),
  Fl = {
    Starmap: fl,
    Map: hl,
    Calendar: yl,
    Clock: gl,
    Puzzle: vl,
    Audio: wl,
    ClipartFrame: kl,
    WordSearch: bl,
    Waveform: Sl,
    WordCloud: Cl,
    BirthFlower: Il,
    AIPrompt: _l,
    Coordinate: Pl,
  },
  El = ne({
    name: "layer-form-item",
    components: {
      TextField: Ar,
      ImageField: Cr,
      OptionField: vr,
      AccessoryField: gr,
    },
    emits: ["update:value"],
    props: {
      layer: { type: Object, required: !0 },
      layers: { type: Object, required: !0 },
      artworkID: String,
      personalized: {
        type: Object,
        default() {
          return {};
        },
      },
      formState: { type: Object, required: !0 },
    },
    computed: {
      albumChildrenLayers() {
        const e = this.layer.albumId;
        return e ? this.layers.filter((t) => t.albumId === e) : [];
      },
      dynamicComponent() {
        const { type: e } = this.layer;
        return e === "Text" && this.layer.spiralEnabled
          ? Al
          : e === "Text" && this.layer.ringEnabled
            ? Dl
            : e === "Image" && this.layer.albumId
              ? $l
              : (Fl[e] ?? null);
      },
      dynamicProps() {
        const e = { layer: this.layer, formState: this.formState },
          { type: t } = this.layer;
        return (
          t === "Text" && this.layer.spiralEnabled
            ? ((e.layers = this.layers),
              (e.value = this.formState[this.layer.layerNumber]))
            : t === "Text" && this.layer.ringEnabled
              ? ((e.layers = this.layers),
                (e.value = this.formState[this.layer.layerNumber]))
              : t === "Image" && this.layer.albumId
                ? ((e.childrenLayers = this.albumChildrenLayers),
                  (e.artworkID = this.artworkID))
                : t === "Coordinate" && (e.layers = this.layers),
          e
        );
      },
    },
    methods: {
      onChange(e) {
        this.$emit("update:value", e);
      },
      checkLayerUpload: Si,
    },
  });
function Ll(e, t, o, i, r, n) {
  const a = Ar,
    u = Cr,
    d = vr,
    s = gr;
  return e.dynamicComponent
    ? (l(),
      w(
        _t(e.dynamicComponent),
        po({ key: 0 }, e.dynamicProps, { "onUpdate:value": e.onChange }),
        null,
        16,
        ["onUpdate:value"],
      ))
    : e.layer.type === "Text"
      ? (l(),
        w(
          a,
          {
            key: 1,
            layer: e.layer,
            layers: e.layers,
            value: e.formState[e.layer.layerNumber],
            formState: e.formState,
            "onUpdate:value": e.onChange,
          },
          null,
          8,
          ["layer", "layers", "value", "formState", "onUpdate:value"],
        ))
      : e.layer.type === "Image"
        ? (l(),
          w(
            u,
            {
              key: 2,
              layer: e.layer,
              layers: e.layers,
              artworkID: e.artworkID,
              formState: e.formState,
              "onUpdate:value": e.onChange,
            },
            null,
            8,
            ["layer", "layers", "artworkID", "formState", "onUpdate:value"],
          ))
        : e.layer.type === "Option"
          ? (l(),
            w(
              d,
              {
                key: 3,
                layer: e.layer,
                formState: e.formState,
                "onUpdate:value": e.onChange,
              },
              null,
              8,
              ["layer", "formState", "onUpdate:value"],
            ))
          : e.layer.type === "Accessory"
            ? (l(),
              w(
                s,
                {
                  key: 4,
                  layer: e.layer,
                  formState: e.formState,
                  "onUpdate:value": e.onChange,
                },
                null,
                8,
                ["layer", "formState", "onUpdate:value"],
              ))
            : v("", !0);
}
const Fr = K(El, [["render", Ll]]),
  Tl = ne({
    name: "personalized-form",
    props: {
      artwork: { type: Object, required: !0 },
      form: { type: Object, required: !0 },
      formId: { type: String, default: "" },
      showDrawer: { type: Boolean, default: !0 },
      wrapInForm: { type: Boolean, default: !1 },
    },
    components: {
      LayerFormItem: Fr,
      TemplateField: fr,
      PreviewTopDrawer: to,
      "a-form": Oe,
    },
    provide() {
      return { personalizedFormId: this.formId || null };
    },
    data() {
      return {
        layers: [],
        debouncedWatcher: null,
        debouncedChangeTempWatcher: null,
        valueChanges: {},
        formState: this.form,
        firstDataChangeForm: !1,
      };
    },
    setup() {
      const e = oe(),
        t = he(),
        o = Se(),
        { variantInfo: i, settings: r, product: n } = ee(e),
        { isEditDesign: a } = ee(o),
        { initialLoadArtworkForm: u } = ee(t);
      return {
        productStore: e,
        product: n,
        formStore: t,
        siteStore: o,
        variantInfo: i,
        initialLoadArtworkForm: u,
        isEditDesign: a,
        settings: r,
      };
    },
    mounted() {
      if (this.settings?.isPackMode && this.effectiveFormId) {
        const e = this.formStore.personalized[this.effectiveFormId];
        if (xe(e)) {
          const { artwork: t, formState: o } = this,
            i = t?.templates[o.template ?? 0]?.layers;
          if (i) {
            const r = Pt(this.settings, t.id),
              { clipartCategories: n } = this.productStore,
              a = no(i, r, o, n);
            this.formStore.setPersonalized({
              artworkID: this.effectiveFormId,
              data: a,
            });
          }
        }
      }
    },
    watch: {
      form(e) {
        if (
          ((this.formState = e),
          this.firstDataChangeForm || this.getLayerArtwork(),
          !this.firstDataChangeForm &&
            this.isEditDesign &&
            !this.settings?.isPackMode)
        ) {
          const t = this.isShowMockupTemplateByVariant();
          t >= 0
            ? (this.onChangeTemplate(t, this.initialLoadArtworkForm),
              this.formStore.setInitialLoadArtworkForm(!1))
            : (this.getLayerArtwork(), this.changePersonalizedForm(e));
        }
        this.formStore.isInitializingForm &&
          this.$nextTick(() => {
            this.formStore.setIsInitializingForm(!1);
          });
      },
      variantInfo: {
        handler() {
          const e = this.isShowMockupTemplateByVariant();
          (e >= 0 &&
            (this.onChangeTemplate(e, this.initialLoadArtworkForm),
            this.formStore.setInitialLoadArtworkForm(!1)),
            this.getLayerArtwork());
        },
        deep: !0,
        immediate: !0,
      },
    },
    computed: {
      isShowPreviewDrawer() {
        const { product: e, layers: t } = this,
          o = t.some(
            (i) =>
              (i.type === "Calendar" ||
                i.type === "BirthFlower" ||
                i.type === "Starmap" ||
                (i.type === "Text" && i.restric === "7")) &&
              i.isShowForm,
          );
        return !e.tags?.includes("Photo Inserted") && !o;
      },
      defaultValueArtSettings() {
        return Pt(
          this.productStore.settings,
          this.artwork?.id,
          this.form?.template,
        );
      },
      popoutLayerSet() {
        const { artwork: e } = this,
          { settings: t } = this.productStore,
          o = t.popoutLayer?.[e?.id];
        return o?.length ? new Set(o) : null;
      },
      effectiveFormId() {
        return this.formId || this.artwork?.id || "";
      },
      popoutLayers() {
        return this.popoutLayerSet
          ? this.layers.filter((e) => this.popoutLayerSet.has(e.layerNumber))
          : [];
      },
      defaultOrderLayers() {
        return this.popoutLayerSet
          ? this.layers.filter((e) => !this.popoutLayerSet.has(e.layerNumber))
          : this.layers;
      },
      renderablePopoutLayers() {
        return this.deduplicateAlbumLayers(this.popoutLayers);
      },
      renderableDefaultOrderLayers() {
        return this.deduplicateAlbumLayers(this.defaultOrderLayers);
      },
      template() {
        const {
          formState: { template: e },
        } = this;
        return e;
      },
      isLoadingTemplate() {
        const { loadings: e } = this.siteStore;
        return B(e, `${this.artwork?.id}.template`, !1);
      },
      mockupTemplates() {
        const { mockups: e, selectedVariant: t } = this.productStore,
          o =
            e.length === 1
              ? e[0]
              : e?.find((r) => r.layers?.some((n) => n.variantID === t));
        return (
          (
            o?.layers?.find(
              (r) => r.type === "Group" && r.artworkID === this.artwork?.id,
            ) ?? o?.layers?.find((r) => r.type === "Group")
          )?.templates ?? []
        );
      },
      isShowTemplate() {
        return !(
          (this.artwork?.templates.length > 1 &&
            this.artwork?.templateDisplayMode == "variant") ||
          this.artwork?.templates.length == 1 ||
          (this.mockupTemplates.length > 1 &&
            this.mockupTemplates?.[this.formState.template]?.detailTemplate
              ?.optionVariants &&
            this.mockupTemplates?.[this.formState.template]?.detailTemplate
              ?.optionVariants?.length > 0)
        );
      },
    },
    methods: {
      deduplicateAlbumLayers(e) {
        const t = new Set();
        return e.filter((o) => {
          const i = o.albumId;
          return i ? (t.has(i) ? !1 : (t.add(i), !0)) : !0;
        });
      },
      getLayerArtwork() {
        const { artwork: e, formState: t } = this,
          { settings: o } = this.productStore;
        let { template: i } = t,
          r;
        e?.templates?.length == 1 && (i = 0);
        const n = Ci(e);
        if (i == null)
          if (
            o.popoutLayer &&
            o.popoutLayer[e?.id] &&
            o.popoutLayer[e?.id].length > 0
          ) {
            const u = e?.templates[0].layers,
              d = n ? Io(u) : u;
            r = _o(Po(d.filter((s) => ($o(s, d) || !so(s)) && s.visible)));
          } else return [];
        else {
          const u = e?.templates[i].layers,
            d = n ? Io(u) : u;
          r = _o(
            Po(
              d.filter(
                (s) =>
                  (!so(s) && s.type == "Option") ||
                  (($o(s, d) || (!so(s) && s?.personalized?.enable)) &&
                    s.visible),
              ),
            ),
          );
        }
        const a =
          o?.ordering && o?.ordering[`${e?.id}`]
            ? B(o, `ordering[${e?.id}][${i || 0}]`, [])
            : B(o, `ordering[artwork][${i || 0}]`, []);
        if (a) {
          const u = a && a[0] && typeof a[0] == "number",
            d = Qt([...a, ...r.map((c) => (u ? c.layerNumber : c.id))]),
            s = new Map(d.map((c, h) => [c, h]));
          r = r.sort(
            (c, h) =>
              (s.get(u ? c.layerNumber : c.id) ?? 1 / 0) -
              (s.get(u ? h.layerNumber : h.id) ?? 1 / 0),
          );
        }
        this.layers = r.map((u) => ({
          ...u,
          isShowForm: this.checkConditionFormChange(u, r),
        }));
      },
      checkConditionFormChange(e, t) {
        const { formState: o } = this,
          i = e.parentConditions ? Ii : _i;
        return this.handleShowImage(e) && i(e, o, t);
      },
      handleShowImage(e) {
        const { variantInfo: t } = this.productStore;
        return ar(t, e?.optionVariants);
      },
      isShowMockupTemplateByVariant() {
        const { variantInfo: e } = this.productStore,
          t = this.mockupTemplates || [];
        return e?.option?.length
          ? t.findIndex((o) => {
              const i = o.detailTemplate?.optionVariants;
              if (!i?.length) return !1;
              const r = new Map(i.map((n) => [n.key, n.value]));
              return e.option.every(({ name: n, value: a }) =>
                r
                  .get(n)
                  ?.some((d) => d.checked && d.name === n && d.value === a),
              );
            })
          : -1;
      },
      onChangeTemplate(e, t = !1) {
        const { formStore: o, productStore: i, siteStore: r } = this,
          { setPersonalized: n } = o,
          { setLoadings: a } = r;
        if (
          (a({ artworkID: this.artwork?.id, key: "template", loading: !0 }),
          o.setTemplateArtwork(e),
          this.formState.template == e)
        ) {
          (this.getLayerArtwork(),
            a({ artworkID: this.artwork?.id, key: "template", loading: !1 }));
          return;
        }
        ((this.formState.template = e),
          this.getLayerArtwork(),
          this.debouncedChangeTempWatcher &&
            clearTimeout(this.debouncedChangeTempWatcher),
          (this.debouncedChangeTempWatcher = setTimeout(() => {
            const u = Pi(this.artwork?.templates[e ?? 0].layers);
            this.formState = {
              ...this.formState,
              template: e,
              ...this.valueChanges,
            };
            const d = no(
              u,
              this.defaultValueArtSettings,
              this.formState,
              i.clipartCategories,
            );
            if (!d) {
              a({ artworkID: this.artwork?.id, key: "template", loading: !1 });
              return;
            }
            (xe(this.valueChanges) ||
              (this.getLayerArtwork(), (this.valueChanges = {})),
              this.handleSaveForm(this.formState, t),
              a({ artworkID: this.artwork?.id, key: "template", loading: !1 }),
              n({ artworkID: this.effectiveFormId, data: d }));
          }, 600)));
      },
      onFormItemChange(e) {
        if (this.formStore.isInitializingForm) return;
        if (this.isLoadingTemplate) {
          Object.assign(this.valueChanges, { [e.key]: e.value });
          return;
        }
        this.formState[e.key] = e.value;
        const t = { [e.key]: e.value };
        (xe(e.value) && !this.firstDataChangeForm) ||
          (this.handleLogicFormLayers(t), this.handlePersonalizedWatcher(t));
      },
      handleLogicFormLayers(e) {
        const t = new Map(),
          o = new Set();
        for (const i in e) {
          if (i == "template") break;
          if (i.includes("category") || i.includes("accessory")) continue;
          const r = this.layers.filter(
            (n) =>
              (n.condition &&
                n.condition.enable &&
                n.condition.rules &&
                n.condition.rules.some((a) => a.option == +i)) ||
              n.parentConditions?.some(
                (a) => a.enable && a.rules?.some((u) => u.option == +i),
              ),
          );
          if (r.length != 0) for (const n of r) this.handleLayerForm(t, n, o);
        }
        this.layers = this.layers.map((i) =>
          t.has(i.id) ? { ...i, isShowForm: t.get(i.id) } : i,
        );
      },
      handleLayerForm(e, t, o) {
        if (o.has(t.id)) return;
        o.add(t.id);
        const i = this.checkConditionFormChange(t, this.layers);
        e.set(t.id, i);
        const r = this.layers.filter(
          (n) =>
            n.condition &&
            n.condition.enable &&
            n.condition.rules &&
            n.condition.rules.some(
              (a) =>
                a.option == t.layerNumber &&
                (a.option_id ? a.option_id == t.id : !0),
            ),
        );
        if (r.length != 0) for (const n of r) this.handleLayerForm(e, n, o);
      },
      handlePersonalizedWatcher(e) {
        const t = this.isChangePersonalized(e);
        if (t) {
          if (typeof t != "boolean" && t == "realtime") {
            (Object.assign(this.valueChanges, e),
              this.debouncedWatcher && clearTimeout(this.debouncedWatcher),
              this.changePersonalizedForm(this.valueChanges));
            return;
          }
          (Object.assign(this.valueChanges, e),
            this.debouncedWatcher && clearTimeout(this.debouncedWatcher),
            (this.debouncedWatcher = setTimeout(() => {
              this.changePersonalizedForm(this.valueChanges);
            }, 400)));
        }
      },
      isChangePersonalized(e) {
        for (const t in e) {
          if (t == "template") return !1;
          if (t.includes("category") || t.includes("accessory")) return !0;
          if (!isNaN(+t)) continue;
          const o = e[t];
          if (
            typeof o == "string" ||
            (typeof o == "object" && (o?.filter || o?.imgSrc))
          )
            return "realtime";
        }
        return !0;
      },
      changePersonalizedForm(e) {
        const { artwork: t } = this,
          o = qt(this.effectiveFormId);
        o &&
          o.packIndex !== this.formStore.activePackIndex &&
          !this.formStore._artworkSwitchGuard &&
          this.formStore.setActivePackIndex(o.packIndex);
        const i = ot(this.formState),
          { clipartCategories: r } = this.productStore,
          { personalized: n } = this.formStore,
          a = n[this.effectiveFormId],
          u = t?.templates[i.template ?? 0].layers;
        let d;
        if (xe(a) || !this.firstDataChangeForm) {
          const s = Pt(this.settings, t.id);
          d = no(u, s, i, r);
        } else d = $i({ ...a }, u, e, i, r);
        (this.formStore.setPersonalized({
          artworkID: this.effectiveFormId,
          data: d,
        }),
          this.handleSaveForm(this.formState),
          (this.valueChanges = {}),
          o &&
            this.productStore.artworks.length > 1 &&
            Di(o.artworkId, o.packIndex, this.formState));
      },
      handleSaveForm(e, t = !1) {
        const { artwork: o } = this;
        this.formStore.setFormValues({
          formID: this.effectiveFormId,
          values: e,
        });
        const i = B(e, "template");
        if (!this.firstDataChangeForm) {
          if (o?.templates && i == null && o?.templates?.length > 1) {
            const r = Jo(e, ["template"]);
            if (xe(r)) return;
          }
          (e &&
            !this.firstDataChangeForm &&
            !t &&
            !this.formStore.isInitializingForm &&
            (console.log("show canvas"),
            window.dispatchEvent(new CustomEvent(rt.SHOW_CANVAS_PREVIEW))),
            !t &&
              !this.formStore.isInitializingForm &&
              (this.firstDataChangeForm = !0));
        }
      },
    },
  });
function Vl(e, t, o, i, r, n) {
  const a = Fr,
    u = fr,
    d = Oe,
    s = to;
  return (
    l(),
    p(
      I,
      null,
      [
        e.wrapInForm
          ? (l(),
            w(
              d,
              {
                key: 0,
                ref: "packFormRef",
                model: e.formState,
                scrollToFirstError: !0,
                class: "pack-inner-form",
              },
              {
                default: ue(() => [
                  (l(!0),
                  p(
                    I,
                    null,
                    ae(
                      e.renderablePopoutLayers,
                      (c) => (
                        l(),
                        p(
                          I,
                          null,
                          [
                            c.isShowForm
                              ? (l(),
                                w(
                                  a,
                                  {
                                    key: c.id,
                                    layer: c,
                                    layers: e.layers,
                                    formState: e.formState,
                                    "onUpdate:value": e.onFormItemChange,
                                  },
                                  null,
                                  8,
                                  [
                                    "layer",
                                    "layers",
                                    "formState",
                                    "onUpdate:value",
                                  ],
                                ))
                              : v("", !0),
                          ],
                          64,
                        )
                      ),
                    ),
                    256,
                  )),
                  e.isShowTemplate
                    ? (l(),
                      w(
                        u,
                        {
                          key: "template",
                          artwork: e.artwork,
                          value: e.formState.template,
                          "onUpdate:value": e.onChangeTemplate,
                        },
                        null,
                        8,
                        ["artwork", "value", "onUpdate:value"],
                      ))
                    : v("", !0),
                  (l(!0),
                  p(
                    I,
                    null,
                    ae(
                      e.renderableDefaultOrderLayers,
                      (c) => (
                        l(),
                        p(
                          I,
                          null,
                          [
                            e.form.template != null && c.isShowForm
                              ? (l(),
                                w(
                                  a,
                                  {
                                    key: c.id,
                                    layer: c,
                                    layers: e.layers,
                                    formState: e.formState,
                                    artworkID: e.artwork?.id,
                                    "onUpdate:value": e.onFormItemChange,
                                  },
                                  null,
                                  8,
                                  [
                                    "layer",
                                    "layers",
                                    "formState",
                                    "artworkID",
                                    "onUpdate:value",
                                  ],
                                ))
                              : v("", !0),
                          ],
                          64,
                        )
                      ),
                    ),
                    256,
                  )),
                ]),
                _: 1,
              },
              8,
              ["model"],
            ))
          : (l(),
            p(
              I,
              { key: 1 },
              [
                (l(!0),
                p(
                  I,
                  null,
                  ae(
                    e.renderablePopoutLayers,
                    (c) => (
                      l(),
                      p(
                        I,
                        null,
                        [
                          c.isShowForm
                            ? (l(),
                              w(
                                a,
                                {
                                  key: c.id,
                                  layer: c,
                                  layers: e.layers,
                                  formState: e.formState,
                                  "onUpdate:value": e.onFormItemChange,
                                },
                                null,
                                8,
                                [
                                  "layer",
                                  "layers",
                                  "formState",
                                  "onUpdate:value",
                                ],
                              ))
                            : v("", !0),
                        ],
                        64,
                      )
                    ),
                  ),
                  256,
                )),
                e.isShowTemplate
                  ? (l(),
                    w(
                      u,
                      {
                        key: "template",
                        artwork: e.artwork,
                        value: e.formState.template,
                        "onUpdate:value": e.onChangeTemplate,
                      },
                      null,
                      8,
                      ["artwork", "value", "onUpdate:value"],
                    ))
                  : v("", !0),
                (l(!0),
                p(
                  I,
                  null,
                  ae(
                    e.renderableDefaultOrderLayers,
                    (c) => (
                      l(),
                      p(
                        I,
                        null,
                        [
                          e.form.template != null && c.isShowForm
                            ? (l(),
                              w(
                                a,
                                {
                                  key: c.id,
                                  layer: c,
                                  layers: e.layers,
                                  formState: e.formState,
                                  artworkID: e.artwork?.id,
                                  "onUpdate:value": e.onFormItemChange,
                                },
                                null,
                                8,
                                [
                                  "layer",
                                  "layers",
                                  "formState",
                                  "artworkID",
                                  "onUpdate:value",
                                ],
                              ))
                            : v("", !0),
                        ],
                        64,
                      )
                    ),
                  ),
                  256,
                )),
              ],
              64,
            )),
        (l(),
        w(tt, { to: "body" }, [
          e.showDrawer
            ? (l(),
              w(
                s,
                {
                  key: 0,
                  show:
                    e.firstDataChangeForm &&
                    !e.isEditDesign &&
                    e.isShowPreviewDrawer,
                },
                null,
                8,
                ["show"],
              ))
            : v("", !0),
        ])),
      ],
      64,
    )
  );
}
const Er = K(Tl, [["render", Vl]]),
  Ml = ye(() =>
    ge(
      () => import("./PackItemTabs.js?v=1-0-2-28d679f1"),
      __vite__mapDeps([26, 1, 2, 3, 4]),
      import.meta.url,
    ),
  ),
  Ul = ne({
    name: "artwork-form",
    components: { "a-form": Oe, "personalized-form": Er, PreviewTopDrawer: to },
    props: {
      value: {
        type: Object,
        default() {
          return { template: null };
        },
      },
      artwork: { type: Object, require: !0 },
      isDevEnv: {
        type: Boolean,
        default() {
          return !1;
        },
      },
      showPreview: {
        type: Boolean,
        default() {
          return !1;
        },
      },
      packFormId: { type: String, default: "" },
      packItemIds: { type: Array, default: () => [] },
      packFormValues: { type: Object, default: () => ({}) },
    },
    setup() {
      const e = oe(),
        t = he(),
        o = Se(),
        { uploadStates: i, qty: r } = ee(t),
        { selectedVariant: n, product: a } = ee(e),
        { isEditDesign: u } = ee(o),
        d = Le();
      return {
        productStore: e,
        formStore: t,
        formRef: d,
        uploadStates: i,
        qty: r,
        selectedVariant: n,
        product: a,
        isEditDesign: u,
        LazyPackItemTabs: Ml,
      };
    },
    data() {
      return { debouncedChangeTempWatcher: null, packFormDataChanged: !1 };
    },
    mounted() {
      const { formStore: e } = this;
      (window.addEventListener("pageshow", this.handlePageShow),
        e.setCurrentArtwork(this.packFormId || this.artwork?.id),
        this.isPackLayout &&
          this.$emitter.on("canvas-after-render", this.onPackFormDataChanged));
    },
    beforeUnmount() {
      (window.removeEventListener("pageshow", this.handlePageShow),
        this.isPackLayout &&
          this.$emitter.off("canvas-after-render", this.onPackFormDataChanged));
    },
    watch: {
      artwork(e) {
        e?.id && this.formStore.setCurrentArtwork(e.id);
      },
      uploadStates: {
        handler(e) {
          const { formStore: t } = this;
          Object.values(e).some(Boolean)
            ? t.setLoadingATC(!0)
            : t.setLoadingATC(!1);
        },
        deep: !0,
      },
    },
    computed: {
      isShowPersonalized() {
        const { settings: e } = this.productStore;
        return !e?.isNoneCustom;
      },
      effectiveFormId() {
        return this.packFormId || this.artwork?.id || "";
      },
      isPackLayout() {
        return this.packItemIds.length > 0;
      },
      packItemLabel() {
        return this.product?.product_type || this.product?.type || "Item";
      },
      isShowPreviewDrawer() {
        if (!this.artwork) return !1;
        const t = (this.artwork.layers || []).some(
          (o) =>
            (o.type === "Calendar" ||
              o.type === "BirthFlower" ||
              o.type === "Starmap" ||
              (o.type === "Text" && o.restric === "7")) &&
            o.isShowForm,
        );
        return !this.product?.tags?.includes("Photo Inserted") && !t;
      },
    },
    methods: {
      async onPreview(e) {
        (e.preventDefault(), e.stopPropagation());
        let t;
        if (
          (this.isPackLayout
            ? (t = await this.validatePack())
            : (t = !!(await this.formRef?.validate())),
          !t)
        ) {
          this.setShowPreview(!1);
          return;
        }
        (await new Promise((o) => {
          const i = () => {
            (this.$emitter.off("canvas-rendered", i), o());
          };
          (this.$emitter.on("canvas-rendered", i),
            window.dispatchEvent(new CustomEvent(rt.CANVAS_RENDERED)));
        }),
          this.setShowPreview(!0));
      },
      setShowPreview(e) {
        this.formStore.setShowPreview(e);
      },
      async validatePack() {
        const e = this.$refs;
        for (let t = 0; t < this.packItemIds.length; t++) {
          const o = `packForm_${t}`,
            i = e[o],
            r = Array.isArray(i) ? i[0] : i;
          if (r?.$refs?.packFormRef?.validate)
            try {
              await r.$refs.packFormRef.validate();
            } catch {
              (this.formStore.setActivePackIndex(t), await mo());
              const n = document.getElementById(`pack-item-${t}`);
              return (
                n && n.scrollIntoView({ behavior: "smooth", block: "center" }),
                !1
              );
            }
        }
        return !0;
      },
      handlePageShow(e) {
        e.persisted &&
          (document
            .querySelectorAll(".preview-actions .btn.add_to_cart")
            .forEach((t) => {
              t.classList.remove("disabled");
            }),
          window.location.reload());
      },
      onPackFormDataChanged() {
        this.packFormDataChanged = !0;
      },
    },
  }),
  zl = { key: 0, class: "personalized-form" },
  Ol = { class: "box-customize" },
  Nl = ["id"],
  Rl = { key: 0, class: "pack-item-divider" },
  Bl = { key: 0 },
  ql = { key: 0, class: "btn-preview hidden-xl" },
  jl = ["value"],
  Kl = ["value"],
  Wl = ["value"],
  Hl = ["id"],
  Yl = { key: 0, class: "pack-item-divider" },
  Xl = ["id"],
  Ql = { key: 0, class: "pack-item-divider" },
  Gl = { class: "box-customize" },
  Zl = { key: 0 },
  Jl = { key: 0, class: "btn-preview hidden-xl" },
  xl = ["value"],
  eu = ["value"],
  tu = ["value"],
  ou = {
    key: 2,
    style: {
      "background-color": "#fff3cd",
      color: "#664d03",
      "margin-bottom": "20px",
      padding: "5px 10px",
      border: "1px solid #ffecb5",
      "border-radius": "3px",
    },
  };
function ru(e, t, o, i, r, n) {
  const a = Er,
    u = to,
    d = Oe;
  return e.isShowPersonalized
    ? (l(),
      p(
        I,
        { key: 0 },
        [
          e.isPackLayout && e.artwork
            ? (l(),
              p("div", zl, [
                e.isDevEnv && !e.isEditDesign
                  ? (l(),
                    p(
                      I,
                      { key: 0 },
                      [
                        f("div", Ol, [
                          (l(),
                          w(
                            _t(e.LazyPackItemTabs),
                            { packItemIds: e.packItemIds },
                            null,
                            8,
                            ["packItemIds"],
                          )),
                          t[4] ||
                            (t[4] = f(
                              "span",
                              { class: "title-customize" },
                              "PERSONALIZED",
                              -1,
                            )),
                          (l(!0),
                          p(
                            I,
                            null,
                            ae(
                              e.packItemIds,
                              (s, c) => (
                                l(),
                                p(
                                  "div",
                                  {
                                    key: s,
                                    id: `pack-item-${c}`,
                                    class: "pack-item-section",
                                  },
                                  [
                                    e.packItemIds.length > 1
                                      ? (l(),
                                        p("div", Rl, [
                                          f(
                                            "span",
                                            null,
                                            V(e.packItemLabel) + " " + V(c + 1),
                                            1,
                                          ),
                                        ]))
                                      : v("", !0),
                                    $(
                                      a,
                                      {
                                        ref_for: !0,
                                        ref: `packForm_${c}`,
                                        artwork: e.artwork,
                                        form: e.packFormValues[s] || e.value,
                                        formId: s,
                                        showDrawer: !1,
                                        wrapInForm: !0,
                                      },
                                      null,
                                      8,
                                      ["artwork", "form", "formId"],
                                    ),
                                  ],
                                  8,
                                  Nl,
                                )
                              ),
                            ),
                            128,
                          )),
                        ]),
                        e.showPreview
                          ? (l(),
                            p("div", Bl, [
                              f(
                                "button",
                                {
                                  onClick:
                                    t[0] ||
                                    (t[0] = (...s) =>
                                      e.onPreview && e.onPreview(...s)),
                                  class: "btn btn-preview preview-new-app",
                                },
                                V("Preview Your Personalization"),
                              ),
                              e.isDevEnv
                                ? (l(),
                                  p("div", ql, [
                                    f(
                                      "a",
                                      {
                                        id: "btn-preview",
                                        href: "#",
                                        class: "button new-app-preview-button",
                                        onClick:
                                          t[1] ||
                                          (t[1] = (...s) =>
                                            e.onPreview && e.onPreview(...s)),
                                      },
                                      " Preview Your Personalization ",
                                    ),
                                  ]))
                                : v("", !0),
                            ]))
                          : v("", !0),
                      ],
                      64,
                    ))
                  : e.isEditDesign
                    ? (l(),
                      p(
                        I,
                        { key: 1 },
                        [
                          t[5] ||
                            (t[5] = f(
                              "input",
                              {
                                type: "hidden",
                                name: "form_type",
                                value: "product",
                              },
                              null,
                              -1,
                            )),
                          t[6] ||
                            (t[6] = f(
                              "input",
                              { type: "hidden", name: "utf8", value: "✓" },
                              null,
                              -1,
                            )),
                          f(
                            "input",
                            {
                              type: "hidden",
                              name: "id",
                              value: e.selectedVariant,
                              class: "product-variant-id",
                            },
                            null,
                            8,
                            jl,
                          ),
                          f(
                            "input",
                            { type: "hidden", name: "quantity", value: e.qty },
                            null,
                            8,
                            Kl,
                          ),
                          f(
                            "input",
                            {
                              type: "hidden",
                              name: "product-id",
                              value: e.product.id,
                            },
                            null,
                            8,
                            Wl,
                          ),
                          (l(),
                          w(
                            _t(e.LazyPackItemTabs),
                            { packItemIds: e.packItemIds },
                            null,
                            8,
                            ["packItemIds"],
                          )),
                          (l(!0),
                          p(
                            I,
                            null,
                            ae(
                              e.packItemIds,
                              (s, c) => (
                                l(),
                                p(
                                  "div",
                                  {
                                    key: s,
                                    id: `pack-item-${c}`,
                                    class: "pack-item-section",
                                  },
                                  [
                                    e.packItemIds.length > 1
                                      ? (l(),
                                        p("div", Yl, [
                                          f(
                                            "span",
                                            null,
                                            V(e.packItemLabel) + " " + V(c + 1),
                                            1,
                                          ),
                                        ]))
                                      : v("", !0),
                                    $(
                                      a,
                                      {
                                        ref_for: !0,
                                        ref: `packForm_${c}`,
                                        artwork: e.artwork,
                                        form: e.packFormValues[s] || e.value,
                                        formId: s,
                                        showDrawer: !1,
                                        wrapInForm: !0,
                                      },
                                      null,
                                      8,
                                      ["artwork", "form", "formId"],
                                    ),
                                  ],
                                  8,
                                  Hl,
                                )
                              ),
                            ),
                            128,
                          )),
                        ],
                        64,
                      ))
                    : (l(),
                      p(
                        I,
                        { key: 2 },
                        [
                          (l(),
                          w(
                            _t(e.LazyPackItemTabs),
                            { packItemIds: e.packItemIds },
                            null,
                            8,
                            ["packItemIds"],
                          )),
                          (l(!0),
                          p(
                            I,
                            null,
                            ae(
                              e.packItemIds,
                              (s, c) => (
                                l(),
                                p(
                                  "div",
                                  {
                                    key: s,
                                    id: `pack-item-${c}`,
                                    class: "pack-item-section",
                                  },
                                  [
                                    e.packItemIds.length > 1
                                      ? (l(),
                                        p("div", Ql, [
                                          f(
                                            "span",
                                            null,
                                            V(e.packItemLabel) + " " + V(c + 1),
                                            1,
                                          ),
                                        ]))
                                      : v("", !0),
                                    $(
                                      a,
                                      {
                                        ref_for: !0,
                                        ref: `packForm_${c}`,
                                        artwork: e.artwork,
                                        form: e.packFormValues[s] || e.value,
                                        formId: s,
                                        showDrawer: !1,
                                        wrapInForm: !0,
                                      },
                                      null,
                                      8,
                                      ["artwork", "form", "formId"],
                                    ),
                                  ],
                                  8,
                                  Xl,
                                )
                              ),
                            ),
                            128,
                          )),
                        ],
                        64,
                      )),
                (l(),
                w(tt, { to: "body" }, [
                  e.isEditDesign
                    ? v("", !0)
                    : (l(),
                      w(
                        u,
                        {
                          key: 0,
                          show: e.packFormDataChanged && e.isShowPreviewDrawer,
                        },
                        null,
                        8,
                        ["show"],
                      )),
                ])),
              ]))
            : e.artwork
              ? (l(),
                w(
                  d,
                  {
                    key: 1,
                    class: "personalized-form",
                    model: e.value,
                    ref: "formRef",
                    scrollToFirstError: !0,
                  },
                  {
                    default: ue(() => [
                      e.isDevEnv && !e.isEditDesign
                        ? (l(),
                          p(
                            I,
                            { key: 0 },
                            [
                              f("div", Gl, [
                                t[7] ||
                                  (t[7] = f(
                                    "span",
                                    { class: "title-customize" },
                                    "PERSONALIZED",
                                    -1,
                                  )),
                                $(
                                  a,
                                  {
                                    artwork: e.artwork,
                                    form: e.value,
                                    formId: e.effectiveFormId,
                                  },
                                  null,
                                  8,
                                  ["artwork", "form", "formId"],
                                ),
                              ]),
                              e.showPreview
                                ? (l(),
                                  p("div", Zl, [
                                    f(
                                      "button",
                                      {
                                        onClick:
                                          t[2] ||
                                          (t[2] = (...s) =>
                                            e.onPreview && e.onPreview(...s)),
                                        class:
                                          "btn btn-preview preview-new-app",
                                      },
                                      V("Preview Your Personalization"),
                                    ),
                                    e.isDevEnv
                                      ? (l(),
                                        p("div", Jl, [
                                          f(
                                            "a",
                                            {
                                              id: "btn-preview",
                                              href: "#",
                                              class:
                                                "button new-app-preview-button",
                                              onClick:
                                                t[3] ||
                                                (t[3] = (...s) =>
                                                  e.onPreview &&
                                                  e.onPreview(...s)),
                                            },
                                            " Preview Your Personalization ",
                                          ),
                                        ]))
                                      : v("", !0),
                                  ]))
                                : v("", !0),
                            ],
                            64,
                          ))
                        : e.isEditDesign
                          ? (l(),
                            p(
                              I,
                              { key: 1 },
                              [
                                t[8] ||
                                  (t[8] = f(
                                    "input",
                                    {
                                      type: "hidden",
                                      name: "form_type",
                                      value: "product",
                                    },
                                    null,
                                    -1,
                                  )),
                                t[9] ||
                                  (t[9] = f(
                                    "input",
                                    {
                                      type: "hidden",
                                      name: "utf8",
                                      value: "✓",
                                    },
                                    null,
                                    -1,
                                  )),
                                f(
                                  "input",
                                  {
                                    type: "hidden",
                                    name: "id",
                                    value: e.selectedVariant,
                                    class: "product-variant-id",
                                  },
                                  null,
                                  8,
                                  xl,
                                ),
                                f(
                                  "input",
                                  {
                                    type: "hidden",
                                    name: "quantity",
                                    value: e.qty,
                                  },
                                  null,
                                  8,
                                  eu,
                                ),
                                f(
                                  "input",
                                  {
                                    type: "hidden",
                                    name: "product-id",
                                    value: e.product.id,
                                  },
                                  null,
                                  8,
                                  tu,
                                ),
                                $(
                                  a,
                                  {
                                    artwork: e.artwork,
                                    form: e.value,
                                    formId: e.effectiveFormId,
                                  },
                                  null,
                                  8,
                                  ["artwork", "form", "formId"],
                                ),
                              ],
                              64,
                            ))
                          : (l(),
                            w(
                              a,
                              {
                                key: 2,
                                artwork: e.artwork,
                                form: e.value,
                                formId: e.effectiveFormId,
                              },
                              null,
                              8,
                              ["artwork", "form", "formId"],
                            )),
                    ]),
                    _: 1,
                  },
                  8,
                  ["model"],
                ))
              : (l(), p("div", ou, " Artwork not available ")),
        ],
        64,
      ))
    : v("", !0);
}
const uo = K(Ul, [
    ["render", ru],
    ["__scopeId", "data-v-2b78a8de"],
  ]),
  iu = ne({
    name: "qty",
    components: { Icon: dt },
    data() {
      return { quantity: 0, select: !0 };
    },
    setup() {
      const e = Se(),
        t = he(),
        { isEditDesign: o } = ee(e),
        { qty: i } = ee(t);
      return { formStore: t, isEditDesign: o, qty: i };
    },
    mounted() {
      this.quantity = this.qty;
    },
    watch: {
      quantity(e) {
        (e > 10 && (this.select = !1), this.formStore.setQty(e));
      },
      qty(e) {
        this.quantity !== e && (this.quantity = e);
      },
    },
    methods: {
      onKeyDown(e) {
        const t = e.keyCode;
        if ((t >= 37 && t <= 40) || t === 8 || t === 46) return;
        /^\d+$/.test(e.key) || e.preventDefault();
      },
      onBlur() {
        console.log(this.quantity);
        const e = /^\d+$/;
        (this.quantity < 1 || !e.test(this.quantity.toString())) &&
          (this.quantity = 1);
      },
      decreaseQty() {
        this.quantity > 1 && this.quantity--;
      },
      increaseQty() {
        this.quantity++;
      },
    },
  }),
  au = { key: 0 },
  nu = { key: 2, class: "qty-control__wrapper" },
  su = { class: "qty-control" },
  lu = ["disabled"];
function uu(e, t, o, i, r, n) {
  const a = dt;
  return (
    l(),
    p(
      "div",
      { class: le(`cart-qty ${e.isEditDesign ? "cart-qty-edit-design" : ""}`) },
      [
        e.select && !e.isEditDesign
          ? (l(), p("label", au, "quantity"))
          : v("", !0),
        e.select && !e.isEditDesign
          ? J(
              (l(),
              p(
                "select",
                {
                  key: 1,
                  "onUpdate:modelValue":
                    t[0] || (t[0] = (u) => (e.quantity = u)),
                  placeholder: "Qty",
                  class: "form-select",
                },
                [
                  ...(t[6] ||
                    (t[6] = [
                      Zo(
                        '<option value="1" data-v-6155c2fa>1</option><option value="2" data-v-6155c2fa>2</option><option value="3" data-v-6155c2fa>3</option><option value="4" data-v-6155c2fa>4</option><option value="5" data-v-6155c2fa>5</option><option value="6" data-v-6155c2fa>6</option><option value="7" data-v-6155c2fa>7</option><option value="8" data-v-6155c2fa>8</option><option value="9" data-v-6155c2fa>9</option><option value="10" data-v-6155c2fa>10</option><option value="11" data-v-6155c2fa>10+</option>',
                        11,
                      ),
                    ])),
                ],
                512,
              )),
              [[Te, e.quantity]],
            )
          : (l(),
            p("div", nu, [
              t[7] ||
                (t[7] = f(
                  "p",
                  { class: "qty-control__label" },
                  "Quantity",
                  -1,
                )),
              f("div", su, [
                f(
                  "button",
                  {
                    class: le(["qty-btn", { "is-disabled": e.quantity <= 1 }]),
                    disabled: e.quantity <= 1,
                    onClick:
                      t[1] ||
                      (t[1] = (...u) => e.decreaseQty && e.decreaseQty(...u)),
                  },
                  [$(a, { type: "minus-qty" })],
                  10,
                  lu,
                ),
                J(
                  f(
                    "input",
                    {
                      type: "number",
                      "onUpdate:modelValue":
                        t[2] || (t[2] = (u) => (e.quantity = u)),
                      min: 1,
                      onBlur:
                        t[3] || (t[3] = (...u) => e.onBlur && e.onBlur(...u)),
                      class: "form-control form-control-qty",
                      placeholder: "Qty",
                      onKeydown:
                        t[4] ||
                        (t[4] = (...u) => e.onKeyDown && e.onKeyDown(...u)),
                    },
                    null,
                    544,
                  ),
                  [[ei, e.quantity]],
                ),
                f(
                  "button",
                  {
                    class: "qty-btn",
                    onClick:
                      t[5] ||
                      (t[5] = (...u) => e.increaseQty && e.increaseQty(...u)),
                  },
                  [$(a, { type: "plus-qty" })],
                ),
              ]),
            ])),
      ],
      2,
    )
  );
}
const Yo = K(iu, [
    ["render", uu],
    ["__scopeId", "data-v-6155c2fa"],
  ]),
  Nt = ti();
function du(e) {
  const t = oe(),
    { settings: o, variantInfo: i } = ee(t),
    r = Fe(() => !xe(o.value.settingsArtwork)),
    n = Fe(() => {
      const { artworks: s } = t;
      return i.value?.print_areas
        ? Array.isArray(i.value?.print_areas)
          ? i.value.print_areas
              .filter((c) => c)
              .filter((c) => c.artwork_id)
              .map((c) => ({
                ...c,
                format: B(
                  s.find((h) => h.id === c.artwork_id),
                  "format",
                  "png",
                ),
              }))
          : []
        : [];
    }),
    a = Fe(() => {
      const { artworks: s, selectedVariant: c } = t;
      if (s.length === 1) return s[0].id;
      if (
        !e.value &&
        o.value?.settingsPack &&
        o.value.settingsPack.length > 0
      ) {
        const y = o.value?.settingsPack
            ?.find((S) => S.pack === "packTwo")
            ?.options?.find((S) => S.variantID === c),
          C = document.querySelector(
            ".price-per-item__container quantity-input input.quantity__input",
          );
        return (C && (C.value = 2), y?.artworkID);
      }
      if (e.value) return s?.find((y) => y.id === e.value)?.id || "";
      if (!r.value) return n.value[0]?.artwork_id;
      const h = i.value;
      return h &&
        o.value.applyTo === "variant" &&
        Array.isArray(o.value.settingsArtwork)
        ? o.value.settingsArtwork.find((y) => +y.id == +h.id)?.artworkId || ""
        : h &&
            h.option &&
            o.value.applyTo === "attribute" &&
            Array.isArray(o.value.settingsArtwork)
          ? o.value.settingsArtwork.find(
              (y) =>
                y.value ===
                h.option.find((C) => C.name === y.name && C.value === y.value)
                  ?.value,
            )?.artworkId || ""
          : n.value[0]?.artwork_id;
    }),
    u = Fe(() => {
      const s = a.value,
        {
          mockups: c,
          artworks: h,
          selectedVariant: m,
          artworkPreviewByVariant: y,
        } = t;
      let C, S;
      if (r.value)
        ((S = c[0].layers.find(
          (N) => N?.artworkID === s && N?.type === "Group",
        )),
          S && (C = S));
      else if (y?.artworkID) C = y;
      else {
        for (const Y of c)
          if (
            ((S = Y.layers.find(
              (N) =>
                (N?.variantID === m && N.type === "Group") ||
                (N.type === "Group" && N?.variantID === ""),
            )),
            S)
          )
            break;
        S && (C = S);
      }
      const A = h.find((Y) => Y.id === s);
      return C
        ? {
            ...Jo(A, "templates"),
            templates: Ai(A?.templates || [], C?.templates),
          }
        : A;
    }),
    d = Fe(() => Pt(o.value, a.value));
  return {
    isNewVersion: r,
    printAreas: n,
    artworkID: a,
    artwork: u,
    defaultValueArtSettings: d,
  };
}
function cu(e) {
  const t = ["#custom-btn-atc", "#btn-preview-desktop", "#btn-preview"];
  ft(e, (o) => {
    t.forEach((i) => {
      const r = document.querySelector(i);
      r && ((r.disabled = o), r.classList.toggle("ld-custom", o));
    });
  });
}
const Ye = new Map();
let yt = null,
  lt = null,
  $t = null,
  Wt = !1,
  Rt = null;
function ro(e, t) {
  return `${e}_${t}`;
}
const pu = "PackModePreview",
  mu = 1,
  it = "previews";
function ho() {
  const t = document
    .querySelector(".slug-product")
    ?.getAttribute("data-handle");
  if (t) return t;
  try {
    const o = oe();
    if (o.product?.handle) return o.product.handle;
  } catch {}
  return (
    window.location.href.split("/products/")[1]?.split("?")[0] || "unknown"
  );
}
function yo() {
  return typeof indexedDB > "u"
    ? Promise.reject(new Error("IndexedDB not available"))
    : new Promise((e, t) => {
        const o = indexedDB.open(pu, mu);
        ((o.onupgradeneeded = () => {
          const i = o.result;
          i.objectStoreNames.contains(it) || i.createObjectStore(it);
        }),
          (o.onsuccess = () => e(o.result)),
          (o.onerror = () => t(o.error)));
      });
}
function Lr(e, t) {
  return `${ho()}_${e}_${t}`;
}
function fu(e) {
  return `${ho()}_${e}`;
}
function hu(e, t, o) {
  const i = Lr(e, t);
  yo()
    .then((r) => {
      const n = r.transaction(it, "readwrite");
      (n.objectStore(it).put(o, i),
        (n.oncomplete = () => r.close()),
        (n.onerror = () => r.close()));
    })
    .catch(() => {});
}
function Tr(e, t) {
  const o = Lr(e, t),
    i = fu(t);
  return yo()
    .then(
      (r) =>
        new Promise((n) => {
          const u = r.transaction(it, "readonly").objectStore(it),
            d = u.get(o);
          ((d.onsuccess = () => {
            if (d.result) (r.close(), n(d.result));
            else {
              const s = u.get(i);
              ((s.onsuccess = () => {
                (r.close(), n(s.result || void 0));
              }),
                (s.onerror = () => {
                  (r.close(), n(void 0));
                }));
            }
          }),
            (d.onerror = () => {
              (r.close(), n(void 0));
            }));
        }),
    )
    .catch(() => {});
}
async function yu(e, t) {
  const o = ho();
  try {
    const i = await yo(),
      n = i.transaction(it, "readonly").objectStore(it),
      a = [],
      u = t ? [t] : [];
    if (!u.length)
      try {
        oe().artworks.forEach((s) => u.push(s.id));
      } catch {}
    for (const d of u)
      for (let s = 0; s < e; s++) {
        const c = `${o}_${d}_${s}`,
          h = ro(d, s);
        a.push(
          new Promise((m) => {
            const y = n.get(c);
            ((y.onsuccess = () => {
              if (y.result && !Ye.has(h)) (Ye.set(h, y.result), m());
              else if (Ye.has(h)) m();
              else {
                const C = n.get(`${o}_${s}`);
                ((C.onsuccess = () => {
                  (C.result && !Ye.has(h) && Ye.set(h, C.result), m());
                }),
                  (C.onerror = () => m()));
              }
            }),
              (y.onerror = () => m()));
          }),
        );
      }
    (await Promise.all(a), i.close());
  } catch {}
}
function Vr(e, t) {
  return Ye.get(ro(e, t));
}
function Ld(e, t) {
  return Ye.has(ro(e, t));
}
function Mr(e, t, o) {
  (Ye.set(ro(e, t), o), hu(e, t, o));
}
function Ur() {
  (yt && (clearTimeout(yt), (yt = null)),
    lt && (clearTimeout(lt), (lt = null)));
}
function go() {
  const e = he(),
    t = e.currentArtwork;
  if (!t) return;
  const o = e.activePackIndex,
    i = window.__fabricCanvas,
    r = i
      ? (i.lowerCanvasEl ?? i.getElement?.())
      : document.getElementById("canvas");
  if (!r) return;
  const a = xt(r, 800, 800).toDataURL(Zt);
  e.activePackIndex === o && e.currentArtwork === t && Mr(t, o, a);
}
function gu() {
  const e = he(),
    t = e.activePackIndex;
  (lt && (clearTimeout(lt), (lt = null)),
    yt && clearTimeout(yt),
    (yt = setTimeout(() => {
      e.activePackIndex === t && go();
    }, 150)));
}
function vu() {
  (Ur(),
    (lt = setTimeout(() => {
      go();
    }, 400)));
}
async function zr(e) {
  const t = he(),
    o = oe(),
    i = t.activePackIndex;
  if (t.currentArtwork && !(o.artworks.length <= 1)) {
    t._artworkSwitchGuard++;
    try {
      for (let n = 0; n < e; n++) (t.setActivePackIndex(n), await Xo(), go());
      (t.setActivePackIndex(i), await Xo());
    } finally {
      t._artworkSwitchGuard--;
    }
  }
}
function Xo() {
  return new Promise((e) => {
    const t = window.__fabricCanvas,
      o = he();
    let i = null,
      r = null,
      n = null,
      a = !1;
    const u = () => {
        (t && t.off("after:render", h),
          i && clearTimeout(i),
          r && clearTimeout(r),
          n && clearInterval(n));
      },
      d = () => {
        (u(), e());
      },
      s = () => {
        const m = Se(),
          y = o.currentArtwork;
        if (!y) return !0;
        const C = m.loadings[y];
        return C ? !Object.values(C).some((S) => S === !0) : !0;
      },
      c = () => {
        a && s() && d();
      },
      h = () => {
        (i && clearTimeout(i),
          (i = setTimeout(() => {
            ((a = !0), c());
          }, 200)));
      };
    (t && t.on("after:render", h),
      (n = setInterval(() => {
        a && s() && d();
      }, 100)),
      (r = setTimeout(d, 2e3)));
  });
}
function wu(e) {
  if (Wt) return;
  const t = he(),
    o = oe(),
    { activePackIndex: i } = ee(t),
    r = Fe(() => !!o.settings?.isPackMode);
  if (r.value) {
    const n = Dt();
    n > 0 && yu(n);
  }
  (($t = () => {
    r.value && gu();
  }),
    e.on("canvas-after-render", $t),
    (Rt = ft(
      i,
      (n, a) => {
        if (r.value) {
          if (a !== void 0 && a !== n) {
            const u = t.currentArtwork;
            if (u) {
              const d = window.__fabricCanvas,
                s = d
                  ? (d.lowerCanvasEl ?? d.getElement?.())
                  : document.getElementById("canvas");
              if (s) {
                const h = xt(s, 800, 800).toDataURL(Zt);
                Mr(u, a, h);
              }
            }
          }
          vu();
        }
      },
      { immediate: !0 },
    )),
    (Wt = !0));
}
function ku(e) {
  Wt &&
    ($t && (e.off("canvas-after-render", $t), ($t = null)),
    Rt && (Rt(), (Rt = null)),
    Ur(),
    Ye.clear(),
    (Wt = !1));
}
const et = new Map(),
  Td = (e, t) => {
    et.set(e, t);
  },
  Vd = (e) => {
    et.delete(e);
  },
  bu = "MapImageDB",
  Su = 1,
  gt = "map-images";
function ht(e, t, o, i) {
  const r = `${e}_${t}_${o}`;
  if (i != null) return `${r}_pack${i}`;
  try {
    if (oe().settings?.isPackMode) {
      const a = he();
      return `${r}_pack${a.activePackIndex}`;
    }
  } catch {}
  return r;
}
function Or() {
  return new Promise((e, t) => {
    if (typeof indexedDB > "u") {
      t(new Error("IndexedDB not available"));
      return;
    }
    const o = indexedDB.open(bu, Su);
    ((o.onupgradeneeded = () => {
      const i = o.result;
      i.objectStoreNames.contains(gt) || i.createObjectStore(gt);
    }),
      (o.onsuccess = () => e(o.result)),
      (o.onerror = () => t(o.error)));
  });
}
const Nr = new Map(),
  Md = (e) => Nr.get(e) ?? null,
  Ud = (e, t) => {
    Nr.set(e, t);
  },
  Ht = new Map(),
  zd = (e, t) => {
    (Ht.set(e, t),
      Or()
        .then(
          (o) =>
            new Promise((i, r) => {
              const n = o.transaction(gt, "readwrite");
              (n.objectStore(gt).put(t, e),
                (n.oncomplete = () => {
                  (o.close(), i());
                }),
                (n.onerror = () => {
                  (o.close(), r(n.error));
                }));
            }),
        )
        .catch((o) => {
          console.warn("[MapImageDB] saveForReload failed:", o);
        }));
  },
  nt = async (e) => {
    const t = Ht.get(e);
    if (t) return t;
    try {
      const o = await Or();
      return await new Promise((i, r) => {
        const u = o.transaction(gt, "readonly").objectStore(gt).get(e);
        ((u.onsuccess = () => {
          o.close();
          const d = u.result ?? null;
          (d && Ht.set(e, d), i(d));
        }),
          (u.onerror = () => {
            (o.close(), r(u.error));
          }));
      });
    } catch (o) {
      return (console.warn("[MapImageDB] getForReload failed:", o), null);
    }
  },
  Od = (e) => Ht.get(e) ?? null,
  Nd = async (e) => nt(e),
  { isTikTok: Cu, isSafari: Iu, isIOSWebView: _u } = Fi();
function Pu(e, t, o, i) {
  const r = oe(),
    n = he(),
    a = Se(),
    { selectedVariant: u, variantInfo: d } = ee(r),
    { personalized: s, keyUploadsPersonalized: c } = ee(n),
    {
      storeName: h,
      storeId: m,
      sessionID: y,
      isEditDesign: C,
      isDesignTrackOrder: S,
    } = ee(a);
  function A() {
    return C.value
      ? window.location.href.split("/cart")[0] +
          "/products/" +
          document.querySelector(".slug-product")?.getAttribute("data-handle")
      : window.location.href;
  }
  function Y(x, R) {
    Ei(R) || localStorage.setItem(x, i.value.toDataURL());
  }
  function N() {
    const x = u.value,
      R = sessionStorage.getItem(tr);
    if (R) return { url: R, type: "base64toFile" };
    const L = document?.querySelector(`.product-mockup[variants="${x}"]`);
    if (!L) return;
    let T = null;
    const D = L.querySelectorAll("#canvas, img"),
      P = Vi ? "image/webp" : "image/jpeg";
    for (const E of D) {
      if (E.tagName.toLowerCase() === "img")
        return { url: E?.src, type: "url" };
      ((i.value = xt(E, 800, 800)),
        Cu || Iu || _u
          ? (T = { url: i.value.toDataURL(P), type: "base64", format: P })
          : (T = { type: "file", format: P }));
      break;
    }
    return T;
  }
  async function F(x) {
    const R = N();
    if (!R) return Promise.resolve({ url: null });
    if (R.type === "base64toFile") {
      const L = jt(R.url);
      return Kt(L, R.url, h.value, x);
    }
    return R.type === "file"
      ? Li(i.value, h.value, x)
      : R.type === "url"
        ? Promise.resolve({ url: R.url })
        : Ti(R.url, h.value, x);
  }
  async function U(x, R) {
    const L = n.currentArtwork || "",
      T = [];
    await zr(R);
    for (let D = 0; D < R; D++) {
      let P;
      if (((P = Vr(L, D)), P || (P = await Tr(L, D)), !P)) continue;
      const E = `${x}_pack_${D}`,
        O = jt(P);
      T.push(
        Kt(O, P, h.value, E)
          .then((se) => (se && typeof se.json == "function" ? se.json() : se))
          .then((se) => ({
            packIndex: D,
            previewUrl:
              se?.url ||
              se?.previewUrl ||
              `https://art.custfy.com/shopify/assetFiles/previews/${h.value}/${E}.jpeg`,
          }))
          .catch(() => ({ packIndex: D, previewUrl: "" })),
      );
    }
    return Promise.all(T);
  }
  async function X(x) {
    const R = e.value,
      L = c.value,
      T = ot(x[R]) ?? {},
      D = [];
    for (const P in T) {
      Number.isNaN(Number(P)) &&
        P !== "template" &&
        !P.includes("_") &&
        delete T[P];
      const E = parseInt(P);
      if (typeof T[P] == "object") {
        const O = T[P];
        if (!O) continue;
        if (O.originScale)
          ((T[P].originScale = O.originScale),
            (T[P].offset = O.offset),
            (T[P].angle = O.angle),
            (T[P].angleArtwork = O.angleArtwork),
            (T[P].frame = O.frame));
        else {
          const Q = typeof P == "string" && P.endsWith("_origin") ? P : E,
            re = window.__layerUpload[Q];
          if (re) {
            const G = re.getParamCustom();
            ((T[P].originScale = G.originScale),
              (T[P].offset = G.offset),
              (T[P].angle = G.angle),
              (T[P].miss_data = !0),
              (T[P].angleArtwork = G.angleArtwork),
              (T[P].frame = { width: re?.width, height: re?.height }));
          }
        }
        if (
          (delete T[P].uri,
          (O.date || O.hour !== void 0 || O.minute !== void 0) &&
            O.imgSrc &&
            delete T[P]?.imgSrc,
          O?.keyImg && O?.imgSrc && delete T[P]?.imgSrc,
          O.key && O.key.startsWith(ht(n.currentArtwork ?? "", "map", E)))
        ) {
          const se = P;
          D.push(async () => {
            const Q = await nt(O.key),
              re = await Ke(y.value, h.value, E, He("MAP"), "image/png"),
              G = await We(Q, re.fields?.Key);
            G &&
              G.msg === "OK" &&
              ((T[se].key = re.fields?.Key), (L[se] = re.fields?.Key));
          });
        }
        if (
          O.key &&
          O.key.startsWith(ht(n.currentArtwork ?? "", "starmap", E))
        ) {
          const se = P;
          D.push(async () => {
            const Q = await nt(O.key),
              re = await Ke(y.value, h.value, E, He("STARMAP"), "image/png"),
              G = await We(Q, re.fields?.Key);
            G &&
              G.msg === "OK" &&
              ((T[se].key = re.fields?.Key), (L[se] = re.fields?.Key));
          });
        }
        if (O.key && O.isAudio) {
          const se = P,
            Q = `${n.currentArtwork ?? ""}_waveform_${E}_`,
            re = Array.from(et.keys()).filter((G) => G.startsWith(Q));
          for (const G of re) {
            const fe = G.replace(Q, ""),
              Ge = et.get(G);
            Ge &&
              D.push(async () => {
                const Re = await Ke(
                    y.value,
                    h.value,
                    E,
                    He("WAVEFORM"),
                    "image/png",
                  ),
                  Pe = await We(Ge, Re.fields?.Key);
                Pe &&
                  Pe.msg === "OK" &&
                  (T[se][`keyWaveform_${fe}`] = Re.fields?.Key);
              });
          }
        }
      }
    }
    return (
      D.length > 0 && (await Promise.all(D.map((P) => P()))),
      (T.sessionID = y.value),
      T
    );
  }
  async function j(x) {
    const R = c.value,
      L = ot(s.value[x]) ?? {},
      T = [];
    for (const D in L) {
      Number.isNaN(Number(D)) &&
        D !== "template" &&
        !D.includes("_") &&
        delete L[D];
      const P = parseInt(D);
      if (typeof L[D] == "object") {
        const E = L[D];
        if (!E) continue;
        const O = qt(x),
          se = !O || O.packIndex === n.activePackIndex;
        if (!E.originScale && se) {
          const re = typeof D == "string" && D.endsWith("_origin") ? D : P,
            G = window.__layerUpload[re];
          if (G) {
            const fe = G.getParamCustom();
            ((L[D].originScale = fe.originScale),
              (L[D].offset = fe.offset),
              (L[D].angle = fe.angle),
              (L[D].miss_data = !0),
              (L[D].angleArtwork = fe.angleArtwork),
              (L[D].frame = { width: G?.width, height: G?.height }));
          }
        } else
          ((L[D].originScale = E.originScale),
            (L[D].offset = E.offset),
            (L[D].angle = E.angle),
            (L[D].angleArtwork = E.angleArtwork),
            (L[D].frame = E.frame));
        if (
          (delete L[D].uri,
          (E.date || E.hour !== void 0 || E.minute !== void 0) &&
            E.imgSrc &&
            delete L[D]?.imgSrc,
          E?.keyImg && E?.imgSrc && delete L[D]?.imgSrc,
          E.key &&
            E.key.startsWith(
              ht(n.currentArtwork ?? "", "map", P, O?.packIndex),
            ))
        ) {
          const Q = D;
          T.push(async () => {
            const re = await nt(E.key),
              G = await Ke(y.value, h.value, P, He("MAP"), "image/png"),
              fe = await We(re, G.fields?.Key);
            fe &&
              fe.msg === "OK" &&
              ((L[Q].key = G.fields?.Key), (R[Q] = G.fields?.Key));
          });
        }
        if (
          E.key &&
          E.key.startsWith(
            ht(n.currentArtwork ?? "", "starmap", P, O?.packIndex),
          )
        ) {
          const Q = D;
          T.push(async () => {
            const re = await nt(E.key),
              G = await Ke(y.value, h.value, P, He("STARMAP"), "image/png"),
              fe = await We(re, G.fields?.Key);
            fe &&
              fe.msg === "OK" &&
              ((L[Q].key = G.fields?.Key), (R[Q] = G.fields?.Key));
          });
        }
        if (E.key && E.isAudio) {
          const Q = D,
            re = `${n.currentArtwork ?? ""}_waveform_${P}_`,
            G = Array.from(et.keys()).filter((fe) => fe.startsWith(re));
          for (const fe of G) {
            const Ge = fe.replace(re, ""),
              Re = et.get(fe);
            Re &&
              T.push(async () => {
                const Pe = await Ke(
                    y.value,
                    h.value,
                    P,
                    He("WAVEFORM"),
                    "image/png",
                  ),
                  Be = await We(Re, Pe.fields?.Key);
                Be &&
                  Be.msg === "OK" &&
                  (L[Q][`keyWaveform_${Ge}`] = Pe.fields?.Key);
              });
          }
        }
      }
    }
    return (
      T.length > 0 && (await Promise.all(T.map((D) => D()))),
      (L.sessionID = y.value),
      L
    );
  }
  async function we(x, R, L, T) {
    let D = A();
    (S.value &&
      (D =
        window.location.href.split("/pages/tracking-order-detail")[0] +
        "/products/" +
        document.querySelector(".slug-product")?.getAttribute("data-handle")),
      n._flushUploadLayersToPersonalized());
    const P = Array.from({ length: R }, (Q, re) => {
        const G = Jt(x, re);
        return j(G).then((fe) => ({ index: re, data: fe }));
      }),
      E = await Promise.all(P),
      O = {};
    for (const Q of E)
      ((O[`${x}_${Q.index}`] = Q.data), Q.index === 0 && (O[x] = Q.data));
    (D && (O.urlCamp = D),
      d.value?.option && (O.variantOption = d.value.option),
      n.setKeyUploadsPersonalized(c.value));
    const se = {
      sessionID: y.value,
      personalized: O,
      printAreas: T,
      storeId: m.value,
      selectedVariant: L,
      keyFileName: o.value,
      artworkID: x,
    };
    try {
      const Q = await Do(se);
      return ((o.value = Ce()), Q);
    } catch (Q) {
      throw (console.error("[savePackCustomization] failed:", Q), Q);
    }
  }
  async function te(x, R, L, T, D, P) {
    const E = { [R]: x };
    let O = A();
    (S.value &&
      (O =
        window.location.href.split("/pages/tracking-order-detail")[0] +
        "/products/" +
        document.querySelector(".slug-product")?.getAttribute("data-handle")),
      O && (E.urlCamp = O),
      P && (E.variantOption = P),
      n.setKeyUploadsPersonalized(c.value));
    const se = {
      sessionID: y.value,
      personalized: E,
      printAreas: T,
      storeId: m.value,
      selectedVariant: L,
      keyFileName: D,
      artworkID: R,
    };
    try {
      return await Do(se);
    } catch (Q) {
      throw (console.error("[postCustomization] failed:", Q), Q);
    }
  }
  async function _e(x, R, L, T) {
    const D = e.value,
      P = await X(x),
      E = await te(P, D, L, T, o.value, d.value?.option);
    return ((o.value = Ce()), E);
  }
  async function De(x, R) {
    const L = await X(x),
      T = await te(
        L,
        R.artworkID,
        R.id,
        t.value,
        o.value + "--" + R.id,
        R.option,
      );
    if (!T.ok) throw new Error(`API request failed with status ${T.status}`);
    const D = await T.json();
    return { variant: R.id, properties: D };
  }
  async function Ne() {
    try {
      const [x, R] = await Promise.all([
          F(o.value ?? ""),
          _e(s.value, m.value, u.value, t.value),
        ]),
        L = x && typeof x.json == "function" ? await x.json() : x,
        T = R && typeof R.json == "function" ? await R.json() : R;
      return (
        Y(T.id, L?.previewUrl),
        { ...T, previewUrl: L?.url || L?.previewUrl, variant_id: u.value }
      );
    } catch {
      alert("Something went wrong, please try again later!");
    }
  }
  return {
    getCustomizationUrl: A,
    getOrderPreview: N,
    getOrPreview: F,
    uploadPackPreviews: U,
    prepareCustomizationData: X,
    preparePackItemData: j,
    saveCustomization: _e,
    savePackCustomization: we,
    saveCustomizationByVariant: De,
    createOrder: Ne,
    checkSavePreviewLocal: Y,
  };
}
const Rr = () => {
    const e = "America/Los_Angeles",
      t = new Date();
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: e,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(t);
  },
  $u = (e) => {
    const t = /\bma[A-Za-z0-9]{7}\b/i,
      o = /([A-Za-z]{2,4})[0-9]{6,8}[A-Za-z]{2,4}/,
      r = e.split("?")[0]?.split("-") || [];
    let n = null;
    for (const a of r)
      if (t.test(a) || o.test(a)) {
        n = a.toUpperCase();
        break;
      }
    return n;
  },
  Mt = (e, t) => {
    const o = $u(e);
    return `${Rr()}/${o ? o + "/" : ""}${t ?? Ce()}`;
  },
  Ct = (e, t) =>
    `https://art.custfy.com/shopify/assetFiles/previews/${e}/${t ?? Ce()}.jpeg`,
  Ut = (e) => `https://art.custfy.com/render_designs/${Rr()}/${e ?? Ce()}.png`;
function zt(e) {
  return new Promise((t) => {
    const o = () => {
      (e.off("canvas-rendered", o), t());
    };
    (e.on("canvas-rendered", o),
      window.dispatchEvent(new CustomEvent(rt.CANVAS_RENDERED)));
  });
}
const Du = () => {
    const e = oe(),
      { selectedVariant: t } = e,
      o = document?.querySelector(`.product-mockup[variants="${t}"]`);
    if (!o) return;
    let i = null;
    if (o) {
      const r = o.querySelectorAll("#canvas, img");
      for (const n of r) {
        if (n.tagName.toLowerCase() === "img")
          return { url: n?.src, type: "url" };
        const a = xt(n, 800, 800);
        i = { url: a.toDataURL(), type: "base64toFile", canvas: a };
        break;
      }
    }
    return i;
  },
  Au = async () => {
    const e = Se(),
      { storeName: t } = e,
      o = Du();
    if (!o)
      return new Promise(function (r) {
        r({ url: null });
      });
    const i = jt(o.url);
    return Kt(i, o.url, t, void 0);
  },
  Fu = async () => {
    const e = oe(),
      t = he(),
      o = Se(),
      { storeName: i } = o,
      r =
        "font-size: 14px; color: white; background: #7258e0; padding: 2px; border-radius:2px;",
      n =
        "font-size: 14px; color: white; background: #ff1313; padding: 2px; border-radius:2px;";
    if (
      (window.dispatchEvent(new CustomEvent(rt.CANVAS_RENDERED)),
      await new Promise((a) => setTimeout(a, 300)),
      e.settings?.isPackMode)
    ) {
      const a = Dt();
      if (a >= 1) {
        const u = t.currentArtwork || "",
          d = [],
          s = ur().replace(".png", "");
        await zr(a);
        for (let c = 0; c < a; c++) {
          let h;
          if (((h = Vr(u, c)), h || (h = await Tr(u, c)), !h)) {
            (console.log(
              `%cPack item ${c + 1}: no preview available (not yet customized?)`,
              n,
            ),
              d.push(""));
            continue;
          }
          try {
            const m = jt(h),
              y = await Kt(m, h, i, `${s}_pack_${c}`),
              S = (y?.ok ? await y.json() : y)?.url || "";
            (d.push(S), console.log(`%cPack item ${c + 1}:`, r, S));
          } catch (m) {
            (console.log(`%cPack item ${c + 1} upload error: ${m.message}`, n),
              d.push(""));
          }
        }
        return d;
      }
    }
    return Au()
      .then((a) => (a.ok ? a.json() : null))
      .then((a) => (console.log(a?.url), a?.url))
      .catch((a) => {
        console.log(
          `%cError: ${a.message}`,
          "font-size: 14px; color: white; background: #ff1313; padding: 2px; border-radius:2px;",
        );
      });
  },
  Yt = async (e, t, o, i = !1, r) => {
    for (const n in e)
      if (
        (Number.isNaN(Number(n)) &&
          n != "template" &&
          !n.includes("_") &&
          delete e[n],
        typeof e[n] == "object")
      ) {
        const a = e[n];
        if (!a) continue;
        const d =
            typeof n == "string" && n.endsWith("_origin") ? n : parseInt(n),
          s = parseInt(n),
          c = i ? null : window.__layerUpload?.[d];
        if (c) {
          const h = c.getParamCustom();
          ((e[n].originScale = h.originScale),
            (e[n].offset = h.offset),
            (e[n].angle = h.angle),
            (e[n].angleArtwork = h.angleArtwork),
            (e[n].frame = { width: c?.width, height: c?.height }));
        } else
          ((e[n].originScale = a.originScale),
            (e[n].offset = a.offset),
            (e[n].angle = a.angle),
            (e[n].angleArtwork = a.angleArtwork),
            (e[n].frame = a?.frame));
        if (
          (delete e[n]?.uri,
          (a.date || a.hour !== void 0 || a.minute !== void 0) &&
            a.imgSrc &&
            delete e[n]?.imgSrc,
          a?.keyImg && a?.imgSrc && delete e[n]?.imgSrc,
          a.key && a.key.startsWith(ht(t.currentArtwork ?? "", "map", s, r)))
        ) {
          const h = await nt(a.key);
          if (!h) continue;
          const m = o.sessionID,
            y = o.storeName,
            C = await Ke(m, y, s, He("MAP"), "image/png"),
            S = await We(h, C.fields?.Key);
          S && S.msg == "OK" && (e[n].key = C.fields?.Key);
        }
        if (
          a.key &&
          a.key.startsWith(ht(t.currentArtwork ?? "", "starmap", s, r))
        ) {
          const h = await nt(a.key);
          if (!h) continue;
          const m = o.sessionID,
            y = o.storeName,
            C = await Ke(m, y, s, He("STARMAP"), "image/png"),
            S = await We(h, C.fields?.Key);
          S && S.msg == "OK" && (e[n].key = C.fields?.Key);
        }
        if (a.key && a.isAudio) {
          const h = `${t.currentArtwork ?? ""}_waveform_${s}_`,
            m = Array.from(et.keys()).filter((y) => y.startsWith(h));
          for (const y of m) {
            const C = y.replace(h, ""),
              S = et.get(y);
            if (!S) continue;
            const A = o.sessionID,
              Y = o.storeName,
              N = await Ke(A, Y, s, He("WAVEFORM"), "image/png"),
              F = await We(S, N.fields?.Key);
            F && F.msg == "OK" && (e[n][`keyWaveform_${C}`] = N.fields?.Key);
          }
        }
      }
    return e;
  },
  Eu = async () => {
    const e = he(),
      t = Se(),
      o = oe(),
      i = ot(e.personalized),
      r = e.currentArtwork,
      n = o.variantInfo,
      a = window.location.href;
    if (o.settings?.isPackMode && r) {
      const s = Dt();
      if (s >= 1) {
        const c = {},
          h = e.activePackIndex;
        for (let m = 0; m < s; m++) {
          const y = Jt(r, m),
            C = i[y] ?? {},
            S = m !== h,
            A = await Yt(ot(C), e, t, S, m);
          ((c[`${r}_${m}`] = A), m === 0 && (c[r] = A));
        }
        return (
          (c.urlCamp = a),
          n?.option && (c.variantOption = n.option),
          { newPersonalized: c, currentArtwork: r }
        );
      }
    }
    const u = r !== null ? i[r] : null;
    u && (await Yt(u, e, t));
    const d = r ? { [r]: u } : {};
    return (
      (d.urlCamp = a),
      n?.option && (d.variantOption = n.option),
      { newPersonalized: d, currentArtwork: r }
    );
  },
  Lu = async (e = null) => {
    const t = he(),
      o = Se(),
      i = oe(),
      r = ot(t.personalized),
      n = t.currentArtwork,
      a = "https://art.custfy.com",
      u = "%cThe link below will become valid in about 5 minutes.",
      d =
        "font-size: 14px; color: white; background: #7258e0; padding: 2px; border-radius:2px;",
      s = `render_designs/${ta()}/${ur()}`,
      c = window.location.href;
    if (i.settings?.isPackMode && n) {
      const y = Dt();
      if (y >= 1) {
        const C = {},
          S = t.activePackIndex;
        for (let U = 0; U < y; U++) {
          const X = Jt(n, U),
            j = r[X] ?? {},
            we = U !== S,
            te = await Yt(ot(j), t, o, we);
          ((C[`${n}_${U}`] = te), U === 0 && (C[n] = te));
        }
        C.urlCamp = c;
        const A = s.lastIndexOf("."),
          Y = A > 0 ? s.substring(0, A) : s,
          N = A > 0 ? s.substring(A) : "",
          F = Array.from({ length: y }, (U, X) => `${a}/${Y}_pack_${X}${N}`);
        return (
          console.debug(u, d),
          F.forEach((U, X) =>
            console.debug(`link design pack item ${X + 1}`, U),
          ),
          fetch("https://render-api.custfy.com/render-design", {
            method: "POST",
            body: JSON.stringify({
              preview: !1,
              key: s,
              artworkID: n,
              personalized: C,
            }),
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              authorization: e || "",
            },
          })
            .then((U) => {
              if (U.ok) return U.json();
            })
            .then((U) =>
              U?.data?.statusCode == 500
                ? alert(U?.data?.body)
                : { data: { body: { url: F[0], packUrls: F } } },
            )
            .catch((U) => {
              if (
                (console.debug(U), U.status == 503 || U.code == "ECONNABORTED")
              )
                return (
                  console.debug(u, d),
                  { data: { body: { url: F[0], packUrls: F } } }
                );
              alert(U);
            })
        );
      }
    }
    const h = n !== null ? r[n] : null;
    h && (await Yt(h, t, o));
    const m = n ? { [n]: h } : {};
    return (
      (m.urlCamp = c),
      console.debug(u, d),
      console.debug("link design", `${a}/${s}`),
      fetch("https://render-api.custfy.com/render-design", {
        method: "POST",
        body: JSON.stringify({
          preview: !1,
          key: s,
          artworkID: n,
          personalized: m,
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: e || "",
        },
      })
        .then((y) => {
          if (y.ok) return y.json();
        })
        .then((y) =>
          y?.data?.statusCode == 500
            ? alert(y?.data?.body)
            : { data: { body: { url: `${a}/${s}` } } },
        )
        .catch((y) => {
          if ((console.debug(y), y.status == 503 || y.code == "ECONNABORTED"))
            return (
              console.debug(u, d),
              { data: { body: { url: `${a}/${s}` } } }
            );
          alert(y);
        })
    );
  };
function Tu(e) {
  const t = oe(),
    o = he(),
    i = Se(),
    { settings: r, variants: n, product: a } = ee(t),
    { personalized: u, loadingATC: d } = ee(o),
    { storeName: s, storeId: c, platform: h, isEditDesign: m } = ee(i),
    {
      artworkID: y,
      printAreas: C,
      fileName: S,
      canvas: A,
      emitter: Y,
      validate: N,
      customization: F,
    } = e;
  function U() {
    try {
      const g = Zt;
      if (A.value && typeof A.value.toDataURL == "function")
        return A.value.toDataURL(g);
      const k = t.selectedVariant,
        _ = document?.querySelector(`.product-mockup[variants="${k}"]`);
      if (!_) return;
      const z = _.querySelector("#canvas");
      if (z) return z.toDataURL(g);
    } catch {
      return;
    }
  }
  function X(g) {
    if (!g) return !1;
    const k = window.getComputedStyle(g);
    return (
      k.width !== "0" &&
      k.height !== "0" &&
      k.opacity !== "0" &&
      k.display !== "none" &&
      k.visibility !== "hidden"
    );
  }
  function j() {
    return (
      document.querySelector('input[name="properties[_ab_variant_id]"]')
        ?.value || null
    );
  }
  function we(g, k, _) {
    const z = document.getElementById(g),
      q = parseInt((z?.querySelector("input[name='id']")).value);
    return { quantity: k, id: q, properties: { _parentKey: _ } };
  }
  function te() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items")?.dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".js-contents-right",
      },
    ];
  }
  function _e() {
    const g = document.querySelector(".pack-selector.active");
    return Array.from(
      g.querySelectorAll(
        '.pack-3-hidden-inputs input[name^="pack_"][name$="_variant_id"]',
      ),
    )
      .map((k) => k.value)
      .filter(Boolean)
      .map(Number);
  }
  function De(g) {
    return !r.value.settingsArtwork || r.value.settingsArtwork.length === 0
      ? y.value
      : r.value.applyTo === "attribute"
        ? r.value.settingsArtwork.find(
            (k) =>
              k.value ===
              g.option.find((_) => _.name === k.name && _.value === k.value)
                ?.value,
          )?.artworkId
        : r.value.settingsArtwork.find((k) => k.id === g.id)?.artworkId;
  }
  function Ne() {
    const g = document.querySelector("product-form form");
    let k = 1,
      _ = !1;
    m.value
      ? (k = o.qty)
      : m.value ||
        (g?.querySelector("input[name='quantity-box']")
          ? ((_ = !0),
            (k = parseInt(
              g?.querySelector("input[name='quantity-box']")?.value,
            )))
          : (k =
              parseInt(g?.querySelector("input[name='quantity']")?.value) ??
              1));
    const z = _ ? void 0 : new Date().getTime().toString();
    return { form: g, qty: k, isBoxQuantity: _, key: z };
  }
  function x(g) {
    const k = document.getElementById("form-gift-box"),
      _ = document.querySelector(".variants-custom-box"),
      z = [],
      q = parseInt(k?.querySelector("input[name='product-id']")?.value),
      H = g?.querySelector("input[name='section-id']")?.value;
    if (_)
      return (
        Array.from(_.querySelectorAll("input.variant-checkbox"))
          .filter((me) => me.checked)
          ?.map((me) => {
            const ve = me.getAttribute("data-variant-id"),
              be =
                me
                  ?.closest(".variant-item")
                  ?.querySelector("input.variant-quantity")?.value ?? 1;
            z.push({
              form_type: "product",
              id: Number(ve),
              quantity: be,
              "product-id": q,
              "section-id": H,
              utf8: "✓",
            });
          }),
        z
      );
  }
  function R(g, k) {
    const _ = document.querySelector(".pack-selector.active"),
      z = parseInt(g?.querySelector("input[name='quantity']")?.value) ?? 1,
      q = parseInt(g?.querySelector("input[name='product-id']")?.value),
      H = g?.querySelector("input[name='section-id']")?.value,
      de = [];
    if (_)
      return (
        Array.from(
          _.querySelectorAll(
            '.pack-3-hidden-inputs input[name^="pack_"][name$="_variant_id"]',
          ),
        )
          .map((be) => be.value)
          .filter(Boolean)
          .map((be) => {
            de.push({
              form_type: "product",
              id: Number(be),
              quantity: z,
              "product-id": q,
              "section-id": H,
              properties: k,
              utf8: "✓",
            });
          }),
        de
      );
    const me = parseInt(g?.querySelector("input[name='id']")?.value);
    return (
      de.push({
        id: me,
        form_type: "product",
        quantity: z,
        properties: k,
        "product-id": q,
        "section-id": H,
        utf8: "✓",
      }),
      de
    );
  }
  function L(g) {
    const { form: k, qty: _, key: z } = Ne(),
      q = [],
      H = document.getElementById("choose-to-buy-card"),
      de = document.querySelector(".gift-box-wrapper.card");
    if (H && H.checked && X(de)) {
      const ce = we("form-gift-card", _, z);
      q.push(ce);
    }
    const me = document.getElementById("choose-to-buy"),
      ve = document.querySelector(".gift-box-wrapper.box"),
      be = document.querySelector(".box-upsell-mutiplate");
    if (me && me.checked && X(ve)) {
      const ce = we("form-gift-box", _, z);
      q.push(ce);
    } else if (be) {
      const ce = x(k);
      q.push(...ce);
    }
    q.length && (g._itemKey = z);
    const ie = R(k, g);
    return (q.push(...ie), q);
  }
  function T(g) {
    const { form: k, qty: _, key: z } = Ne(),
      q = [],
      H = document.getElementById("choose-to-buy"),
      de = document.querySelector(".gift-box-wrapper.box");
    if (H && H.checked && X(de)) {
      const ie = we("form-gift-box", _, z);
      q.push(ie);
    }
    const me = document.getElementById("choose-to-buy-card"),
      ve = document.querySelector(".gift-box-wrapper.card");
    if (me && me.checked && X(ve)) {
      const ie = we("form-gift-card", _, z);
      q.push(ie);
    }
    const be = D(k, g);
    return (q.push(...be), q);
  }
  function D(g, k) {
    const _ = parseInt(g?.querySelector("input[name='quantity']")?.value) ?? 1,
      z = parseInt(g?.querySelector("input[name='product-id']")?.value),
      q = g?.querySelector("input[name='section-id']")?.value,
      H = [];
    return (
      _e().map((me) => {
        H.push({
          form_type: "product",
          id: Number(me),
          quantity: _,
          "product-id": z,
          "section-id": q,
          properties: k.find((ve) => +ve.variantID == +me),
          utf8: "✓",
        });
      }),
      H
    );
  }
  function P() {
    return window.Shopify?.routes?.root
      ? `${window.Shopify.routes.root}cart/add.js`
      : `${window.location.origin}/api/atc`;
  }
  async function E(g) {
    const items = g.map((item) => ({
      ...item,
      properties: Object.fromEntries(
        Object.entries(item.properties || {}).filter(
          ([key]) => !/^variant(?:[_\s-]?id)?$/i.test(key),
        ),
      ),
    }));
    const response = await fetch(P(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });
    if (!response.ok) {
      const error = await response.clone().json().catch(() => ({}));
      const message = error.description || error.message || "Unable to add this item. Please try again.";
      St.error(message);
      throw new Error(message);
    }
    return response;
  }
  async function O() {
    try {
      const k = await (await fetch("/cart.js")).json(),
        _ = document.querySelector("#header-cart-count-bubble");
      _ && k?.item_count && (_.innerText = k.item_count);
      if (typeof k?.item_count === "number") {
        document.querySelectorAll(".cart-link").forEach((link) => {
          link.setAttribute("aria-label", `Cart with ${k.item_count} items`);
          const count = link.querySelector(".cart-link__count");
          if (count) count.textContent = String(k.item_count);
        });
      }
    } catch (g) {
      console.error("Error:", g);
    }
  }
  function mobileCartAfterAdd() {
    if (m.value || !window.matchMedia("(max-width: 749px)").matches) return false;
    o.setShowPreview(!1);
    t.setIsShowPopupATC(!1);
    window.location.assign(`${window.Shopify?.routes?.root || "/"}cart`);
    return true;
  }
  function se() {
    if (mobileCartAfterAdd()) return;
    let cartType;
    try {
      cartType = JSON.parse(document.getElementById("CustoGiftsConfig")?.textContent || "{}").cart_type;
    } catch {}
    if (cartType === "page" && !m.value) {
      o.setShowPreview(!1);
      t.setItemATC({
        previewBase64: U(),
        variant_id: t.selectedVariant,
        qty: Number(o.qty) || 1,
      });
      o.setLoadingATC(!1);
      O();
      t.setIsShowPopupATC(!0);
      return;
    }
    (o.setLoadingATC(!1),
      document.dispatchEvent(new CustomEvent("viewCartDrawer")),
      document.dispatchEvent(new CustomEvent("custogifts:cart:open")));
  }
  async function Q() {
    const g = _e(),
      _ = n.value
        .filter((ie) => g.includes(ie.id))
        .map((ie) => ({ ...ie, artworkID: De(ie) })),
      z = await F.getOrPreview(S.value ?? "");
    let q;
    if (z && typeof z.json == "function")
      try {
        q = await z.json();
      } catch {
        q = z;
      }
    else q = z;
    const H = q?.url || q?.previewUrl,
      de = await Promise.all(
        _.map((ie) => F.saveCustomizationByVariant(u.value, ie)),
      ),
      me = j(),
      ve = de
        .filter(Boolean)
        .map((ie) => ({
          variantID: ie?.variant,
          "_custom-id": ie?.properties.id,
          "_custom-preview": H,
          "_custom-customization-url": F.getCustomizationUrl(),
          "_custom-production-url": ie?.properties["_custom-production-url"],
          ...(me ? { _ab_variant_id: me } : {}),
        })),
      be = T(ve);
    await E(be)
      .then((ie) => {
        if (!ie.ok) throw new Error("Network response was not ok");
        return ie.json();
      })
      .then(() => {
        ((S.value = Ce()), se());
      })
      .catch((ie) => {
        (console.log("Error:", ie), o.setLoadingATC(!1));
      });
  }
  async function re(g) {
    try {
      if (g) {
        const ce = await F.createOrder(),
          pe = {
            "_custom-id": ce.id,
            "_custom-preview": ce.previewUrl,
            "_custom-customization-url": F.getCustomizationUrl(),
            "_custom-production-url": ce["_custom-production-url"],
          },
          je = j();
        (je && (pe._ab_variant_id = je),
          await fetch(`${window.Shopify?.routes?.root}cart/change.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              line: document
                .querySelector(".slug-product")
                ?.getAttribute("data-index"),
              quantity: 0,
              sections: te().map((pt) => pt.section),
              sections_url: window.location.pathname,
            }),
          }),
          ce.print_files?.length &&
            (pe._print_area_id = ce.print_files[0]?.print_area_id));
        const jr = L(pe);
        await E(jr)
          .then((pt) => {
            if (!pt.ok) throw new Error("Network response was not ok");
            return pt.json();
          })
          .then(() => {
            ((S.value = Ce()), se());
          })
          .catch((pt) => {
            (console.log("Error:", pt), o.setLoadingATC(!1));
          });
        return;
      }
      let k;
      if (S.value) k = S.value;
      else {
        const ce = Ce();
        ((S.value = ce), (k = ce));
      }
      const _ =
          document
            .querySelector(".slug-product")
            ?.getAttribute("data-handle") ?? a.value?.handle,
        z = Mt(_, k),
        q = Ct(s.value, k),
        H = Ut(k),
        de = {
          "_custom-id": z,
          "_custom-preview": q,
          "_custom-customization-url": F.getCustomizationUrl(),
          "_custom-production-url": H,
        },
        me = j();
      (me && (de._ab_variant_id = me),
        C.value.length && (de._print_area_id = C.value[0]?.id));
      const ve = L(de);
      if (
        !(await Promise.all([
          F.getOrPreview(k),
          F.saveCustomization(u.value, c.value, t.selectedVariant, C.value),
          E(ve),
        ]).then((ce) => {
          const pe = ce.map((je) =>
            je && typeof je.json == "function"
              ? je.json()
              : Promise.resolve(void 0),
          );
          return Promise.all(pe);
        }))
      )
        throw new Error("error");
      const ie = U();
      (mobileCartAfterAdd() ? void 0 : r.value?.isAddToCartPopupVisible
        ? (o.setShowPreview(!1),
          t.setItemATC({
            previewUrl: q,
            previewBase64: ie,
            variant_id: t.selectedVariant,
            qty:
              parseInt(
                document?.querySelector(
                  "product-form form input[name='quantity']",
                )?.value,
              ) ?? 1,
          }),
          o.setLoadingATC(!1),
          await O(),
          t.setIsShowPopupATC(!0))
        : t.upsellProducts?.length > 0 && !m.value
          ? (t.setPropertiesUpsell(de), t.setIsShowUpsell(!0))
          : se(),
        (S.value = Ce()));
    } catch (k) {
      (St.error(k.message), o.setLoadingATC(!1));
    }
  }
  async function G() {
    try {
      let g;
      if (S.value) g = S.value;
      else {
        const ie = Ce();
        ((S.value = ie), (g = ie));
      }
      const k =
          document
            .querySelector(".slug-product")
            ?.getAttribute("data-handle") ?? a.value?.handle,
        _ = Mt(k, g),
        z = Ct(s.value, g),
        q = Ut(g),
        H = {
          "_custom-id": _,
          "_custom-preview": z,
          "_custom-customization-url": F.getCustomizationUrl(),
          "_custom-production-url": q,
        },
        de = j();
      (de && (H._ab_variant_id = de),
        C.value.length && (H._print_area_id = C.value[0]?.id));
      const me = L(H);
      if (
        !(await Promise.all([
          F.getOrPreview(g),
          F.saveCustomization(u.value, c.value, t.selectedVariant, C.value),
          E(me),
        ]).then((ie) => {
          const ce = ie.map((pe) =>
            pe && typeof pe.json == "function"
              ? pe.json()
              : Promise.resolve(void 0),
          );
          return Promise.all(ce);
        }))
      )
        throw new Error("error");
      const be = U();
      (mobileCartAfterAdd() ? void 0 : r.value?.isAddToCartPopupVisible
        ? (o.setShowPreview(!1),
          t.setItemATC({
            previewUrl: z,
            previewBase64: be,
            variant_id: t.selectedVariant,
            qty:
              parseInt(
                document?.querySelector(
                  "product-form form input[name='quantity']",
                )?.value,
              ) ?? 1,
          }),
          o.setLoadingATC(!1),
          await O(),
          t.setIsShowPopupATC(!0))
        : t.upsellProducts?.length > 0 && !m.value
          ? (t.setPropertiesUpsell(H), t.setIsShowUpsell(!0))
          : se(),
        (S.value = Ce()));
    } catch (g) {
      (console.log("Error:", g), o.setLoadingATC(!1));
    }
  }
  function fe() {
    const g = Dt();
    return g > 0 ? g : 1;
  }
  async function Ge() {
    try {
      let g;
      if (S.value) g = S.value;
      else {
        const ce = Ce();
        ((S.value = ce), (g = ce));
      }
      const k = fe(),
        _ =
          document
            .querySelector(".slug-product")
            ?.getAttribute("data-handle") ?? a.value?.handle,
        z = Mt(_, g),
        q = Ct(s.value, `${g}_pack_0`),
        H = {
          "_custom-id": z,
          "_custom-customization-url": F.getCustomizationUrl(),
          _custom_is_pack: !0,
        },
        de = j();
      de && (H._ab_variant_id = de);
      for (let ce = 0; ce < k; ce++) {
        const pe = `${g}_pack_${ce}`;
        ((H[`_custom-preview-${ce}`] = Ct(s.value, pe)),
          (H[`_custom-production-url-${ce}`] = Ut(pe)));
      }
      C.value.length && (H._print_area_id = C.value[0]?.id);
      const me = m.value
        ? [
            {
              id: Number(t.selectedVariant),
              form_type: "product",
              quantity: o.qty || 1,
              properties: H,
              "product-id": Number(a.value?.id),
              utf8: "✓",
            },
          ]
        : L(H);
      await Promise.all([F.uploadPackPreviews(g, k), E(me)]);
      const ve = await F.savePackCustomization(
        y.value,
        k,
        t.selectedVariant,
        C.value,
      );
      if (!(ve && typeof ve.json == "function" ? await ve.json() : ve))
        throw new Error("error");
      const ie = U();
      (mobileCartAfterAdd() ? void 0 : r.value?.isAddToCartPopupVisible
        ? (o.setShowPreview(!1),
          t.setItemATC({
            previewUrl: q,
            previewBase64: ie,
            variant_id: t.selectedVariant,
            qty:
              parseInt(
                document?.querySelector(
                  "product-form form input[name='quantity']",
                )?.value,
              ) ?? 1,
          }),
          o.setLoadingATC(!1),
          await O(),
          t.setIsShowPopupATC(!0))
        : t.upsellProducts?.length > 0 && !m.value
          ? (t.setPropertiesUpsell(H), t.setIsShowUpsell(!0))
          : se(),
        (S.value = Ce()));
    } catch (g) {
      (console.error("[addToCartPackMode] Error:", g),
        St.error(g.message || "Something went wrong"),
        o.setLoadingATC(!1));
    }
  }
  async function Re() {
    try {
      let g;
      if (S.value) g = S.value;
      else {
        const pe = Ce();
        ((S.value = pe), (g = pe));
      }
      const k = fe(),
        _ =
          document
            .querySelector(".slug-product")
            ?.getAttribute("data-handle") ?? a.value?.handle,
        q = {
          "_custom-id": Mt(_, g),
          "_custom-customization-url": F.getCustomizationUrl(),
          _custom_is_pack: !0,
        },
        H = j();
      H && (q._ab_variant_id = H);
      for (let pe = 0; pe < k; pe++) {
        const je = `${g}_pack_${pe}`;
        ((q[`_custom-preview-${pe}`] = Ct(s.value, je)),
          (q[`_custom-production-url-${pe}`] = Ut(je)));
      }
      (C.value.length && (q._print_area_id = C.value[0]?.id),
        await fetch(`${window.Shopify?.routes?.root}cart/change.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            line: document
              .querySelector(".slug-product")
              ?.getAttribute("data-index"),
            quantity: 0,
            sections: te().map((pe) => pe.section),
            sections_url: window.location.pathname,
          }),
        }),
        await F.uploadPackPreviews(g, k));
      const de = await F.savePackCustomization(
        y.value,
        k,
        t.selectedVariant,
        C.value,
      );
      if (!(de && typeof de.json == "function" ? await de.json() : de))
        throw new Error("error");
      const ve = t.selectedVariant,
        be = a.value?.id,
        ie = o.qty || 1,
        ce = [
          {
            id: Number(ve),
            form_type: "product",
            quantity: ie,
            properties: q,
            "product-id": Number(be),
            utf8: "✓",
          },
        ];
      await E(ce)
        .then((pe) => {
          if (!pe.ok) throw new Error("Network response was not ok");
          return pe.json();
        })
        .then(() => {
          ((S.value = Ce()), se());
        })
        .catch((pe) => {
          (console.log("Error:", pe), o.setLoadingATC(!1));
        });
    } catch (g) {
      (console.error("[updateCartPackMode] Error:", g),
        St.error(g.message || "Something went wrong"),
        o.setLoadingATC(!1));
    }
  }
  async function Pe(g, k) {
    if (
      (g.preventDefault(),
      g.stopPropagation(),
      o.setLoadingATC(!0),
      await zt(Y),
      !(await N()))
    )
      return (o.setLoadingATC(!1), !1);
    if (h.value === "shopify")
      return r.value?.isPackMode && fe() >= 1
        ? k
          ? Re()
          : Ge()
        : document.querySelector(".pack-selector.active") &&
            t.artworks?.length > 1
          ? Q()
          : k
            ? re(k)
            : G();
    o.setLoadingATC(!1);
  }
  async function Be(g) {
    if (
      (g.preventDefault(),
      g.stopPropagation(),
      o.setLoadingATC(!0),
      await zt(Y),
      !(await N()))
    )
      return (o.setLoadingATC(!1), !1);
    try {
      const { newPersonalized: _ } = await Eu();
      (typeof window.__AdminSubmitCallback == "function"
        ? window.__AdminSubmitCallback(_)
        : window.dispatchEvent(
            new CustomEvent("ADMIN_SUBMIT_DESIGN", { detail: _ }),
          ),
        o.setLoadingATC(!1));
    } catch (_) {
      (console.error(_),
        o.setLoadingATC(!1),
        St?.error?.(_.message || "Something went wrong"));
    }
  }
  async function ct(g) {
    await Pe(g, !0);
  }
  function Z() {
    document
      .querySelector(".modal-edit-cart-exit-confirm")
      ?.classList?.toggle("hidden");
  }
  function M(g, k) {
    const _ = document.querySelector(".notification-error");
    _ && _?.classList?.remove("hidden");
    const z = document.querySelector(".notification-text");
    (z && (z.textContent = g),
      k === "warning"
        ? _?.style &&
          ((_.style.backgroundColor = "#ffeddc"), (_.style.color = "#1b2631"))
        : _ &&
          ((_.style.backgroundColor = "#4faf9c"), (_.style.color = "#fff")),
      setTimeout(() => {
        _ && _.classList.add("hidden");
      }, 3e3));
  }
  async function W() {
    const g = "Please contact us email: ops@custfy.com";
    try {
      const k = await F.createOrder(),
        _ = document.querySelector(".slug-product"),
        z = new FormData();
      (z.append("custom_preview", k.previewUrl),
        z.append("line_item_id", _.getAttribute("data-line-item-id") || ""),
        z.append("customization_id", k.id),
        z.append("design_url", k["_custom-production-url"]),
        z.append(
          "customization-url",
          `${window.location.origin}/products/${_.getAttribute("data-handle")}`,
        ));
      const H = await fetch(
        "https://api.custfy.com/shopify/edit-design-order",
        { method: "POST", body: z },
      );
      if (!H.ok) {
        const de = await H.text();
        throw new Error(de || `HTTP error! status: ${H.status}`);
      }
      (M("Update successful", "success"),
        o.setLoadingATC(!1),
        location.reload());
    } catch (k) {
      (console.error(k),
        o.setLoadingATC(!1),
        M(g, "warning"),
        St?.error?.(k.message || "Something went wrong"));
    }
  }
  async function ke(g) {
    if (
      (g.preventDefault(),
      g.stopPropagation(),
      o.setLoadingATC(!0),
      await zt(Y),
      !(await N()))
    )
      return (o.setLoadingATC(!1), !1);
    if (h.value === "shopify") return W();
    o.setLoadingATC(!1);
  }
  async function Ae(g) {
    if (d.value) return;
    if ((g.preventDefault(), !(await N()))) {
      o.setShowPreview(!1);
      return;
    }
    (await zt(Y), o.setShowPreview(!0));
  }
  async function $e(g) {
    const k = document.getElementById("custom-btn-atc");
    if ((k && (k.disabled = !0), d.value)) return;
    if ((o.setLoadingATC(!0), !(await N()))) {
      (o.setLoadingATC(!1), k && (k.disabled = !1));
      return;
    }
    await Pe(g);
  }
  function qe() {
    if ((Y.on("submitATC", $e), h.value === "shopify")) {
      const g = document.querySelectorAll("#btn-preview, #btn-preview-desktop"),
        k = document.querySelector("#custom-btn-atc");
      (k?.classList.remove("ld-custom"),
        g.forEach((_) => {
          (_.classList.remove("ld-custom"), _.addEventListener("click", Ae));
        }),
        k?.addEventListener("click", $e));
    } else if (h.value === "lattehub")
      if (typeof window.beforeAddCart == "function")
        window.beforeAddCart(async () => await Pe(new Event("click")));
      else {
        const g = setInterval(() => {
          typeof window.beforeAddCart == "function" &&
            (window.beforeAddCart(async () => await Pe(new Event("click"))),
            clearInterval(g));
        }, 100);
      }
    S.value = Ce();
  }
  function Et() {
    if ((Y.off("submitATC", $e), h.value === "shopify")) {
      const g = document.querySelectorAll("#btn-preview, #btn-preview-desktop"),
        k = document.querySelector("#custom-btn-atc");
      (g.forEach((_) => {
        _.removeEventListener("click", Ae);
      }),
        k?.removeEventListener("click", $e));
    }
  }
  return {
    addToCart: Pe,
    updateDesign: ct,
    updateDesignOrder: ke,
    adminSubmitDesign: Be,
    closedEditDSOrder: Z,
    previewModalEvent: Ae,
    addToCartEvent: $e,
    handlePageShow: qe,
    handlePageHide: Et,
  };
}
const Vu = 1731744e6;
async function Mu(e) {
  try {
    return await (
      await fetch(`${Mi("VITE_CST_API")}/get-customization/${e}`, {
        headers: { "x-origin-secret": "b04181ca10255dc0c9ec01bbba99e3e5" },
      })
    ).json();
  } catch {
    return null;
  }
}
function Uu(e, t) {
  const { settings: o } = oe(),
    { formValues: i } = he();
  return t?.[e.id] ? t[e.id] : i?.[e.id] ? i[e.id] : Pt(o, e.id);
}
function zu(e, t) {
  const o = oe(),
    i = he(),
    r = o.UpdatedAt,
    n = !!t?.[e.id],
    a = i.formValues[e.id],
    u = Uu(e, t),
    d = B(u, "template", e.templates?.length == 1 ? 0 : null);
  if (n) {
    (i.setTemplateArtwork(u.template ?? 0),
      o.settings?.isPackMode ||
        i.replaceFormValues({ formID: e.id, values: { ...u } }));
    return;
  }
  if (a) {
    i.setIsInitializingForm(!0);
    const s = a.template ?? 0;
    if (e?.templates[s]?.layers) {
      const h = Ui(a),
        m = Ao(e, h, {}, o.clipartCategories || []);
      i.setPersonalized({ artworkID: e.id, data: m });
    }
    setTimeout(() => {
      i.setIsInitializingForm(!1);
    }, 1500);
    return;
  }
  if (
    (i.setIsInitializingForm(!0), r && new Date(r).getTime() > Vu && !xe(u))
  ) {
    i.setFormValues({ formID: e.id, values: { ...u, template: d } });
    const s = Ao(e, u, {}, o.clipartCategories || []);
    i.setPersonalized({ artworkID: e.id, data: s });
  } else i.setFormValues({ formID: e.id, values: { template: d } });
  setTimeout(() => {
    i.setIsInitializingForm(!1);
  }, 1500);
}
function Ou(e, t, o) {
  let i = null;
  if (t?.length === 1) i = t[0];
  else {
    const r = e?.variantOption;
    r?.length &&
      (i = t?.find(
        (n) =>
          (!r[0] || n.option1 == r[0].value) &&
          (!r[1] || n.option2 == r[1].value) &&
          (!r[2] || n.option3 == r[2].value),
      ));
  }
  i && (o.setSelectedVariant(i.origin_id), o.setSelectedVariantInfo({ ...i }));
}
function Nu() {
  const e = he(),
    t = Se(),
    o = oe();
  async function i(r, n) {
    let a = null;
    t.customKey &&
      ((a = await Mu(t.customKey)), a && (Ou(a, n, o), await mo()));
    const u = r();
    return (
      u && (zu(u, a), e.setLocalStorageTimestamp(Date.now())),
      { prevCustom: a }
    );
  }
  return { initArtworkForm: i };
}
const Ru = { key: 0, class: "add-to-cart-group" },
  Bu = ["disabled"],
  qu = { key: 0, class: "add-to-cart-group edit-cart" },
  ju = { class: "qty" },
  Ku = ["disabled"],
  Wu = ["disabled"],
  Hu = { class: "edit-cart-footer" },
  Yu = { key: 1, class: "add-to-cart-group track-order edit-cart" },
  Xu = ["disabled"],
  Qu = ["disabled"],
  Gu = { key: 2, class: "add-to-cart-group admin-edit-cart edit-cart" },
  Zu = ["disabled"],
  Ju = ne({
    __name: "Form",
    props: { storeKey: { default: "" }, viewMode: { default: "default" } },
    setup(e) {
      const t = Oi,
        o = oe(),
        i = he(),
        r = Se(),
        {
          settings: n,
          variants: a,
          selectedVariant: u,
          variantInfo: d,
        } = ee(o),
        { formValues: s, loadingATC: c } = ee(i),
        {
          platform: h,
          isEditDesign: m,
          isDesignTrackOrder: y,
          isAdminEdit: C,
        } = ee(r);
      Object.keys(i.formValues).length > 0 &&
        Object.keys(i.personalized).length === 0 &&
        i.setIsInitializingForm(!0);
      const S = Le(null),
        A = oi(null),
        Y = Le(null),
        N = Le(null),
        F = Le(null),
        U = Le(null),
        {
          artworkID: X,
          artwork: j,
          printAreas: we,
          defaultValueArtSettings: te,
        } = du(F);
      cu(c);
      const _e = Pu(X, we, Y, A),
        De = Fe(() => nr()),
        { isPackMode: Ne, packItemIds: x, initPackItemForms: R } = zi(X);
      wu(Nt);
      const L = ri();
      async function T() {
        try {
          const Z = L.proxy.$refs;
          if (Ne.value) {
            const M = Z.packArtworkForm;
            return M?.validatePack ? await M.validatePack() : !0;
          }
          for (const M in Z) {
            const W = Z[M];
            if (!W?.formRef?.validate) continue;
            if (!(await W.formRef.validate())) return ((S.value = M), !1);
          }
          return !0;
        } catch (Z) {
          console.log(Z);
          const M = document.querySelector(".ant-form-item-has-error");
          if (M) {
            const W = M.closest(".ant-form-item");
            if (W) {
              const ke = W.getBoundingClientRect().top + window.scrollY - 150;
              window.scrollTo({ top: ke, behavior: "smooth" });
            }
            M.focus();
          }
          return !1;
        }
      }
      const D = Tu({
          artworkID: X,
          printAreas: we,
          fileName: Y,
          canvas: A,
          artworkIdPack: F,
          emitter: Nt,
          validate: T,
          customization: _e,
        }),
        {
          addToCart: P,
          updateDesign: E,
          updateDesignOrder: O,
          adminSubmitDesign: se,
          closedEditDSOrder: Q,
          handlePageShow: re,
          handlePageHide: G,
        } = D;
      function fe(Z) {
        ((F.value = Z?.artworkID), (U.value = Z?.pack));
      }
      function Ge() {
        let Z,
          M =
            wt("variant") ||
            document.querySelector(".edit-design-cart-variant")?.value;
        (M && (Z = a.value?.find((W) => W.origin_id == M || W.id == M)),
          Z ||
            ((M = document.querySelector("product-form [name=id]")?.value),
            (Z = a.value?.find((W) => W.origin_id == M))),
          Z && (o.setSelectedVariantInfo(Z), o.setSelectedVariant(Z.origin_id)),
          (N.value = Z));
      }
      function Re(Z, M) {
        const W = s.value[Z];
        let ke = B(s.value, `${M}.template`, 0);
        j.value?.templates &&
          (ke > j.value?.templates?.length - 1 ||
            j.value?.templates?.length == 1) &&
          (ke = 0);
        const Ae = j.value?.templates[ke ?? 0],
          $e = Ae?.layers
            ? Ni(
                Ae.layers,
                s.value[Z] ?? te.value,
                { ...s.value[M], template: ke },
                o.clipartCategories,
              )
            : {},
          qe = s.value[M];
        (i.setPersonalized({ artworkID: Z, data: { ...W, ...$e } }),
          i.setFormValues({ formID: Z, values: { ...qe, template: ke } }));
      }
      const { initArtworkForm: Pe } = Nu(),
        Be = Le(!1),
        ct = Le(null);
      return (
        xo(async () => {
          if ((Ge(), await mo(), !Be.value)) {
            const Z = await Pe(() => j.value, a.value);
            ((ct.value = Z?.prevCustom), (Be.value = !0));
          }
          (Ne.value && j.value && R(j.value, ct.value),
            re(),
            m.value &&
              window.dispatchEvent(new CustomEvent(rt.SHOW_CANVAS_PREVIEW)));
        }),
        wo(() => {
          (G(), ku(Nt));
        }),
        window.addEventListener("pageshow", re),
        wo(() => window.removeEventListener("pageshow", re)),
        ft(u, (Z, M) => {
          N.value = M;
          const W = a.value.find((ke) => ke.origin_id == Z);
          if ((W && o.setSelectedVariantInfo(W), F.value && U.value)) {
            const Ae = n.value?.settingsPack
              ?.find(($e) => $e.pack == U.value)
              ?.options?.find(($e) => $e.variantID == Z);
            F.value = Ae?.artworkID;
          }
        }),
        ft(X, async (Z, M) => {
          if (!M) {
            if (!Be.value && j.value) {
              const W = await Pe(() => j.value, a.value);
              ((ct.value = W?.prevCustom),
                (Be.value = !0),
                Ne.value && j.value && R(j.value, ct.value));
            }
            return;
          }
          Re(Z, M);
        }),
        ft(we, (Z, M) => {
          Xt(Z, M) ||
            Z?.some((W, ke) => {
              if (W?.artwork_id)
                return ((S.value = `${W.artwork_id}-${ke}`), !0);
            });
        }),
        ft(
          d,
          (Z, M) => {
            let W = ["Size"];
            const ke = o?.settings?.customizedSkipFields;
            ke?.length && (W = ke);
            const Ae = Z.option,
              $e = M.option;
            if ($e != null) {
              for (let qe = 0; qe < Ae.length; qe++)
                if (!W.includes(Ae[qe].name)) {
                  const Et = $e.find((g) => g.name == Ae[qe].name)?.value;
                  if (Et && Et != Ae[qe].value) {
                    window.dispatchEvent(
                      new CustomEvent(rt.SHOW_CANVAS_PREVIEW),
                    );
                    return;
                  }
                }
            }
          },
          { deep: !0 },
        ),
        (Z, M) => (
          l(),
          p(
            I,
            null,
            [
              $(Na),
              b(n)?.settingsPack && b(n).settingsPack?.length > 0
                ? (l(), w(tn, { key: 0, onSendArtwork: fe }))
                : v("", !0),
              e.viewMode !== "compact"
                ? (l(),
                  p(
                    I,
                    { key: 1 },
                    [
                      (l(),
                      w(
                        tt,
                        { to: "#edit-cart-form", disabled: !b(m) },
                        [
                          b(Ne) && b(x).length > 0
                            ? (l(),
                              w(
                                uo,
                                {
                                  key: 0,
                                  artwork: b(j),
                                  ref: "packArtworkForm",
                                  value: b(s)[b(X)],
                                  packItemIds: b(x),
                                  packFormValues: b(s),
                                  showPreview: e.viewMode === "default",
                                  isDevEnv: b(De),
                                },
                                null,
                                8,
                                [
                                  "artwork",
                                  "value",
                                  "packItemIds",
                                  "packFormValues",
                                  "showPreview",
                                  "isDevEnv",
                                ],
                              ))
                            : b(we).length > 1
                              ? (l(),
                                w(
                                  uo,
                                  {
                                    key: b(X),
                                    artwork: b(j),
                                    ref: `${b(X)}`,
                                    value: b(s)[b(X)],
                                    showPreview: e.viewMode === "default",
                                    isDevEnv: b(De),
                                  },
                                  null,
                                  8,
                                  [
                                    "artwork",
                                    "value",
                                    "showPreview",
                                    "isDevEnv",
                                  ],
                                ))
                              : (l(),
                                p(
                                  I,
                                  { key: 2 },
                                  [
                                    b(we).length == 1
                                      ? (l(),
                                        w(
                                          uo,
                                          {
                                            key: 0,
                                            artwork: b(j),
                                            ref: `artwork_${b(X)}`,
                                            value: b(s)[b(X)],
                                            showPreview:
                                              e.viewMode === "default",
                                            isDevEnv: b(De),
                                          },
                                          null,
                                          8,
                                          [
                                            "artwork",
                                            "value",
                                            "showPreview",
                                            "isDevEnv",
                                          ],
                                        ))
                                      : v("", !0),
                                  ],
                                  64,
                                )),
                        ],
                        8,
                        ["disabled"],
                      )),
                      e.viewMode === "default" && b(De) && !b(m)
                        ? J(
                            (l(),
                            p(
                              "div",
                              Ru,
                              [
                                f("div", null, [$(Yo)]),
                                f(
                                  "button",
                                  {
                                    onClick:
                                      M[0] ||
                                      (M[0] = (...W) => b(P) && b(P)(...W)),
                                    class: le(
                                      `btn btn-primary btn-add-to-cart ${b(c) ? "ld-custom add-to-cart-loading" : ""}`,
                                    ),
                                    disabled: b(c),
                                  },
                                  [
                                    b(c)
                                      ? (l(), w(b(t), { key: 0 }))
                                      : v("", !0),
                                    M[6] || (M[6] = Ue(" Add to cart ", -1)),
                                  ],
                                  10,
                                  Bu,
                                ),
                              ],
                              512,
                            )),
                            [[Ie, b(h) !== "lattehub"]],
                          )
                        : v("", !0),
                      (l(),
                      w(
                        tt,
                        { to: "#atc-button-group", disabled: !b(m) },
                        [
                          e.viewMode === "default" && b(m) && !b(y) && !b(C)
                            ? J(
                                (l(),
                                p(
                                  "div",
                                  qu,
                                  [
                                    f("div", ju, [$(Yo)]),
                                    f(
                                      "div",
                                      {
                                        onClick:
                                          M[1] ||
                                          (M[1] = (...W) => b(E) && b(E)(...W)),
                                        class: le(
                                          `btn btn-primary btn-add-to-cart btn-edit-cart ${b(c) ? "ld-custom add-to-cart-loading" : ""}`,
                                        ),
                                        disabled: b(c),
                                      },
                                      " Save changes ",
                                      10,
                                      Ku,
                                    ),
                                    f(
                                      "div",
                                      {
                                        onClick:
                                          M[2] ||
                                          (M[2] = (...W) => b(P) && b(P)(...W)),
                                        class: le(
                                          `btn btn-primary btn-add-to-cart ${b(c) ? "ld-custom add-to-cart-loading" : ""}`,
                                        ),
                                        disabled: b(c),
                                      },
                                      [
                                        b(c)
                                          ? v("", !0)
                                          : (l(),
                                            w(dt, {
                                              key: 0,
                                              type: "preview-cart",
                                            })),
                                        M[7] ||
                                          (M[7] = Ue(" Add as new item ", -1)),
                                      ],
                                      10,
                                      Wu,
                                    ),
                                    f("div", Hu, [
                                      $(dt, { type: "info-circle" }),
                                      M[8] ||
                                        (M[8] = f(
                                          "p",
                                          { class: "edit-cart-footer__note" },
                                          [
                                            Ue("Note: "),
                                            f(
                                              "span",
                                              {
                                                class:
                                                  "edit-cart-footer__hightlight",
                                              },
                                              "Want to keep both versions?",
                                            ),
                                            Ue(' Use "Add as new item".'),
                                          ],
                                          -1,
                                        )),
                                    ]),
                                  ],
                                  512,
                                )),
                                [[Ie, b(h) !== "lattehub"]],
                              )
                            : v("", !0),
                          e.viewMode === "default" && b(m) && b(y)
                            ? J(
                                (l(),
                                p(
                                  "div",
                                  Yu,
                                  [
                                    f(
                                      "div",
                                      {
                                        onClick:
                                          M[3] ||
                                          (M[3] = (...W) => b(Q) && b(Q)(...W)),
                                        class: le(
                                          `btn btn-primary btn-add-to-cart btn-edit-cart ${b(c) ? "ld-custom add-to-cart-loading" : ""}`,
                                        ),
                                        disabled: b(c),
                                      },
                                      " Cancel ",
                                      10,
                                      Xu,
                                    ),
                                    f(
                                      "div",
                                      {
                                        onClick:
                                          M[4] ||
                                          (M[4] = (...W) => b(O) && b(O)(...W)),
                                        class: le(
                                          `btn btn-primary btn-add-to-cart ${b(c) ? "ld-custom add-to-cart-loading" : ""}`,
                                        ),
                                        disabled: b(c),
                                      },
                                      " Update Design ",
                                      10,
                                      Qu,
                                    ),
                                  ],
                                  512,
                                )),
                                [[Ie, b(h) !== "lattehub"]],
                              )
                            : v("", !0),
                          e.viewMode === "default" && b(C)
                            ? J(
                                (l(),
                                p(
                                  "div",
                                  Gu,
                                  [
                                    f(
                                      "div",
                                      {
                                        onClick:
                                          M[5] ||
                                          (M[5] = (...W) =>
                                            b(se) && b(se)(...W)),
                                        class: le(
                                          `btn btn-primary btn-add-to-cart btn-admin-submit ${b(c) ? "ld-custom add-to-cart-loading" : ""}`,
                                        ),
                                        disabled: b(c),
                                      },
                                      [
                                        b(c)
                                          ? (l(), w(b(t), { key: 0 }))
                                          : v("", !0),
                                        M[9] ||
                                          (M[9] = Ue(" Save Design ", -1)),
                                      ],
                                      10,
                                      Zu,
                                    ),
                                  ],
                                  512,
                                )),
                                [[Ie, b(h) !== "lattehub"]],
                              )
                            : v("", !0),
                        ],
                        8,
                        ["disabled"],
                      )),
                    ],
                    64,
                  ))
                : v("", !0),
            ],
            64,
          )
        )
      );
    },
  }),
  xu = ne({
    props: {
      mockup: { type: Object, required: !0 },
      loading: { type: Boolean },
    },
    setup() {
      const e = he(),
        { layerUploadSelect: t, personalized: o } = ee(e);
      return { formStore: e, layerUploadSelect: t, personalized: o };
    },
    data() {
      return { isShowModalConfirm: !1 };
    },
    computed: {
      isShowUploadController() {
        const { mockup: e } = this,
          {
            currentArtwork: t,
            templateArtwork: o,
            layerUploadSelect: i,
          } = this.formStore;
        return e?.layers
          ?.find((a) => a.type == "Group" && a.artworkID == t)
          ?.templates[o]?.layers?.find((a) => a.layerNumber == i.layerNumber)
          ? Object.keys(this.formStore.layerUploadSelect).length > 0
          : !1;
      },
    },
    methods: {
      incrementMoveImageX() {
        this.moveImage("upto", "x");
      },
      incrementMoveImageY() {
        this.moveImage("upto", "y");
      },
      decrementMoveImageX() {
        this.moveImage("down", "x");
      },
      decrementMoveImageY() {
        this.moveImage("down", "y");
      },
      incrementScaleImage() {
        this.scaleImage("upto");
      },
      decrementScaleImage() {
        this.scaleImage("down");
      },
      incrementRotationImage() {
        this.rotationImage("upto");
      },
      decrementRotationImage() {
        this.rotationImage("down");
      },
      toggleImage(e, t) {
        let o = 0.0025;
        (t === "rotation" && (o = 0.25),
          this.$emit("modified-layer", {
            type: t,
            value: e === "upto" ? o : -1 * o,
            id: "canvas",
          }));
      },
      scaleImage(e) {
        this.toggleImage(e, "scale");
      },
      rotationImage(e) {
        this.toggleImage(e, "rotation");
      },
      moveImage(e, t) {
        let o = "moveImageX";
        (t == "y" && (o = "moveImageY"),
          this.$emit("modified-layer", {
            type: o,
            value: e === "upto" ? -1 : 1,
            id: "canvas",
          }));
      },
      nextImage() {
        this.$emit("modified-layer", { type: "next-image" });
      },
    },
  }),
  ed = { key: 0, class: "upload-controller" },
  td = { class: "btn-action-canvas" },
  od = ["disabled"],
  rd = ["disabled"],
  id = ["disabled"],
  ad = ["disabled"],
  nd = ["disabled"],
  sd = ["disabled"];
function ld(e, t, o, i, r, n) {
  const a = dt,
    u = ii("longpress");
  return e.isShowUploadController
    ? (l(),
      p("div", ed, [
        f("div", td, [
          f(
            "div",
            {
              title: "Next image",
              class: "btn-vector sf-btn-icon-m next-btn",
              onClick:
                t[0] || (t[0] = (...d) => e.nextImage && e.nextImage(...d)),
              onContextmenu: t[1] || (t[1] = Go(() => {}, ["stop", "prevent"])),
            },
            [$(a, { type: "duplicate" })],
            32,
          ),
          J(
            (l(),
            p(
              "div",
              {
                title: "Scale up",
                class: "btn-vector sf-btn-icon-m",
                onClick: t[2] || (t[2] = (d) => e.scaleImage("upto")),
              },
              [$(a, { type: "guide-zoom-in" })],
            )),
            [[u, e.incrementScaleImage]],
          ),
          J(
            (l(),
            p(
              "div",
              {
                title: "Scale up",
                class: "btn-vector sf-btn-icon-m",
                onClick: t[3] || (t[3] = (d) => e.scaleImage("down")),
              },
              [$(a, { type: "guide-zoom-out" })],
            )),
            [[u, e.decrementScaleImage]],
          ),
          J(
            (l(),
            p(
              "div",
              {
                disabled: e.isShowModalConfirm || e.loading,
                title: "Rotation down",
                class: "btn-vector sf-btn-icon-m",
                onClick: t[4] || (t[4] = (d) => e.rotationImage("down")),
              },
              [$(a, { type: "guide-rotate-left" })],
              8,
              od,
            )),
            [[u, e.decrementRotationImage]],
          ),
          J(
            (l(),
            p(
              "div",
              {
                disabled: e.isShowModalConfirm || e.loading,
                title: "Rotation up",
                class: "btn-vector sf-btn-icon-m",
                onClick: t[5] || (t[5] = (d) => e.rotationImage("upto")),
              },
              [$(a, { type: "guide-rotate-right" })],
              8,
              rd,
            )),
            [[u, e.incrementRotationImage]],
          ),
          J(
            (l(),
            p(
              "div",
              {
                disabled: e.isShowModalConfirm || e.loading,
                class: "btn-vector sf-btn-icon-m first",
                onClick: t[6] || (t[6] = (d) => e.moveImage("upto", "y")),
              },
              [$(a, { type: "guide-arrow-up" })],
              8,
              id,
            )),
            [[u, e.incrementMoveImageY]],
          ),
          J(
            (l(),
            p(
              "div",
              {
                disabled: e.isShowModalConfirm || e.loading,
                key: "downY",
                class: "btn-vector sf-btn-icon-m",
                onClick: t[7] || (t[7] = (d) => e.moveImage("down", "y")),
              },
              [$(a, { type: "guide-arrow-down" })],
              8,
              ad,
            )),
            [[u, e.decrementMoveImageY]],
          ),
          J(
            (l(),
            p(
              "div",
              {
                disabled: e.isShowModalConfirm || e.loading,
                key: "uptoX",
                class: "btn-vector sf-btn-icon-m",
                onClick: t[8] || (t[8] = (d) => e.moveImage("upto", "x")),
              },
              [$(a, { type: "guide-arrow-right" })],
              8,
              nd,
            )),
            [[u, e.incrementMoveImageX]],
          ),
          J(
            (l(),
            p(
              "div",
              {
                disabled: e.isShowModalConfirm || e.loading,
                key: "downx",
                class: "btn-vector sf-btn-icon-m",
                onClick: t[9] || (t[9] = (d) => e.moveImage("down", "x")),
              },
              [$(a, { type: "guide-arrow-left" })],
              8,
              sd,
            )),
            [[u, e.decrementMoveImageX]],
          ),
        ]),
      ]))
    : v("", !0);
}
const Br = K(xu, [["render", ld]]),
  ud = ye(() =>
    ge(
      () => import("./modals.js?v=1-0-2-28d679f1").then((e) => e.aE),
      __vite__mapDeps([1, 2, 3, 4]),
      import.meta.url,
    ),
  ),
  dd = ne({
    components: {
      ModalImageUpload: ud,
      MainUploadAction: Br,
      "a-progress": er,
    },
    props: {
      dots: {
        type: Boolean,
        default() {
          return !0;
        },
      },
      defaultSlide: {
        type: Number,
        default() {
          return 0;
        },
      },
      width: { type: Number },
      storeKey: { type: String, required: !0 },
    },
    data() {
      return {
        windowWidth: window.innerWidth,
        affixOffsetTop: 0,
        loading: !1,
        canvas: null,
        isShowModalConfirm: !1,
        timeOutEditImageUpload: {},
        progress: 0,
      };
    },
    setup() {
      const e = oe(),
        t = he(),
        { selectedVariant: o, settings: i } = ee(e),
        r = Fe(() => !!i.value?.isPackMode);
      return {
        productStore: e,
        formStore: t,
        selectedVariant: o,
        isPackMode: r,
      };
    },
    computed: {
      mockup() {
        const { mockups: e, selectedVariant: t } = this.productStore;
        return e.length == 1
          ? e[0]
          : e.find((o) => o.layers?.find((i) => i.variantID == t));
      },
    },
    methods: {
      saveImageUploadWatcher(e) {
        const t = e.get("layerNumber");
        (clearTimeout(this.timeOutEditImageUpload?.[t]),
          (this.timeOutEditImageUpload[t] = setTimeout(() => {
            this.saveImageUpload(e);
          }, 400)));
      },
      saveImageUpload(e) {
        this.formStore.setLayersUploadEditMode(e);
        const t = e.get("layerNumber");
        this.$emitter.emit(`saveInputFormUpload-${t}`, {
          layerNumber: t,
          target: e,
        });
      },
      modifiedCanvas(e) {
        const { target: t } = e;
        t?.clipPath && this.saveImageUploadWatcher(t);
      },
      modifiedLayer(e) {
        this.$refs.mainMockupRef.handlerEvent(e);
      },
      goToFirstRenderMockup() {
        const { productImages: e } = this.productStore,
          { currentArtwork: t } = this.formStore;
        e.some((o, i) => {
          if ((o.artwork_ids || []).includes(t))
            return (this.productStore.setCurrentSlide(i), !0);
        });
      },
      getImageURL: lr,
      thumbnailClick(e) {
        this.productStore.setCurrentSlide(e);
      },
      prev() {
        const { productImages: e, currentSlide: t } = this.productStore;
        t > 0
          ? this.productStore.setCurrentSlide(t - 1)
          : this.productStore.setCurrentSlide(e.length - 1);
      },
      next() {
        const { productImages: e, currentSlide: t } = this.productStore;
        t < e.length - 1
          ? this.productStore.setCurrentSlide(t + 1)
          : this.productStore.setCurrentSlide(0);
      },
      getThumbnailImage(e) {
        const { selectedVariant: t, productImages: o } = this.productStore;
        return o[e].images.get(`${t}`) || o[e].images.get("default");
      },
      afterChange(e) {
        this.productStore.setCurrentSlide(e);
      },
    },
  }),
  cd = { class: "canvas-wrapper" },
  pd = ["variants"],
  md = { key: 0, class: "modal-progress" },
  fd = { key: 1, class: "background-error" };
function hd(e, t, o, i, r, n) {
  const a = Ri,
    u = Br,
    d = er,
    s = ut("ModalImageUpload");
  return (
    l(),
    p(
      I,
      null,
      [
        f("div", cd, [
          f(
            "div",
            { class: "is-render product-mockup", variants: e.selectedVariant },
            [
              e.mockup
                ? (l(),
                  w(
                    a,
                    {
                      key: 0,
                      mockup: e.mockup,
                      ref: "mainMockupRef",
                      storeKey: e.storeKey,
                      isPopupModal: !1,
                      onModifiedCanvas: e.modifiedCanvas,
                    },
                    null,
                    8,
                    ["mockup", "storeKey", "onModifiedCanvas"],
                  ))
                : v("", !0),
              e.mockup
                ? (l(),
                  w(
                    u,
                    {
                      key: 1,
                      mockup: e.mockup,
                      onModifiedLayer: e.modifiedLayer,
                    },
                    null,
                    8,
                    ["mockup", "onModifiedLayer"],
                  ))
                : v("", !0),
            ],
            8,
            pd,
          ),
        ]),
        e.progress != 0
          ? (l(),
            p("div", md, [
              $(
                d,
                {
                  type: "circle",
                  "stroke-color": { "0%": "#fb6413", "100%": "#fb6413" },
                  percent: e.progress,
                },
                null,
                8,
                ["percent"],
              ),
              t[0] || (t[0] = f("h2", null, "Generating, please wait...", -1)),
              t[1] ||
                (t[1] = f(
                  "p",
                  { class: "content-err" },
                  "Usually takes 1 to 2 minutes.",
                  -1,
                )),
            ]))
          : v("", !0),
        e.progress != 0 ? (l(), p("div", fd)) : v("", !0),
        (l(),
        w(tt, { to: "body" }, [
          e.formStore.showUploadModal
            ? (l(),
              w(
                s,
                { loading: e.loading, mockup: e.mockup, key: "modal" },
                null,
                8,
                ["loading", "mockup"],
              ))
            : v("", !0),
        ])),
      ],
      64,
    )
  );
}
const qr = K(dd, [["render", hd]]),
  yd = {
    components: { ProductImages: qr },
    props: { storeKey: { type: String, required: !0 } },
    data() {
      return { windowWidth: window.innerWidth, affixWidth: 0 };
    },
    mounted() {
      ((this.affixWidth = this.$refs.productImages.clientWidth),
        this.$nextTick(() => {
          ((this.affixWidth = this.$refs.productImages.clientWidth),
            window.addEventListener("resize", this.onResize));
        }));
    },
    beforeUnmount() {
      window.removeEventListener("resize", this.onResize);
    },
    methods: {
      onResize() {
        ((this.windowWidth = window.innerWidth),
          (this.affixWidth = this.$refs.productImages.clientWidth));
      },
    },
    computed: {
      isDev() {
        return nr();
      },
    },
  },
  gd = { ref: "productImages", style: { height: "100%" } };
function vd(e, t, o, i, r, n) {
  const a = qr;
  return (
    l(),
    p(
      "div",
      gd,
      [
        f(
          "div",
          {
            style: st({
              width: `${r.affixWidth}px`,
              top: n.isDev ? 0 : void 0,
            }),
            class: "ant-affix",
          },
          [
            $(a, { storeKey: o.storeKey, key: "mockup-preview" }, null, 8, [
              "storeKey",
            ]),
          ],
          4,
        ),
      ],
      512,
    )
  );
}
const wd = K(yd, [["render", vd]]);
let Ze = null,
  Je = null;
function kd(e) {
  e &&
    (Ze && Ze.remove(),
    (Ze = document.createElement("style")),
    Ze.setAttribute("data-custom", "store-settings"),
    (Ze.textContent = e),
    document.head.appendChild(Ze));
}
function bd(e) {
  e &&
    (Je && Je.remove(),
    (Je = document.createElement("script")),
    Je.setAttribute("data-custom", "store-settings"),
    (Je.textContent = e),
    document.body.appendChild(Je));
}
function Sd() {
  (Ze?.remove(), Je?.remove(), (Ze = null), (Je = null));
}
const Cd = ne({
    __name: "App",
    props: {
      storeName: {},
      product: {},
      artworkEl: {},
      formEl: {},
      viewMode: {},
      editDesign: { type: Boolean },
      customKey: {},
      isDesignTrackOrder: { type: Boolean },
      isAdminEdit: { type: Boolean },
    },
    setup(e) {
      const t = ye(() =>
          ge(
            () => import("./Preview.js?v=1-0-2-28d679f1"),
            __vite__mapDeps([27, 28, 1, 2, 3, 4]),
            import.meta.url,
          ),
        ),
        o = ye(() =>
          ge(
            () => import("./ModalUpsell.js?v=1-0-2-28d679f1"),
            __vite__mapDeps([29, 1, 2, 3, 4]),
            import.meta.url,
          ),
        ),
        i = ye(() =>
          ge(
            () => import("./PopupATC.js?v=1-0-2-28d679f1"),
            __vite__mapDeps([30, 28, 1, 2, 3, 4]),
            import.meta.url,
          ),
        ),
        r = oe(),
        n = Se(),
        a = he(),
        u = Ft(),
        d = Bi();
      (n.setSessionID(d), u.setIsLowDevice(qi()));
      const s = e,
        c = s.product,
        h = Le(null),
        m = Le(!1),
        y = async (A) => {
          try {
            const F = await (
              await fetch(
                `https://api.custfy.com/custom/stores/${A}/settings.json`,
              )
            ).json();
            return (
              F?.customCSS && kd(F.customCSS),
              F?.customJS && bd(F.customJS),
              F
            );
          } catch (Y) {
            return (
              console.warn("Failed to fetch store settings, using defaults", Y),
              {}
            );
          }
        },
        C = async () => {
          const A = wt("store", s.storeName);
          let Y = window.location.href.split("/products/")[1]?.split("?")[0];
          s?.editDesign &&
            (Y = document
              .querySelector(".slug-product")
              ?.getAttribute("data-handle"));
          let N = "https://api.custfy.com/custom";
          if (
            (window &&
              window.location.href.includes(".shopifypreview.com") &&
              (N = "https://api.custfy.com/custom"),
            y(A),
            c)
          ) {
            const X = await fetch(`${N}/${A}/${c.handle}.json?v=20250401`).then(
              (j) => j.json(),
            );
            ((h.value = X), (h.value.product = c));
          } else {
            const X = `${N}/${A}/${Y}.json?v=2.0.48`,
              j = [`https://${A}/products/${Y}.json?v=202408358`, X],
              we = await Promise.all(j.map((te) => fetch(te))).then((te) =>
                Promise.all(te.map((_e) => _e.json())),
              );
            ((h.value = we[1]), (h.value.product = we[0].product));
          }
          if (h.value?.upSells) {
            const X = h.value?.upSells
              ?.filter((te) => te)
              ?.map((te) => te?.product?.slug);
            let j = await Promise.all(
              X.map((te) => fetch(`https://${A}/products/${te}.json`)),
            ).then((te) => Promise.all(te.map((_e) => _e.json())));
            const we = h.value?.upSells;
            ((j = j?.map((te) => {
              const _e = we?.find(
                (De) => De?.product?.slug == te?.product?.handle,
              );
              return {
                title: te?.product?.title,
                variants: Fo(te?.product),
                image: te?.product?.images[0]?.src,
                price: te?.product?.variants[0]?.price,
                slug: te?.product?.handle,
                options: te?.product?.options,
                productID: te?.product?.id,
                variantSelected: te?.product?.variants[0]?.id,
                qty: 1,
                checked: !0,
                product_type: te?.product?.product_type,
                settings: _e?.settings?.settingsArtwork,
                printAreas: _e?.printAreas?.map((De) => ({
                  ...De,
                  artwork_id: De?.artworkId,
                })),
              };
            })),
              (h.value.upsellProducts = j));
          }
          (console.banner("1.0.2"), (m.value = !0));
          const F = Le({
              storeSettings: {
                displayMode: {
                  enableColor: !0,
                  optionStyle: "Selectable boxes",
                  swatchShape: "circle",
                },
              },
              storeStatus: !0,
            }),
            U = h.value;
          if (h.value) {
            const X = Fo(U?.product, U?.printAreas);
            if (
              (r.setStoreSettings(F.value.storeSettings),
              r.setUpsellProducts(U?.upsellProducts || []),
              r.setArtworks(U.artworks),
              r.setProduct(U.product),
              r.setVariants(X),
              r.setCampaignDate(U.updated_at),
              U?.storeConfigs?.settings?.isAddToCartPopupVisible &&
                (U.settings.isAddToCartPopupVisible = !0),
              r.setSettings(U.settings),
              r.setMockups(U.mockups),
              r.setClipartCategories(U.clipartCategories),
              s?.editDesign && n.setIsEditDesign(!0),
              s?.isDesignTrackOrder && n.setIsEditDesignOrder(!0),
              s?.isAdminEdit && n.setIsAdminEdit(!0),
              n.setStoreName(A),
              n.setPlatform(U.platform || "shopify"),
              s?.customKey)
            ) {
              n.setCustomKey(s.customKey);
              const j = document.querySelector(
                ".edit-design-cart-quantity",
              )?.value;
              j && a.setQty(+j);
            }
            a.setLocalStorageTimestamp(Date.now());
          }
        },
        S = () => {
          (document
            .querySelector("#artwork-preview")
            ?.classList.remove("hidden-mockup"),
            document
              .querySelector("#artwork-preview-fallback")
              ?.classList.add("hidden"),
            document
              .querySelector(
                ".product__column-sticky[data-desktop-layout='thumbnail_slider']",
              )
              ?.classList.add("hidden"));
        };
      return (
        xo(() => {
          (window.addEventListener(rt.SHOW_CANVAS_PREVIEW, S), C());
        }),
        (A, Y) =>
          b(m)
            ? (l(),
              w(
                b(ni),
                { key: 0, "hash-priority": "high" },
                {
                  default: ue(() => [
                    $(
                      b(ai),
                      { theme: { hashed: !1 } },
                      {
                        default: ue(() => [
                          (l(),
                          w(tt, { to: "body" }, [
                            $(b(t)),
                            b(r)?.isShowUpsell &&
                            b(r)?.upsellProducts?.length > 0
                              ? (l(), w(b(o), { key: 0 }))
                              : v("", !0),
                            b(r)?.isShowPopupATC
                              ? (l(), w(b(i), { key: 1 }))
                              : v("", !0),
                          ])),
                          (l(),
                          w(
                            tt,
                            { to: e.artworkEl },
                            [
                              $(wd, { storeKey: b(n).storeName }, null, 8, [
                                "storeKey",
                              ]),
                            ],
                            8,
                            ["to"],
                          )),
                          (l(),
                          w(
                            tt,
                            { to: e.formEl },
                            [
                              b(h)
                                ? (l(),
                                  w(
                                    Ju,
                                    {
                                      key: 0,
                                      viewMode: e.viewMode,
                                      storeKey: b(n).storeName,
                                    },
                                    null,
                                    8,
                                    ["viewMode", "storeKey"],
                                  ))
                                : v("", !0),
                            ],
                            8,
                            ["to"],
                          )),
                        ]),
                        _: 1,
                      },
                    ),
                  ]),
                  _: 1,
                },
              ))
            : v("", !0)
      );
    },
  }),
  Qo = "https://art.custfy.com",
  Id = "https://art.custfy.com";
document.addEventListener(
  "error",
  function (e) {
    const t = e.target;
    t.tagName === "IMG" &&
      t.src.includes(Qo) &&
      !t.dataset.fb &&
      ((t.dataset.fb = "1"), (t.src = t.src.replace(Qo, Id)));
  },
  !0,
);
let at;
const _d = () => ({
    beforeMount(e, t) {
      if (typeof t.value != "function") {
        console.warn(`Expect a function, got ${t.value}`);
        return;
      }
      let o = null;
      const i = (a) => {
          (a.type === "click" && a.button !== 0) ||
            (o === null && (o = setInterval(() => t.value(a), 50)));
        },
        r = () => {
          o !== null && (clearInterval(o), (o = null));
        },
        n = {
          start: ["mousedown", "touchstart"],
          cancel: ["click", "mouseup", "mouseout", "touchend", "touchcancel"],
        };
      (n.start.forEach((a) => e.addEventListener(a, i)),
        n.cancel.forEach((a) => e.addEventListener(a, r)),
        (e.__longpress__ = { start: i, cancel: r, events: n }));
    },
    beforeUnmount(e) {
      if (e.__longpress__) {
        const { start: t, cancel: o, events: i } = e.__longpress__;
        (i.start.forEach((r) => e.removeEventListener(r, t)),
          i.cancel.forEach((r) => e.removeEventListener(r, o)),
          delete e.__longpress__);
      }
    },
  }),
  vo = (e) => {
    const {
      storeName: t,
      product: o,
      artworkEl: i,
      formEl: r,
      viewMode: n = "default",
      editDesign: a,
      customKey: u,
      isDesignTrackOrder: d,
      isAdminEdit: s,
    } = e;
    ((at = si(Cd, {
      storeName: t,
      product: o,
      artworkEl: i,
      formEl: r,
      viewMode: n,
      editDesign: a,
      customKey: u,
      isDesignTrackOrder: d,
      isAdminEdit: s,
    })),
      at.directive("longpress", _d()),
      (at.config.globalProperties.$emitter = Nt));
    const c = li();
    (a ||
      (Eo("__persisted__", 7 * 24),
      oa() && Eo("__persisted__", 12),
      c.use(ui({ key: (y) => `__persisted__${y}` }))),
      at.use(c),
      (window.__FONTS = {}),
      (window.__layerUpload = {}),
      (window.renderDesign = Lu),
      (window.renderPreview = Fu));
    const h = document.createElement("div");
    return (at.mount(h), at);
  };
window.__InitApp = (e, t, o, i, r) =>
  vo({ storeName: e, product: t, artworkEl: o, formEl: i, viewMode: r });
window.__UnmountApp = () => {
  (ji(), Sd(), delete window.__AdminSubmitCallback, at.unmount());
};
window.__EditDesign = (e, t, o, i, r, n, a) =>
  vo({
    storeName: e,
    product: t,
    artworkEl: o,
    formEl: i,
    viewMode: r,
    editDesign: !0,
    customKey: n,
    isDesignTrackOrder: a,
  });
window.__AdminEditDesign = (e, t, o, i, r, n, a, u) => (
  u ? (window.__AdminSubmitCallback = u) : delete window.__AdminSubmitCallback,
  vo({
    storeName: e,
    product: t,
    artworkEl: o,
    formEl: i,
    viewMode: r,
    editDesign: !0,
    customKey: n,
    isDesignTrackOrder: a,
    isAdminEdit: !0,
  })
);
export {
  Od as A,
  Nd as B,
  Md as C,
  Ud as D,
  Td as E,
  Vd as F,
  us as I,
  eo as _,
  lr as a,
  Fd as b,
  ht as c,
  nt as d,
  Dr as e,
  Ed as f,
  Vr as g,
  Ld as h,
  Qe as i,
  _r as j,
  kt as k,
  Tr as l,
  bt as m,
  Ft as n,
  fo as o,
  Ir as p,
  Vt as q,
  hr as r,
  Mr as s,
  mt as t,
  He as u,
  ts as v,
  os as w,
  as as x,
  Sr as y,
  zd as z,
};
